/**
 * @generated — non modificare a mano: `npm run i18n:pull`
 *
 * Fallback inglese compilato nel bundle. Le traduzioni vive stanno a database e
 * arrivano da `GET /labels/translations/{iso}`; questo file esiste solo perché al
 * primissimo avvio, o con l'API irraggiungibile, l'interfaccia sia in inglese
 * invece di mostrare chiavi grezze.
 *
 * Per cambiare una stringa si usa il pannello (Admin → Label), non questo file:
 * una modifica qui verrebbe sovrascritta alla prossima rigenerazione.
 */
export default {
  admin: {
    cache: {
      clearAll: 'Clear everything',
      cleared: 'Cache cleared: {tag}.',
      clearedAll: 'Whole cache cleared.',
      disabled:
        'The configured store ({store}) does not support tags, so caching is off and these buttons do nothing here.',
      reload: 'Reload',
      subtitle:
        'Clear one family of cached values, or all of them. Useful after editing data straight in the database.',
      tags: {
        settings: 'Settings',
      },
      title: 'Backend cache',
    },
    discord: {
      create: 'New event',
      deleteConfirmHint:
        '{count} group(s) already configured a channel for this event: their configuration will be lost too.',
      deleteConfirmTitle: 'Remove this event?',
      deleted: 'Discord event removed.',
      empty: 'No event configured yet.',
      filterPlaceholder: 'Search by name or key…',
      form: {
        createTitle: 'New Discord event',
        editTitle: 'Edit Discord event',
        emptyHint: "An empty name for a language deletes that language's translation.",
        key: 'Key',
        keyHint:
          'Stable identifier used by the code that triggers this event — cannot be changed once created.',
        keyInvalid: 'Use only letters, numbers, - and _.',
        nameRequired: 'Enter a name in at least one language.',
      },
      saved: 'Discord event saved.',
      subtitle:
        'Events that can trigger a Discord notification. Groups only pick a channel and role for the events listed here.',
      title: 'Discord events',
      usedByGroups: 'Used by groups',
    },
    extensionLinks: {
      chromePlaceholder: 'https://chromewebstore.google.com/detail/…',
      firefoxPlaceholder: 'https://addons.mozilla.org/firefox/addon/…',
      hint: 'Download links shown as cards in the Browser extension box of the Profile. Leave a field empty to hide its card.',
      invalidUrl: 'Each link must start with http:// or https://.',
      saved: 'Extension links saved.',
      title: 'Browser extension',
    },
    groups: {
      columns: {
        members: 'Members',
      },
      confirmDeleteHint: 'Members and alliance links go with them; players and users stay.',
      confirmDeleteMany: '{count} groups will be removed.',
      confirmDeleteTitle: 'Delete groups?',
      create: 'New group',
      deleted: 'Groups deleted.',
      detail: {
        addAlliance: 'Add an alliance',
        addMember: 'Add a member',
        addMemberHint:
          'No invite key, no application: pick the user and the character to sign them up with. If they have not claimed it yet, it is claimed for them.',
        alliancePlaceholder: 'Alliance tag…',
        alliances: 'Alliances ({count})',
        filterMembers: 'Filter members…',
        inviteKey: 'Invite key',
        keyCopied: 'Invite key copied.',
        keyCopyFailed: 'Could not copy it: select it by hand.',
        keyRegenerated: 'New invite key generated.',
        memberAdded: 'Member added.',
        members: 'Members ({count})',
        noAlliances: 'No alliance linked.',
        noMemberMatches: 'No member matches the filter.',
        noMembers: 'No member yet.',
        noPlayer: 'no character',
        player: 'Character',
        playerPlaceholder: 'Character alias…',
        players: '{count} players',
        regenerateHint: 'The old key stops working immediately.',
        removeAlliance: 'Remove the alliance {tag}',
        removeMember: 'Remove {name} from the group',
        userPlaceholder: 'Name or email…',
      },
      empty: 'No group matches these filters.',
      filters: {
        anyServer: 'Any server',
        createdFrom: 'Created from',
        createdTo: 'Created to',
      },
      form: {
        createSubtitle: 'Members and alliances are added from the detail.',
        createTitle: 'New group',
        editSubtitle: 'Name, world and state of the confederation.',
        editTitle: 'Edit group',
        noMembersNote: 'The group is created empty: you add members from the detail.',
        serverHint: 'Moving a group to another world leaves its members on the old one.',
        serverRequired: 'Pick a server.',
      },
      rolesShort: {
        admin: 'Adm',
        def: 'Def',
        off: 'Off',
      },
      saved: 'Group saved.',
      subtitle: '{count} confederations.',
    },
    home: {
      registrations: 'Registrations, last 14 days',
      sections: {
        users: 'Accounts',
        world: 'Groups, servers and game data',
      },
      subtitle: 'The state of the platform at a glance.',
      title: 'Admin home',
    },
    jobs: {
      columns: {
        actions: 'Actions',
        enabled: 'Enabled',
        job: 'Job',
        lastRun: 'Last run',
        outcome: 'Last outcome',
        schedule: 'Schedule',
      },
      details: {
        countFailed: '{count} failed',
        countPending: '{count} still queued',
        countSkipped: '{count} skipped',
        countSuccess: '{count} succeeded',
        empty: 'No import run recorded yet.',
        finished: 'Finished',
        started: 'Started',
        stats: {
          active_players_total: 'Active players',
          alliances_total: 'Alliances',
          conquered_villages: 'Conquered villages',
          deleted_players: 'Removed players',
          new_alliances: 'New alliances',
          new_players: 'New players',
          removed_alliances: 'Removed alliances',
          updated_players: 'Updated players',
          villages_total: 'Villages',
          zeroed_villages: 'Zeroed villages',
        },
        status: {
          failed: 'Failed',
          skipped: 'Skipped',
          success: 'OK',
        },
        toggle: 'Servers',
      },
      disabled: "“{label}” disabled: it will not run automatically until it's turned back on.",
      empty: 'No scheduled job found.',
      enabled: '“{label}” enabled: it will run on schedule again.',
      finishedAt: 'Finished {date}',
      neverRun: 'Never run yet',
      run: 'Run now',
      runAria: 'Run “{label}” now',
      runConfirmBody:
        '“{label}” will start right away, even if it is disabled. Queued jobs report their outcome when the worker has run them: refresh the page to see it.',
      runConfirmRunning:
        'The last run looks still in progress: starting another one queues it after the current one.',
      runConfirmTitle: 'Run the job now?',
      runFailed: '“{label}” failed: see the outcome column for the reason.',
      runStarted: '“{label}” started.',
      status: {
        failed: 'Failed',
        partial: 'Partly failed',
        running: 'Running',
        success: 'Succeeded',
      },
      subtitle:
        'Enable or disable the automatic run of each job, see how its last run went and run it again by hand. A manual run works even when the job is disabled.',
      title: 'Scheduled jobs',
    },
    labels: {
      columns: {
        name: 'Key',
        updated: 'Updated',
      },
      confirmDeleteMany: '{count} labels and all their translations will be deleted.',
      confirmDeleteOne: 'The label "{label}" and all its translations will be deleted.',
      confirmDeleteTitle: 'Delete label?',
      count: '{count} labels.',
      create: 'New label',
      deleted: 'Label deleted.',
      empty: 'No label matches these filters.',
      export: 'Export',
      exportFailed: 'The sheet could not be downloaded.',
      filters: {
        anyLanguage: 'Any language',
        missingIn: 'Missing in',
        name: 'Key',
      },
      form: {
        createTitle: 'New label',
        editTitle: 'Edit label',
        emptyHint: 'An empty field means the label has no translation in that language yet.',
        nameHint: 'Dotted key, for example admin.servers.columns.name',
        subtitle: 'The key is what the interface asks for; the translations are what it shows.',
      },
      import: 'Import',
      importDialog: {
        done: 'Import completed.',
        file: 'Sheet',
        result: {
          blanked: 'Translations cleared',
          created: 'Translations added',
          deleted: 'Translations removed',
          labelsCreated: 'Labels created',
          rows: 'Rows read',
          skipped: 'Rows skipped',
          unchanged: 'Unchanged',
          updated: 'Translations changed',
        },
        ruleEmptyCell: 'An empty cell clears the translation it had.',
        ruleEmptyName: 'A row with no key is skipped.',
        ruleMissingColumn: 'A language whose column is not in the sheet is left untouched.',
        ruleUnderscore: 'A cell containing _ removes the translation altogether.',
        subtitle: 'The sheet needs "name" as its first column and one column per language code.',
        title: 'Import translations',
        unknownLanguages: 'Columns ignored, no such language: {list}.',
      },
      languages: {
        columns: {
          active: 'Published',
          flag: 'Flag',
          iso: 'Code',
        },
        confirmDeleteHint: 'Every translation written in this language will be lost.',
        confirmDeleteOne: 'The language "{label}" will be removed from the app.',
        confirmDeleteTitle: 'Delete language?',
        create: 'New language',
        deleted: 'Language deleted.',
        empty: 'No language yet.',
        form: {
          activeHint: 'While unpublished, the language can be translated but nobody can pick it.',
          createTitle: 'New language',
          editTitle: 'Edit language',
          flagHint: 'https URL of the flag image. Leave it empty to use the built-in one.',
          isoHint: 'Two-letter ISO code, for example it.',
          isoLocked: 'The code cannot be changed: accounts already point to it.',
          orderHint: 'Position in the language menu, lowest first.',
          subtitle: 'A language can be translated before it is published to users.',
        },
        saved: 'Language saved.',
        subtitle: '{count} languages. Only the published ones can be picked by users.',
        unpublished: 'not published',
      },
      saved: 'Label saved.',
      subtitle: 'Every string the interface shows, and the languages it shows them in.',
      tabs: {
        labels: 'Labels',
        languages: 'Languages',
      },
      untranslated: 'not translated',
    },
    maintenance: {
      badge: 'Site closed',
      confirmAction: 'Close the site',
      confirmBody:
        'Every user except admins and editors will be locked out until you turn maintenance off.',
      confirmTitle: 'Close the site?',
      disabled: 'The site is open again.',
      enabled: 'The site is now in maintenance.',
      endsAt: 'Expected end',
      endsAtEmpty: 'Leave it empty for an open-ended maintenance.',
      message: 'Custom message',
      messageHint: 'Shown on the notice page instead of the default text.',
      messagePlaceholder: 'Optional — replaces the default wording',
      title: 'Maintenance mode',
      toggle: 'Put the site in maintenance',
      toggleHint:
        'Everyone but admins and editors sees a notice instead of the site. Only the login page and this panel stay reachable.',
    },
    menus: {
      childOf: 'inside {parent}',
      confirmCascade: 'Their {count} child entries will be deleted too.',
      confirmDeleteMany: '{count} entries will be removed from the menu.',
      confirmDeleteOne: '“{label}” will be removed from the menu.',
      confirmDeleteTitle: 'Delete menu entries?',
      create: 'New entry',
      deleted: 'Menu entries deleted.',
      empty: 'No entry matches these filters.',
      filters: {
        allParents: 'Any parent',
        topLevel: 'Top level only',
      },
      flags: {
        admin: 'Admins',
        editor: 'Editors',
        groupAdmin: 'Group admins',
        groupDef: 'Group Defence Leaders',
        groupMember: 'Group members',
        groupOff: 'Group Offender Leaders',
        guest: 'Guests',
        user: 'Logged-in users',
      },
      flagsShort: {
        groupAdmin: 'G. adm',
        groupDef: 'G. def',
        groupMember: 'G. mem',
        groupOff: 'G. off',
        guest: 'Guest',
      },
      form: {
        createTitle: 'New menu entry',
        editTitle: 'Edit menu entry',
        icon: 'Icon',
        iconHint: 'Material Design Icons name, e.g. mdi-sword-cross.',
        isNew: 'Mark as new',
        isNewHint: 'Shows a "New" badge next to the entry wherever the menu is rendered.',
        label: 'Label',
        labelRequired: 'The label is required.',
        logged: 'Hide from anonymous visitors',
        loggedHint: 'The entry only appears once the visitor is logged in.',
        noParent: 'No parent (top level)',
        parent: 'Parent entry',
        path: 'Path',
        pathHint: 'Leave it empty for a category, or for a page that does not exist yet.',
        subtitle: 'Position, page and who is allowed to see it.',
        visibility: 'Who sees this entry',
      },
      noPath: 'no page',
      saved: 'Menu entry saved.',
      subtitle: '{count} entries. This is what every user of the app can see.',
    },
    nav: {
      backToSite: 'Back to the site',
      home: 'Home',
      jobs: 'Jobs',
      label: 'Admin navigation',
      openPanel: 'Admin panel',
    },
    news: {
      columns: {
        author: 'Author',
        body: 'Body',
        publishedAt: 'Published on',
        title: 'Title',
      },
      confirmDeleteMany: '{count} articles will be removed.',
      confirmDeleteTitle: 'Delete articles?',
      create: 'New article',
      deleted: 'Articles deleted.',
      editor: {
        bold: 'Bold',
        bulletList: 'Bulleted list',
        clear: 'Clear formatting',
        colors: {
          default: 'Default colour',
          gold: 'Gold',
          green: 'Green',
          primary: 'Blue',
          red: 'Red',
        },
        heading: 'Heading',
        insertChip: 'Insert the {chip} chip',
        italic: 'Italic',
        linkUrl: 'Link address',
        orderedList: 'Numbered list',
        quote: 'Quote',
        strike: 'Strikethrough',
        underline: 'Underline',
      },
      empty: 'No article matches these filters.',
      form: {
        bodyHint: 'Bold, italic, colours, lists, links and the Bug/Feature chips.',
        bodyRequired: 'The body cannot be empty.',
        createTitle: 'New article',
        editTitle: 'Edit article',
        image: {
          default: {
            changelog: 'Changelog',
            info: 'Announcement',
            novita: "What's new",
          },
          invalidType: 'Unsupported file format.',
          remove: 'Remove image',
          tooLarge: 'The file is too large.',
          upload: 'Upload custom image',
          uploadAfterCreate: 'Save the article first to upload a custom image.',
        },
        subtitle: 'It stays a draft until you publish it.',
        titleRequired: 'The title is required.',
      },
      hideOne: 'Hide {label}',
      publish: {
        body: '{count} article(s) will become visible on every dashboard.',
        confirm: 'Publish',
        dateLabel: 'Publish on',
        dateRequired: 'Pick a date and time.',
        now: 'Publish now',
        nowHint: 'It shows up on the dashboards immediately.',
        schedule: 'Schedule',
        scheduleHint: 'It stays hidden until the date you pick.',
        title: 'Publish',
      },
      publishAction: 'Publish',
      published: 'Article published.',
      publishOne: 'Publish {label}',
      saved: 'Article saved.',
      scheduled: 'Publication scheduled.',
      states: {
        all: 'Any state',
        draft: 'Draft',
        published: 'Published',
        scheduled: 'Scheduled',
      },
      subtitle: '{count} announcements.',
      unpublished: 'Article back to draft.',
    },
    placeholder: {
      body: 'This section of the panel is not built yet. The route already exists, so the page will light up as soon as the feature ships.',
    },
    servers: {
      columns: {
        archive: 'Archived',
        closed: 'Closed',
        endDate: 'End',
        size: 'Size',
        startDate: 'Start',
        wwLevel: 'WW',
      },
      confirmDeleteHint: 'Alliances, players and villages of that world are deleted with it.',
      confirmDeleteMany: '{count} servers will be removed.',
      confirmDeleteTitle: 'Delete servers?',
      create: 'New server',
      defaultTechnical: {
        configured: 'In use by every world set to the default account.',
        emailRequired: 'The email is required.',
        hint: 'Credentials used by every world that has no dedicated account of its own. A newly created server starts out using these. Stored encrypted and never sent back by the API.',
        notConfigured:
          'No default account configured: worlds without their own credentials cannot be reached.',
        passwordRequired: 'The password is required the first time you save it.',
        remove: 'Delete default account',
        removeBody:
          'Every world using it is left without usable credentials until a new default is configured.',
        removed: 'Default technical account deleted.',
        removeTitle: 'Delete the default account?',
        saved: 'Default technical account saved.',
        title: 'Default technical account',
      },
      deleted: 'Servers deleted.',
      empty: 'No server matches these filters.',
      filters: {
        endFrom: 'End from',
        endTo: 'End to',
        startFrom: 'Start from',
        startTo: 'Start to',
      },
      form: {
        createTitle: 'New server',
        editTitle: 'Edit server',
        linkRequired: 'The link is required.',
        sizeHint: 'Map radius: a size 200 world spans -200 to +200.',
        startHint: 'Empty means it starts today.',
        subtitle: 'Dates, speed, map size and state of the world.',
      },
      gameProgressSync: 'Sync game progress',
      gameProgressSyncHint:
        'Runs the nightly job now: reads the Wonder ranking and the progression timeline from every game world.',
      gameProgressSyncQueued: 'Game progress sync queued.',
      lobbySync: 'Update from the lobby',
      lobbySyncHint:
        'Reads the Travian lobby and refreshes every world: new ones are added, finished rounds are closed. Runs on its own every night at 23:00.',
      lobbySyncQueued: 'Update from the lobby started: it runs in the background.',
      saved: 'Server saved.',
      subtitle: '{count} game worlds.',
      sync: 'Run the sync for {name}',
      syncQueued: 'Sync queued for {name}.',
      syncShort: 'Sync',
      technical: {
        active: 'Account enabled',
        defaultInactive:
          'The default account is disabled: this world cannot be reached until it is enabled again, or given a dedicated account.',
        defaultMissing:
          'No default account is configured yet: set one from the Servers page, or give this world a dedicated account.',
        hint: 'Credentials the system will use to log into this world and check the hero’s equipment on incoming attacks. Stored encrypted and never sent back by the API.',
        keptForLater:
          'The dedicated credentials stay saved: you can switch back without retyping the password.',
        passwordKept: 'Leave it empty to keep the saved one.',
        passwordNew: 'Required the first time you save it.',
        remove: 'Delete account',
        removed: 'Technical account deleted.',
        source: 'Credentials to use',
        title: 'Technical game account',
        useDefault: 'Default account',
        useOwn: 'Dedicated account',
        usingDefault: 'This world logs in as {email}.',
      },
    },
    social: {
      discordPlaceholder: 'https://discord.gg/your-invite',
      hint: 'Shown as icons at the bottom of the sidebar. Leave a field empty to hide its icon.',
      instagramPlaceholder: 'https://instagram.com/your-profile',
      invalidUrl: 'Use a full http:// or https:// address.',
      saved: 'Social links saved.',
      telegramPlaceholder: 'https://t.me/your-channel',
      title: 'Social links',
    },
    stats: {
      groups: {
        activeHint: '{count} active',
        candidates: '{count} pending candidates',
        members: 'Users in a group',
      },
      incomings: {
        hint: '{total} reported in total',
        upcoming: 'Upcoming attacks',
      },
      menu: {
        hint: '{count} without a page',
        total: 'Menu entries',
      },
      players: {
        claimed: 'Claimed characters',
        hint: '{total} players imported',
      },
      servers: {
        active: 'Active servers',
        hint: '{total} total · {closed} closed',
      },
      users: {
        activeHint: '{count} active',
        new30: '{count} in the last 30 days',
        new7: 'New this week',
        staff: 'Staff',
        staffHint: '{admins} admins · {editors} editors',
        total: 'Registered users',
        verified: 'Verified emails',
      },
    },
    users: {
      columns: {
        createdAt: 'Registered on',
        lobbyName: 'Lobby name',
        verifiedAt: 'Verified on',
      },
      confirmDeleteHint:
        'Deletion is permanent: their groups, characters and subscriptions go with them.',
      confirmDeleteMany: '{count} accounts will be removed for good.',
      confirmDeleteOne: '“{label}” will be removed for good.',
      confirmDeleteTitle: 'Delete users?',
      create: 'New user',
      deleted: 'Users deleted.',
      detail: {
        ended: 'Ended',
        groupRemoved: 'User removed from the group.',
        noEndDate: 'no end date',
        noGroups: 'Not part of any group.',
        noSubscriptions: 'No subscription.',
        subscriptionTerminated: 'Subscription ended.',
        terminate: 'End',
      },
      empty: 'No user matches these filters.',
      filters: {
        anyLanguage: 'Any language',
        createdFrom: 'Registered from',
        createdTo: 'Registered to',
      },
      form: {
        createSubtitle: 'The account is created already verified.',
        createTitle: 'New user',
        editSubtitle: 'Leave the password empty to keep the current one.',
        editTitle: 'Edit user',
        emailRequired: 'The email is required.',
        passwordEdit: 'Fill it in only to reset their password.',
        passwordNew: 'Optional: without one, they will have to use the password reset.',
        roles: 'Roles',
        verified: 'Verified',
        verifiedNote: 'Created by an admin, so no email confirmation is needed.',
      },
      saved: 'User saved.',
      skippedSelf: 'Your own account was left untouched.',
      skippedSelfHint: 'Your own account will be skipped.',
      subtitle: '{count} accounts, deactivated ones included.',
    },
  },
  alliance: {
    detail: {
      charts: {
        members: {
          empty: 'No members history yet.',
          title: 'Members over time',
        },
        tribes: {
          empty: 'No members with a known tribe.',
          title: 'Members by tribe',
        },
      },
      fields: {
        creationDate: 'Founded on',
        deletedOn: 'Deleted on {date}',
        noPreviousNames: 'Never renamed',
        openProfile: 'Open Travian alliance profile',
        previousNames: 'Previous names',
        previousNameSince: 'until {date}',
      },
      former: {
        columns: {
          destination: 'Moved to',
          leftAt: 'Left on',
        },
        deleted: 'Deleted player',
        empty: 'No former members.',
        title: 'Former members',
      },
      history: {
        events: {
          created: 'Alliance founded as {tag}',
          deleted: 'Alliance deleted',
          playerDeleted: 'Deleted while a member:',
          playerJoined: 'Joined the alliance:',
          playerLeft: 'Left the alliance:',
          renamed: 'Renamed from {previous} to {tag}',
        },
        title: 'History of {tag}',
      },
      map: {
        empty: 'No member villages to place on the map.',
        title: 'Where the members are',
      },
      members: {
        columns: {
          fromAlliance: 'Came from',
          joinedAt: 'Joined on',
        },
        empty: 'No members.',
        title: 'Current members',
      },
    },
  },
  archiveServers: {
    confirmRemoveBody: 'The server will be permanently removed from your favorites.',
    confirmRemoveTitle: 'Remove {name} from the archive?',
    confirmRemoveWithTroops: 'The troops saved for {alias} on this server will be deleted too.',
    empty: 'Your archive is still empty.',
    remove: 'Remove from archive',
    removed: '{name} removed from the archive',
    subtitle: 'The concluded servers among your favorites.',
    title: 'Server archive',
  },
  attackPlans: {
    arenaModes: {
      optimize: 'Optimize levels',
      optimizeHint:
        "Each launch gets its tournament square level, so the launches of a village fall in the shortest window possible — or in the window you ask for — at least the minimum gap apart. Between two launches the level goes up or down by 3 at most; the levels closest to the village's own are preferred.",
      same: 'Same level for all',
      sameHint:
        'Every launch of a village uses its starting level: no building or demolishing during the mission.',
    },
    army: {
      destroyed: 'Marked as dead/destroyed on {date}.',
      destroyedShort: 'Army dead',
      open: 'Army reported in {village}',
      openTracker: 'Open Track enemies',
      reported: '{total} troops · last report {date} · {reports} reports',
      short: 'Army',
      title: 'Army in {village}',
    },
    assign: {
      assignPicked: 'Assign ({count})',
      cellTitle: '{source} → {target} ({fields} fields)',
      gridCorner: 'Our village ↓ · Target →',
      gridEmpty: 'Choose targets (step 2) and participants (step 3) first.',
      gridTitle: 'Who attacks whom',
      ourVillages: 'Our villages ({count} ticked)',
      pairs: 'Attacks to create or remove: {count}',
      quickHint:
        'Tick some of our villages and some targets: “Assign” gives every ticked village every ticked target. Repeat with other groups, or fine-tune in the grid below.',
      quickTitle: 'Quick assignment',
      removePicked: 'Remove these pairs',
      targets: 'Targets ({count} ticked)',
      total: 'Attacks: {count}',
      withoutTargets: 'Without targets ({count})',
    },
    attackStatus: {
      not_sent: 'Not launched',
      pending: 'To launch',
      sent: 'Sent',
    },
    columns: {
      arena: 'Arena',
      arrival: 'Arrival',
      distance: 'Distance',
      kind: 'Type',
      launch: 'Launch',
      note: 'Note',
      speed: 'Speed',
      speedShort: 'Speed',
      status: 'Status',
      target: 'Target',
      waves: 'Waves',
      wavesShort: 'Waves',
    },
    common: {
      capital: 'Capital',
      fields: 'fields',
      population: '{count} inh.',
      retry: 'Retry',
      select: 'Select',
      selectAll: 'All',
      selectNone: 'None',
    },
    edit: {
      apply: 'Apply',
      arenaHint:
        'Change it to launch this attack with that level: the other launches of the village stay as they are.',
      arenaNear: 'Within 20 fields the arena does not count.',
      arrivalHint: "Empty = the plan's landing.",
      title: 'Edit attack',
    },
    editor: {
      back: 'Back',
      concluded:
        'This plan is concluded: every landing is past. It can only be viewed, duplicated or deleted.',
      duplicateTitle: 'Copy of a plan',
      editTitle: 'Edit “{name}”',
      leaveBody: 'The changes to this plan have not been saved and will be lost.',
      leaveConfirm: 'Leave',
      leaveTitle: 'Leave without saving?',
      needs: {
        assign: 'Assign at least one attack.',
        players: 'Choose at least one player.',
        sources: 'Choose at least one village of ours.',
        targets: 'Choose at least one target village.',
      },
      next: 'Next',
      steps: 'Steps of the plan',
      subtitle:
        'Attack plan of {group}: choose the enemies and their villages, who takes part and from where, who hits whom, then arrival and speed.',
      title: 'New plan',
    },
    errors: {
      alreadyPublished: 'The plan is already published: it cannot go back to draft.',
      arrivalNotFeasible:
        'Some attacks cannot arrive in time even with arena 20 (earliest arrival):',
      arrivalRequired: 'Set the arrival time.',
      duplicateAttack: 'The same village attacks the same target twice.',
      exportFailed: 'The Excel file could not be downloaded.',
      generic: 'The plan could not be saved.',
      invalidAttack: 'An attack refers to a village not in the plan.',
      invalidSource: "A participant's village is not of a member of the group any more.",
      invalidTarget: 'A target is not a village of this world.',
      launchInPast: 'Some launches are already past with the chosen levels:',
      loadFailed: 'The plan data could not be loaded.',
      memberTarget: 'A target belongs to a member of the group.',
      nameRequired: 'Give the plan a name.',
      noAttacks: 'The plan has no attack.',
      noParticipants: 'None of the chosen players takes part in the plan.',
      notLaunchedYet:
        'The launch time has not passed yet: you can mark the attack only after launching it.',
      notPublished: 'The plan is not published.',
      planConcluded: 'The plan is concluded: it can only be viewed, duplicated or deleted.',
      sourceWithoutAttacks: 'Some participants have no target:',
      speedRequired: 'Set the troop speed.',
    },
    export: {
      artifact: 'Speed artifact ×{value}',
      block: "{village} ({x}{'|'}{y}) — {plan}",
      columns: {
        arena: 'ARENA LV',
        arrival: 'ARRIVAL',
        departureDay: 'DEPARTURE DAY',
        departureTime: 'DEPARTURE TIME',
        distance: 'DISTANCE',
        duration: 'DURATION',
        note: 'NOTE',
        send: 'SEND',
        speed: 'SPEED',
        target: 'TARGET',
        type: 'ATTACK TYPE',
        waves: 'WAVES',
        x: 'X',
        y: 'Y',
      },
      reminder:
        'Mark every launched (or skipped) attack on Travick, so the coordinators can follow the mission: {url}',
      sheetMission: 'Mission',
      sheetRules: 'Rules',
      title: 'Attack plan of {player}',
    },
    exportPlan: {
      button: "Download the players' Excel",
      chosen: 'Players: {chosen} of {total}',
      download: 'Download ({count})',
      formats: {
        files: 'One Excel per player',
        filesHint:
          'A zip with a file per player, the same file the player downloads from Your plan.',
        sheets: 'One Excel file',
        sheetsHint: 'One sheet per player, plus the rules.',
      },
      formatTitle: 'File',
      noPlayers: 'The plan has no participant.',
      short: 'Excel',
      title: "Download the players' Excel",
      villages: 'villages: {count}',
    },
    kinds: {
      fake: 'Fake',
      real: 'Real',
    },
    mine: {
      ago: '{time} ago',
      arenaRow: 'Arena of this launch',
      arenaRowHint:
        'Type a level to launch this attack with it; the other launches stay as they are. “Recalculate” optimizes them all again.',
      arenaStart: 'Your arena',
      artifact: 'Speed artifact in this village',
      artifactFaster: 'speed artifact',
      artifactNone: 'no artifact',
      artifactSlower: 'slowed (Book of Secrets)',
      confirmNotSent: 'Mark not launched',
      coordinatorHint:
        "Follow a participant's launches and marks; to fix a mistake, edit the plan from",
      done: '{done}/{total} marked',
      download: 'Download Excel',
      downloadReminder:
        'Excel downloaded. Remember to mark here every attack you launch (or skip): the coordinators follow the mission from this page.',
      empty: 'No attack for you in the published plans.',
      emptyOther: 'No attack for {player} in the published plans.',
      in: 'in {time}',
      late: 'Late: {time}',
      markAfterLaunch: 'You can mark it once the launch time has passed.',
      markNotSent: 'Not launched',
      markReminder:
        'Mark every attack as sent or not launched: the coordinators follow the mission from here.',
      markSent: 'Sent',
      myself: 'Me',
      nextLaunch: 'Next launch',
      ownArrival: 'own landing',
      participantOption: '{player} · {sent}+{notSent}/{total}',
      planLine: 'Plan “{plan}” · arrival {arrival}',
      player: 'Player',
      progressLabel: 'Progress',
      reason: "Why wasn't it launched?",
      reasonPlaceholder: 'e.g. troops not back yet',
      recalculate: 'Recalculate',
      reset: 'Back to “to launch”',
      restore: "Plan's values",
      restoreHint: 'Back to the levels of the plan (the artifact stays)',
      send: 'Send',
      sendHint: 'Opens the rally point of the game with the target filled in',
      settingsHint:
        'Different arena from the plan, or a speed artifact? Set them and recalculate: the launches move, the landing stays. Recalculating also redoes the levels typed on single launches.',
      settingsSaved: 'Launches recalculated.',
      subtitle:
        'Your attacks in the published plans of {group}, one table per departure village, in launch order.',
      title: 'Your plan',
      unavailable: 'Your plan is not available: you need a character in this group.',
      viewing: 'Mission of',
      yours: 'yours',
    },
    notAllowed:
      "Only the group's admins and Offender Leaders can create and manage plans: here is your plan.",
    players: {
      addPlayer: 'Add a player by name',
      alliances: 'Alliances',
      allianceSearchPlaceholder: 'Search an alliance by tag',
      alreadyAdded: 'added',
      empty: 'Add an alliance or a player to see the list.',
      filter: 'Filter the list',
      listTitle: 'Players for the mission',
      member: 'Group member',
      membersCount: '{count} players',
      noAlliance: 'Without alliance',
      noResults: 'Nothing found.',
      playerInfo: '{villages} villages · {population} inh.',
      playerSearchPlaceholder: 'Search a player (even outside an alliance)',
      removeAlliance: 'Remove the alliance {tag}',
      removePlayer: 'Remove {player}',
      selectedCount:
        'Chosen players: {count}. Their villages are the possible targets of the next step.',
      tracked: 'Tracked ({count})',
      trackedHint: 'Armies of this player in Track enemies: {count}',
    },
    preview: {
      arrival: 'arrival {date}',
      empty: 'No participant in this plan.',
      speed: 'speed {speed}',
    },
    realTypes: {
      conquer: 'Conquest',
      demolish: 'Demolition',
    },
    rules: {
      button: 'Mission rules',
      intro: 'Read them before the first launch: they are also in the second sheet of the Excel.',
      items: {
        '1': "Before you start the first fake, change your hero clothes as you will land on the real, and DON'T change them until landing time.",
        '2': "Before the first fake send your troops away walking: they should arrive home 3-4 min before the real. DON'T send your troops as reinforcement to your oasis.",
        '3': 'Make sure to leave the right troops to send the fakes before and after the real targets.',
        '4': 'You can change the TS level, but remember to build/destroy according to your configuration here before sending.',
        '5': 'Please check some launch times to be sure they are correct.',
        '6': 'Always keep at home (after the real and the last fake as well) 5XX foot + 1XX horse, 2X rams and 2X catapults (e.g. always have at home 527 clubs, 155 TK, 25 rams, 22 catas).',
        '7': "After the last fake destroy/build 1 or 2 levels of TS, so you don't get sniped by the enemy when the troops come back.",
      },
      rule: 'Rule {n}',
      title: 'Rules of a clean mission',
    },
    save: {
      blocked: 'It cannot be published yet ({count} problems):',
      draft: 'Save draft',
      draftBody: "The plan goes into Saved plans; the players don't see it yet.",
      draftTitle: 'Save as draft',
      name: 'Plan name',
      namePlaceholder: 'e.g. Op. North, 3 April',
      publish: 'Save and publish',
      publishBody:
        'The plan goes into Saved plans and every participant finds their attacks in “Your plan”.',
      published: 'Plan saved and published to the participants.',
      publishTitle: 'Save and publish',
      saved: 'Plan saved as draft.',
      unpublishWarning:
        'This plan is published: saving it as draft takes it away from the players until you publish it again.',
      update: 'Save changes',
      updateBody:
        'The participants see the new version right away and the group is told the plan changed.',
      updated: 'Plan updated: the participants have been told.',
      updateTitle: 'Save the published plan',
    },
    saved: {
      attacks: 'Attacks: {count} ({fakes} fake, {reals} real)',
      columns: {
        actions: 'Actions',
        arrival: 'Arrival',
        content: 'Content',
        name: 'Plan',
        progress: 'Progress',
        updated: 'Updated',
      },
      confirmDelete: 'Delete for good?',
      delete: 'Delete',
      deleted: 'Plan “{name}” deleted.',
      duplicate: 'Duplicate',
      edit: 'Edit',
      empty: 'No plan yet: create one with “New plan”.',
      participants: 'Participants: {count} ({villages} villages)',
      progress: '{sent} sent · {notSent} not launched · of {total}',
      subtitle: 'Drafts and published plans of {group}.',
      targets: 'Targets: {count}',
      title: 'Saved plans',
      unpublish: 'Unpublish',
      view: 'View',
    },
    sources: {
      arena: 'arena {level}',
      arenaUnknown: 'arena not declared',
      attackArmy: 'Attack',
      attackArmyHint: 'Attack army: suggested for the mission',
      filter: 'Search player by alias',
      intro:
        'Choose who takes part and from which villages. The villages with an attack army (from their role or declared troops) are suggested. Chosen villages: {count}.',
      noMatch: 'No player matches "{query}".',
      noMembers: 'The group has no member with a character.',
      selectSuggested: 'Pick the suggested ({count})',
      suggested: 'Suggested',
      troopsUnknown: 'troops not updated',
      troopsUpdated: 'troops of {date}',
    },
    status: {
      concluded: 'Concluded',
      draft: 'Draft',
      published: 'Published',
    },
    steps: {
      assign: 'Assignment',
      players: 'Players',
      sources: 'Participants',
      targets: 'Targets',
      timing: 'Timing',
    },
    targets: {
      chosenOf: '{chosen} of {total} chosen',
      intro: 'Tick the villages to hit. Chosen targets: {count}.',
      noPlayers: 'No player chosen: go back to step 1.',
      orphansHint:
        'Targets saved in the plan whose player is not in the list any more (village conquered, alliance changed).',
      orphansTitle: 'Other targets of the plan',
      remove: 'Remove {village}',
    },
    timing: {
      apply: 'Apply',
      applyToAll: 'Apply to all',
      arenaAuto: 'Computed level: type one to set it by hand',
      arenaBackToAuto: 'Back to the computed level',
      arenaFixed: 'Level set by hand: the optimization keeps it',
      arenaMode: 'Tournament square',
      arenaStart: 'Starting arena (villages without a declared one)',
      arenaStartAll: 'Use it for every village',
      arenaStartHint:
        'Each village starts from the level its player declared; you can change it village by village.',
      arrival: 'Arrival',
      arrivalBackToPlan: "Plan's landing",
      arrivalHint: 'In the game time (your Travick time zone), to the second.',
      attacksCount: '{count} attacks',
      bulkSelected: 'Selected attacks: {count}',
      bulkTitle: 'Change the selected attacks',
      checks: 'Checks',
      closeCount: 'Launches less than {seconds} s apart: {count} (allowed, but hard to send)',
      closeLaunch: 'Less than {seconds} s from another launch',
      customSpeed: 'Another speed…',
      defaultWaves: 'Default waves',
      idleSources: 'Participants without targets: {villages}',
      infeasible: 'Impossible even with arena 20: earliest arrival {date}',
      infeasibleCount: 'Attacks that cannot arrive in time even with arena 20: {count}',
      launchWindow: 'Launch window per village (hours)',
      manualHint:
        'Levels set by hand: the optimization no longer moves this village. Recalculate to optimize it again.',
      manualVillages:
        'Arena set by hand in: {villages}. Their levels stay as they are until you recalculate.',
      minGap: 'Minimum gap between launches (s)',
      minGapHint: 'Launches of the same village closer than this are flagged.',
      mixed: 'Mixed',
      noAttacksHere:
        'No target assigned to this village: assign one in step 4 or remove the village in step 3.',
      notePlaceholder: 'Note for the player',
      ownArrival: 'Landing time of this attack',
      ownShort: 'own',
      pastCount: 'Attacks whose launch is already past: {count}',
      pastLaunch: 'The launch is already past: raise the level or move the arrival',
      planArrival: 'same as the plan',
      planSpeed: 'Plan speed',
      recalculate: 'Recalculate optimization',
      recalculateAll: 'Recalculate all',
      selectPlayer: 'Select every attack of this player',
      selectRow: 'Select the attack on {target}',
      selectSource: 'Select every attack of {village}',
      sourceArena: 'Starting arena',
      span: 'window {span}',
      speed: 'Troop speed for everyone',
      speedHint:
        'Fields/hour on an x1 world, the speed of the slowest unit sent; the world multiplies it by {factor}.',
      speedPlaceholder: 'Choose the speed',
      startDeclared: 'declared: {level}',
      startNone: 'not declared: 0',
      startOverride: 'set by you',
      startPlan: 'plan: {level}',
      stepExceeded:
        'No arrangement keeps the arena within 3 levels between two launches here: {villages}',
      targetKind: 'Type of the attacks on {village}',
      targetsHint: 'Sets every attack on that target; single attacks can still be changed below.',
      targetsTitle: 'Fake or real, target by target',
      travel: 'travel {time}',
      window: 'launches {from} → {to}',
      windowAuto: 'shortest',
      windowExceeded:
        'These villages cannot launch within {hours} h, the shortest window possible is used: {villages}',
      windowHint:
        'Empty = as tight as possible. With a window, the launches fit in it touching the arena as little as possible; if a village cannot, it is flagged.',
    },
    unpublish: {
      body: 'The plan goes back to draft: the players no longer see it in “Your plan” until you publish it again.',
      done: '“{name}” is a draft again.',
      past: 'Launches already past: {count}.',
      saveTitle: 'Back to draft',
      sent: 'Attacks already marked as sent: {count}.',
      title: 'Unpublish “{name}”?',
    },
  },
  auth: {
    discord: 'Continue with Discord',
    discordLoginFailed: 'Discord sign-in failed, please try again.',
    emailNotVerified: {
      body: 'We sent you a confirmation link. Verify your address, then log in again.',
      resend: 'Send it again',
      resent: 'Verification email sent.',
      title: 'Verify your email first',
    },
    fields: {
      currentPassword: 'Current password',
      newPassword: 'New password',
      passwordConfirmation: 'Confirm password',
    },
    forgot: {
      backToLogin: 'Back to login',
      submit: 'Send the link',
      subtitle: 'We will email you a link to choose a new password.',
      success: 'If that address exists, the reset link is on its way.',
      title: 'Reset your password',
    },
    google: 'Continue with Google',
    googleUnavailable: 'Google sign-in is not configured for this environment.',
    login: {
      forgot: 'Forgot your password?',
      noAccount: 'No account yet?',
      resendVerification: 'Resend the verification email',
      subtitle: 'Log in to reach your confederation.',
      success: 'Welcome back, {name}!',
      title: 'Welcome back',
    },
    logout: {
      success: 'You are logged out.',
    },
    orContinueWith: 'or continue with',
    placeholders: {
      email: "you{'@'}example.com",
      name: 'How should we call you?',
    },
    register: {
      hasAccount: 'Already registered?',
      privacyLink: 'Privacy Policy',
      privacyNotice: 'By creating an account you confirm that you have read the {link}.',
      subtitle: 'One account for every world you play.',
      success: 'Account created. Check your inbox to verify your email before logging in.',
    },
    reset: {
      invalidLink: 'This reset link is invalid or incomplete. Ask for a new one.',
      submit: 'Save the new password',
      subtitle: 'Pick something you have never used elsewhere.',
      success: 'Password updated. You can log in now.',
      title: 'Choose a new password',
    },
    verify: {
      error: 'We could not verify this link. It may already have been used.',
      goToLogin: 'Go to login',
      invalidLink: 'This verification link is incomplete.',
      pending: 'Hold on while we confirm your address…',
      success: 'Your email is verified. Welcome aboard!',
      title: 'Verifying your email',
    },
  },
  brand: {
    name: 'Travick',
    tagline: 'Command your confederation',
  },
  building: {
    academy: 'Academy',
    bakery: 'Bakery',
    barracks: 'Barracks',
    brewery: 'Brewery',
    brickyard: 'Brickyard',
    cityWall: 'City Wall',
    clayPit: 'Clay Pit',
    commandCenter: 'Command Center',
    cranny: 'Cranny',
    cropland: 'Cropland',
    earthWall: 'Earth Wall',
    embassy: 'Embassy',
    grainMill: 'Grain Mill',
    granary: 'Granary',
    greatBarracks: 'Great Barracks',
    greatGranary: 'Great Granary',
    greatStable: 'Great Stable',
    greatWarehouse: 'Great Warehouse',
    herosMansion: "Hero's Mansion",
    horseDrinkingTrough: 'Horse Drinking Trough',
    hospital: 'Hospital',
    ironFoundry: 'Iron Foundry',
    ironMine: 'Iron Mine',
    mainBuilding: 'Main Building',
    makeshiftWall: 'Makeshift Wall',
    marketplace: 'Marketplace',
    palace: 'Palace',
    palisade: 'Palisade',
    rallyPoint: 'Rally Point',
    residence: 'Residence',
    sawmill: 'Sawmill',
    smithy: 'Smithy',
    stable: 'Stable',
    stonemasonsLodge: "Stonemason's Lodge",
    stoneWall: 'Stone Wall',
    tournamentSquare: 'Tournament Square',
    townHall: 'Town Hall',
    tradeOffice: 'Trade Office',
    trapper: 'Trapper',
    treasury: 'Treasury',
    warehouse: 'Warehouse',
    waterworks: 'Waterworks',
    woodcutter: 'Woodcutter',
    workshop: 'Workshop',
  },
  calcDefSend: {
    arrival: {
      anyArena: 'Any arena',
      arenaOption: 'Arena {level}',
      arenaOptionMin: 'Arena {level} (minimum)',
      arenaPicker: 'Tournament square for {troop}',
      departBy: 'Leave by {time}',
      minArena: 'Arena {level}+',
      noArena: 'No arena needed',
      none: 'No troop makes it, not even with a level 20 tournament square.',
      passed: 'The arrival time has already passed.',
      summary: '{inTime} in time · {late} late',
      travel: 'travel {time}',
      withYourArena: 'With your arena (level {level}) you can leave by {time}.',
    },
    coordsInvalid: 'Enter whole numbers between -400 and 400.',
    errors: {
      serverRequired: 'Select a favourite world to start from one of your villages.',
      villageNotFound: 'That village is no longer yours on this world.',
    },
    hero: {
      boots: {
        '1': 'Boots of the Mercenary (+{bonus}%)',
        '2': 'Boots of the Warrior (+{bonus}%)',
        '3': 'Boots of the Archon (+{bonus}%)',
      },
      bootsLabel: 'Boots',
      flagLabel: 'Flag',
      hunBonusApplied: 'Faster with the Hun hero',
      hunHero: 'With mounted hero',
      hunHeroHint: 'Hun hero: +3 fields/hour, only for armies of cavalry alone.',
      noBoots: 'No speed boots',
      noFlag: 'No flag',
      note: 'Hero items only count when the hero travels with the troops, and the army moves at the speed of its slowest unit, hero included.',
      pennant: {
        '1': 'Small pennant (+{bonus}%)',
        '2': 'Pennant (+{bonus}%)',
        '3': 'Great pennant (+{bonus}%)',
        group: 'Pennant · between your own villages',
      },
      standard: {
        '1': 'Small standard (+{bonus}%)',
        '2': 'Standard (+{bonus}%)',
        '3': 'Great standard (+{bonus}%)',
        group: 'Standard · between alliance villages',
      },
      title: 'Hero',
    },
    origin: {
      coords: 'Starting coordinates',
      mode: 'Starting point',
      modes: {
        coords: 'Coordinates',
        village: 'My village',
      },
      pickTribe: 'Choose a tribe',
      speed: 'Server speed',
      title: 'From',
      tribe: 'Tribe',
      tribeFixed: "Tribe: {tribe} (the village's)",
      village: 'Village',
    },
    parking: {
      coords: 'Parking coordinates',
      hint: 'They come back here first and then leave: you see when to withdraw them. Arena and hero count on the way back too.',
      returnAndTravel: 'return {back} + travel {time}',
      thenSendBy: 'Then send from home by {time}',
      toggle: 'Troops parked in another village',
      totalsNote:
        'Total times: return from the parking village plus the trip to the target. Hover a time to see the two legs.',
      withdrawBy: 'Withdraw by {time}',
      withYourArena: 'With your arena (level {level}) you can withdraw them by {time}.',
    },
    results: {
      distance: '{distance} fields',
      inTime: 'Troops arriving in time',
      needOrigin: 'Choose where the troops leave from to see the times.',
      needTarget: 'Enter the target coordinates to start.',
      times: 'Travel times',
    },
    subtitle: 'Travel times on {server}, from one of your villages or from any coordinates.',
    subtitleNoServer:
      'No favourite world selected: enter coordinates, tribe and server speed by hand.',
    target: {
      arrival: 'Arrival time',
      arrivalHint:
        'Game time, in your Travick time zone ({zone}). Without it you get every travel time.',
      clearArrival: 'Clear arrival time',
      coords: 'Target coordinates',
      optional: '(optional)',
      title: 'To',
    },
    times: {
      anyLevel: 'Any level',
      arena: 'Arena',
      caption: 'Travel time of each troop for each tournament square level',
      hunBonus: '+3 hero',
      level: 'Lv {level}',
      yours: '(yours)',
    },
    title: 'Defense send calculator',
  },
  celebration: {
    greatCelebration: 'Great celebration',
    smallCelebration: 'Small celebration',
  },
  common: {
    accountSettings: 'Account settings',
    add: 'Add',
    avgPopulation: 'Avg. population',
    backToDashboard: 'Back to dashboard',
    backToHome: 'Back to home',
    cancel: 'Cancel',
    capital: 'Capital',
    close: 'Close',
    columns: {
      active: 'Active',
      alias: 'Alias',
      createdAt: 'Created on',
      name: 'Name',
      type: 'Type',
    },
    comingSoon: 'Coming soon',
    comingSoonBody:
      'This section is not built yet. The menu entry already exists, so the page will light up as soon as the feature ships.',
    comparisonWindow: 'Comparison window: {days} day(s)',
    concludedServer: 'Concluded server',
    confirm: 'Confirm',
    confirmDelete: {
      one: '“{label}” will be removed.',
    },
    copy: 'Copy',
    createGroup: 'Create group',
    createYourAccount: 'Create your account',
    dashboard: 'Dashboard',
    diffDown: 'Down {value} over the last {days} day(s)',
    diffUp: 'Up {value} over the last {days} day(s)',
    edit: 'Edit',
    fields: {
      active: 'Active',
      alliance: 'Alliance',
      alliances: 'Alliances',
      character: 'Character',
      defence: 'Defence',
      description: 'Description',
      discord: 'Discord',
      editor: 'Editor',
      email: 'Email',
      group: 'Group',
      groups: 'Groups',
      image: 'Image',
      labels: 'Labels',
      language: 'Language',
      link: 'Link',
      members: 'Members',
      menu: 'Menu',
      name: 'Name',
      news: 'News',
      order: 'Order',
      password: 'Password',
      player: 'Player',
      playerAlias: 'Player alias',
      players: 'Players',
      population: 'Population',
      rank: 'Rank',
      role: 'Role',
      server: 'Server',
      servers: 'Servers',
      speed: 'Speed',
      state: 'State',
      subscriptions: 'Subscriptions',
      telegram: 'Telegram',
      timezone: 'Timezone',
      tribe: 'Tribe',
      user: 'User',
      username: 'Username',
      users: 'Users',
      village: 'Village',
      villages: 'Villages',
    },
    filterByAlias: 'Filter by alias',
    findOrCreateGroup: 'Find or create one',
    groupSettings: 'Group settings',
    hide: 'Hide',
    history: 'History',
    home: 'Home',
    identity: 'Identity',
    loading: 'Loading…',
    logIn: 'Log in',
    memberRemoved: 'Member removed.',
    membersCount: '{count} members',
    myGroups: 'Your groups',
    newBadge: 'New',
    next: 'Next',
    no: 'No',
    noEventsRecorded: 'No events recorded yet.',
    noGroupSelected: 'You have no group selected.',
    none: 'None',
    noPopulationHistory: 'No population history yet.',
    noRankedAlliances: 'No ranked alliances yet.',
    open: 'Detail',
    pickServer: 'Pick a server',
    placeholders: {
      chooseCharacter: 'Choose a character',
      searchAlliance: 'Search an alliance…',
      searchByAlias: 'Search by alias…',
    },
    populationOverTime: 'Population over time',
    previous: 'Previous',
    profile: 'Profile',
    refresh: 'Refresh',
    regenerate: 'Regenerate',
    remove: 'Remove',
    retry: 'Retry',
    roles: {
      admin: 'Admin',
    },
    save: 'Save',
    saving: 'Saving…',
    search: 'Search',
    select: 'Select',
    signUp: 'Sign up',
    sinceDate: 'since {date}',
    skipToContent: 'Skip to content',
    social: {
      discord: 'Discord',
      instagram: 'Instagram',
      telegram: 'Telegram',
    },
    table: {
      actions: 'Actions',
      delete: 'Delete {label}',
      deleteSelected: 'Delete selected',
      edit: 'Edit {label}',
      go: 'Go',
      goToPage: 'Go to page',
      next: 'Next',
      pageOf: 'Page {page} of {pages}',
      pagination: 'Pages',
      perPage: 'Per page',
      resetFilters: 'Clear filters',
      selectAll: 'Select every row on this page',
      selectedCount: '{count} selected',
      selectRow: 'Select {label}',
      totalRows: '{count} rows',
      view: 'Open {label}',
    },
    timezonePreview: 'In your timezone: {datetime}',
    unassigned: 'Unassigned',
    unknown: 'Unknown',
    validation: {
      nameRequired: 'The name is required.',
    },
    villagesCount: '{count} villages',
    yes: 'Yes',
  },
  contact: {
    channels: {
      discordHint: 'Join our server',
      instagramHint: 'Follow us',
      subtitle: 'You can also find us and write to us on our channels.',
      telegramHint: 'Join our channel',
      title: 'Other ways to reach us',
      whatsapp: 'WhatsApp',
      whatsappHint: 'Write to us on WhatsApp',
    },
    form: {
      emailHint: "We'll reply to this address.",
      message: 'Message',
      messagePlaceholder: 'Tell us everything we need to know.',
      reason: 'Reason',
      sendAnother: 'Write another message',
      sent: "Message sent, thank you! We'll get back to you as soon as possible.",
      subject: 'Subject',
      subjectPlaceholder: 'In a few words…',
      submit: 'Send message',
      title: 'Send us a message',
      tooMany: "You've sent too many messages: try again in a while.",
    },
    reasons: {
      info: 'Information',
      report: 'Report',
      suggestion: 'Suggestions',
    },
    subtitle: "Questions, problems or ideas? Write to us and we'll reply by email.",
    title: 'Contact us',
  },
  counterAttack: {
    arena: {
      label: 'Tournament square',
      level: 'Level {level}',
      none: 'None (level 0)',
      yours: 'Your tournament square',
    },
    enemy: {
      arenaHint:
        'With this troop the incoming fits a tournament square between level {min} and {max}.',
      arenaHintOne: 'With this troop the incoming fits a level {level} tournament square.',
      arrival: 'Their attack lands at',
      arrivalHint: 'Game time, in your Travick time zone ({zone}).',
      compatible: "Fit the attack's timing",
      coords: "Attacker's village",
      incoming: 'Incoming attack',
      map: {
        '1': 'Small map (+{bonus}% returning)',
        '2': 'Map (+{bonus}% returning)',
        '3': 'Large map (+{bonus}% returning)',
      },
      mapLabel: 'Hero map',
      noMap: 'No map',
      others: 'Others',
      pickIncoming: 'Pick one of your incoming attacks',
      pickTroop: 'The slowest in their army',
      title: 'Who is attacking you',
      troop: 'Attacking troop',
    },
    note: "The enemy's troops head home the moment their attack lands. An army moves at the speed of its slowest unit, hero included, and hero items only count when the hero travels with it.",
    origin: {
      boots: "Your hero's boots",
      margin: 'Land after their return by (seconds)',
      marginHint: '0 = the very second they get home. Add a second or two to be safe.',
      pickTroop: 'The slowest you send',
      title: 'Your counter-attack',
      troop: 'Your troop',
    },
    results: {
      allTroops: 'All your troops',
      enemyBack: '{troop} back home at',
      lands: 'lands at {time}',
      launchIn: 'in {time}',
      launchWith: 'Launch with {troop} at',
      needArrival: 'Enter when their attack lands.',
      needEnemyTribe: "Choose the attacker's tribe.",
      needEnemyTroop: 'Choose the troop they are attacking with.',
      needOrigin: 'Choose where your counter-attack leaves from.',
      needOwnTribe: 'Choose your tribe.',
      needOwnTroop: 'Choose your troop, or tap one below.',
      needTarget: "Enter the attacker's village to start.",
      passed: 'Launch time passed {time} ago: this troop no longer makes it.',
      passedShort: 'too late',
      returnTrip: 'return trip {time}',
      title: 'When to launch',
      travel: 'travel {time}',
    },
    subtitle:
      "On {server}: when to launch so your attack lands on the attacker's village as their troops get home.",
    subtitleNoServer:
      'No favourite world selected: enter coordinates, tribes and server speed by hand.',
    title: 'Counter-attack calculator',
    tribe: {
      auto: 'From the coordinates',
      detected: '{tribe} · {village} ({player})',
      label: 'Tribe',
      notFound: 'No known village at these coordinates: choose the tribe.',
      pick: 'Without a world the tribe cannot be looked up: choose it.',
    },
  },
  cropFinder: {
    actions: {
      collisions: 'Oasis collisions',
      delete: 'Remove from the list',
      free: 'Free',
      openMap: 'View on the game map',
      reserve: 'Reserve',
      taken: 'Taken by a non-ally',
      takenShort: 'Taken',
    },
    add: {
      description:
        "Coordinates, type and oasis bonus: the tile is added as free. You can paste (x{'|'}y) into X.",
      done: 'Tile added.',
      open: 'Add by hand',
      submit: 'Add',
      title: 'Add a tile',
    },
    collisions: {
      description:
        'Tick the tiles that compete for the same oases. Only tiles within 6 fields can share one; the collision applies to both tiles.',
      distance: '{value} fields',
      distanceOne: '{value} field',
      done: 'Oasis collisions saved.',
      none: 'No other tile of the list within 6 fields.',
      save: 'Save',
      title: 'Oasis collisions · {tile}',
      with: 'Shares oases with {tiles}',
    },
    columns: {
      oasis: 'Oasis bonus',
      sector: 'Sector',
      status: 'Status',
      tile: 'Tile',
      type: 'Type',
    },
    confirm: {
      cancelsReservation:
        'The reservation for {player} is cancelled and the channels are notified.',
      delete: {
        body: 'The tile {tile} leaves the crop finder; pasting it again adds it back.',
        confirm: 'Yes, remove it',
        done: '{tile} removed.',
        title: 'Remove the tile?',
      },
      free: {
        body: 'The tile {tile} goes back to free.',
        confirm: 'Yes, free it',
        done: '{tile} is free again.',
        title: 'Free the tile?',
      },
      taken: {
        body: 'The tile {tile} is marked as taken by a player outside the group and its alliances.',
        confirm: 'Yes, mark it',
        done: '{tile} marked as taken by a non-ally.',
        title: 'Taken by a non-ally?',
      },
    },
    count: '{count} tiles',
    countOne: '{count} tile',
    empty: "No tile yet: paste a page of the game's crop finder or add one by hand.",
    emptyFiltered: 'No tile matches the filters.',
    errors: {
      alreadyPresent: 'This tile is already in the crop finder.',
      alreadyReserved: '{reserved_by} already reserved this tile.',
      noServer: 'The group has no game world.',
      notActive: 'This reservation has already expired, been cancelled or been confirmed.',
      notFree: 'Only a free tile can be reserved: reload the page.',
      notReserved: 'The tile is no longer reserved: reload the page.',
      outOfMap: 'Outside the map: coordinates go from -{radius} to {radius}.',
      playerNotAllowed: 'That player is neither a member of the group nor in one of its alliances.',
      tileOccupied:
        '{village} is already there, according to the world data: mark the tile as taken.',
      tooFar: 'Only tiles of the list within {range} fields can share an oasis.',
    },
    fields: '{count}c',
    filters: {
      allSectors: 'All',
      allTypes: '15c and 9c',
      ally: 'Held by allies',
      anyOasis: 'Any',
      atLeast: 'At least +{value}%',
      clear: 'Reset filters',
      flagAll: 'All',
      flagNo: 'Hide',
      flagYes: 'Only these',
      label: 'Filters',
      player: 'Reserved for',
      playerPlaceholder: 'Name of the player the tile is reserved for',
      reserved: 'Reserved',
      taken: 'Taken by non-allies',
    },
    map: {
      collisions: 'Oasis collision',
      dotHint: 'dot = 15c · click a free tile to reserve it',
      empty: 'No tile to show on the map yet.',
      emptyFiltered: 'No tile on the map matches the filters.',
      hide: 'Hide',
      show: 'Show',
      title: 'Map',
    },
    markedBy: 'marked by {name} on {date}',
    notAllowed: 'Only the group admin can open the crop finder.',
    note: {
      description:
        'Note of the reservation for {player}. Empty it to remove it; the channels are not notified.',
      done: 'Note saved.',
      hint: 'Also shown in Reservations.',
      label: 'Note',
      open: 'See the note',
      save: 'Save',
      title: 'Note · {tile}',
    },
    paste: {
      description: 'Tiles already in the list are not added again; the distance is not saved.',
      hint: '{count} tiles recognised.',
      hintOne: '{count} tile recognised.',
      includeOccupied: 'Also load occupied tiles',
      includeOccupiedHint:
        "Off: free tiles only. On: those of a member or of one of the group's alliances become “held by an ally”, the others “taken by a non-ally”.",
      label: 'Crop finder page',
      notRecognized:
        "This doesn't look like the crop finder page: copy the whole page from the game.",
      open: 'Paste from the game',
      placeholder: 'Paste the copied page here',
      result: {
        ally: '{count} held by allies',
        allyOne: '{count} held by an ally',
        duplicates: '{count} already in the list',
        duplicatesOne: '{count} already in the list',
        free: '{count} free',
        freeOne: '{count} free',
        nextPage: 'You can paste the next page right away.',
        none: 'No tile found in the pasted page.',
        outOfMap: '{count} outside the map',
        outOfMapOne: '{count} outside the map',
        skippedOccupied: '{count} occupied, skipped',
        skippedOccupiedOne: '{count} occupied, skipped',
        summary: '{found} tiles read, {inserted} added.',
        taken: '{count} taken by non-allies',
        takenOne: '{count} taken by a non-ally',
      },
      step1: 'In the game open the 9/15 crop finder (cropfinder.php) and run the search you want.',
      step2: 'Select the whole page (Ctrl+A / Cmd+A) and copy it.',
      step3: 'Paste it here and send. The game shows 50 tiles per page: repeat for every page.',
      submit: 'Load',
      submitting: 'Loading…',
      title: 'Paste the crop finder',
    },
    reserve: {
      ally: 'Ally',
      change: 'Choose another player',
      description: "Choose a group member or a player of one of the group's alliances.",
      done: '{tile} reserved for {player}.',
      member: 'Member',
      members: 'Group members',
      narrow: '{count} players: type to narrow the list.',
      noExpiry:
        "It doesn't expire: it shows up in Reservations and the channels are notified. Freeing the tile here cancels it.",
      noPlayers: 'No player found.',
      note: 'Note (optional)',
      noteHint: 'Shown in Reservations and here with the note icon, where you can edit it.',
      player: 'Player',
      search: 'Search',
      searchPlaceholder: 'Type a name or an alliance tag',
      submit: 'Reserve',
      submitFor: 'Reserve for {player}',
      title: 'Reserve {tile}',
    },
    sectors: {
      ne: 'North-east',
      nw: 'North-west',
      se: 'South-east',
      sw: 'South-west',
    },
    status: {
      ally: 'Held by an ally',
      free: 'Free',
      reserved: 'Reserved',
      taken: 'Taken by a non-ally',
    },
    subtitle:
      "15c and 9c of {group}: paste them from the game's crop finder, reserve the free ones for members and allies.",
    title: 'Crop finder',
  },
  cropOrder: {
    autosave: {
      failed: 'Not saved',
      retry: 'Retry',
      saved: 'Saved',
      saving: 'Saving…',
    },
    catchUp: {
      body: 'Steps before #{number} still to do: {count}. Mark them as done too?',
      confirm: 'Mark them',
      dismiss: 'No',
    },
    confirmSettings: {
      body: 'With these settings the order of the steps changes: the ticked steps ({count}) would be cleared.',
      confirm: 'Change and reset',
      title: 'Change the village?',
    },
    list: {
      allDone: 'Every step is done.',
      hideDone: 'Hide done',
      markDone: 'Step {number} done',
      nextBadge: 'Next',
      payback: 'Pays back in {days} days',
      production: '{value}/h (+{delta})',
      reset: 'Reset progress',
      run: '{index} of {count}',
      showDone: 'Show done',
      title: 'Build order',
    },
    next: {
      completeBody: 'Every step is ticked off: the village has nothing left to build for crop.',
      completeTitle: 'Plan completed',
      done: 'Done',
      title: 'Next step · #{number}',
    },
    plans: {
      badge: '{count}/{max}',
      capital: 'Capital {fields}c',
      close: 'Close plan',
      closeDialog: 'Close',
      confirmDelete: 'Delete "{name}" and its progress?',
      count: 'Plans used: {count} of {max}.',
      current: 'Plan:',
      delete: 'Delete',
      empty: 'No saved plans yet.',
      errors: {
        limitReached: 'You already have {max} saved plans: overwrite or delete one.',
        nameRequired: 'Enter a name.',
        tooLarge: 'This plan is too large to be saved.',
      },
      gone: 'The plan was deleted elsewhere: the progress is still on this page, save it again to keep it.',
      limitHint:
        'You already have {max} plans: use the name of one to overwrite it, or delete one.',
      load: 'Open',
      loaded: 'Plan "{name}" opened.',
      loading: 'Loading plans…',
      nameLabel: 'Name',
      namePlaceholder: 'e.g. Capital 15c',
      open: 'In use',
      openList: 'My plans',
      overwrite: 'Overwrite',
      overwriteHint: 'A plan with this name exists: it will be overwritten.',
      progress: '{done} of {total} steps',
      save: 'Save',
      saved: 'Plan "{name}" saved.',
      saveDescription:
        'Village settings and ticked steps are saved on your account, up to {max} plans: one per village.',
      saveTitle: 'Save plan',
      title: 'Saved plans',
      unreadable: "This plan can't be read.",
      updated: 'Plan "{name}" updated.',
      village: 'Village {fields}c',
    },
    reset: {
      body: 'The ticked steps ({count}) will be cleared from this plan.',
      confirm: 'Reset',
      title: 'Reset progress?',
    },
    settings: {
      capital: 'Capital',
      capitalHint: 'Fields go up to level 20.',
      egyptian: 'Egyptian tribe',
      egyptianHint: 'Adds the waterworks: +5% to the bonus of the captured oases for each level.',
      fields: 'Crop fields',
      goldBonus: '+25% production with gold',
      goldBonusHint: 'Changes production and payback days, not the order.',
      oases: 'Crop oases to capture',
      oasesHint:
        "The order doesn't matter: they are taken from the best one. Hero's mansion at 10, 15 and 20 for the first, second and third.",
      oasis: 'Oasis {number}',
      otherVillage: 'Other village',
      otherVillageHint: 'Outside the capital fields stop at level 10.',
      title: 'Your village',
      village: 'Village type',
    },
    state: {
      bakery: 'Bakery {level}',
      fields: 'Fields {levels}',
      heroMansion: 'Mansion {level}',
      mill: 'Mill {level}',
      waterworks: 'Waterworks {level}',
    },
    steps: {
      bakery: 'Bakery to level {level}',
      field: 'Crop field from {from} to {to}',
      mill: 'Grain mill to level {level}',
      oasis: "Hero's mansion to level {level} and capture the {bonus}% oasis",
      rush: {
        bakery: 'Unlocks the bakery',
        mill: 'Unlocks the mill',
      },
      waterworks: 'Waterworks to level {level}',
    },
    subtitle:
      'In which order to upgrade crop fields, grain mill, bakery, oases and waterworks so that every resource spent pays back as soon as possible.',
    summary: {
      label: 'Plan summary',
      loginToTrack: 'Sign in to track your progress.',
      production: 'Crop production',
      progress: 'Completed',
      saveToTrack: 'Save the plan to tick off the steps.',
      steps: 'Steps',
    },
    title: 'Crop build order',
    track: {
      login: 'Sign in to save this plan and tick off the steps as you complete them.',
      loginButton: 'Sign in',
      save: 'Save this plan with a name to tick off the steps as you complete them: progress is saved automatically.',
      saveButton: 'Save plan',
    },
  },
  dashboard: {
    account: {
      noSubscriptions: 'No active subscription',
      notVerified: 'Not verified',
      subscriptions: 'Active subscriptions',
      title: 'Account',
      verified: 'Verified',
    },
    activeGroup: {
      role: 'Your role',
      title: 'Active group',
    },
    group: {
      activity: {
        defCalls: 'Active wall calls',
        enemies: 'Tracked enemy armies',
        incomings: 'Attacks on you',
        nextArrival: 'next at {time}, {when}',
        plans: 'Your attack plans',
        push: 'Push requests',
        pushMissing: 'below quota in {count}',
        pushMissingOne: 'below quota in 1',
        recapIncomings: 'Attacks on the group',
        reservations: 'Reservations',
        title: 'Open activities',
      },
      find: 'Find a group',
      members: 'Members',
      stats: {
        members: 'Members',
        population: 'Population',
        since: 'Member since',
        villages: 'Villages',
      },
      title: 'Your group',
      troops: {
        aria: '{fresh} updated in the last 24 hours, {stale} older, {never} never declared',
        fresh: 'Last 24 hours: {count}',
        never: 'Never: {count}',
        stale: 'Older: {count}',
        summary: '{fresh} of {members} updated in the last 24 hours',
        title: "Members' troops",
      },
    },
    hero: {
      counters: {
        characters: 'Characters',
        groups: 'Groups',
        worlds: 'Worlds',
      },
      day: 'day {day}',
      subtitle: 'Here is where you stand today.',
      subtitleNoServer: 'Follow a world and claim your character to get started.',
    },
    loadFailed: 'The summary could not be loaded.',
    noGroup: {
      body: 'Join a confederation with an invite key, or create your own, to unlock coordination tools.',
      title: 'You have no active group',
    },
    onboarding: {
      progress: '{done} of {total}',
      steps: {
        group: {
          body: 'Apply to your confederation, use an invite key or create one.',
          cta: 'Groups',
          title: 'Join a group',
        },
        player: {
          body: 'Tell Travick which character is yours on that world.',
          cta: 'Profile',
          title: 'Claim your character',
        },
        server: {
          body: 'Add the world you play on to your favourites.',
          cta: 'Worlds',
          title: 'Follow your world',
        },
        troops: {
          body: 'Paste the troops overview: your group can plan with your army.',
          cta: 'Your villages',
          title: 'Declare your troops',
        },
      },
      title: 'Get started',
    },
    player: {
      detail: 'Details',
      diffDown: 'Down {value} since yesterday',
      diffUp: 'Up {value} since yesterday',
      empty: {
        body: 'Claim your character from your profile: your stats and troops will show up here.',
        cta: 'Claim your character',
        noServerBody:
          'Add the world you play on to your favourites: it becomes the world of the header.',
        noServerCta: 'Browse worlds',
        noServerTitle: 'You follow no world yet',
        title: 'No character on {server}',
      },
      stats: {
        population: 'Population',
        rank: 'Rank',
        villages: 'Villages',
      },
      title: 'Your character',
      troops: {
        declared: '{total} troops declared in {declared} of {villages} villages',
        farmLists: '{count} farm lists, last paste {when}',
        farmListsCount: '{count} farm lists',
        farmListsCountOne: '1 farm list',
        farmListsOne: '1 farm list, last paste {when}',
        never: 'You have not declared your troops yet: your group cannot count on them.',
        openFarmLists: 'Farm lists',
        smithy: 'Smithy updated {when}',
        smithyNever: 'Smithy never declared',
        state: {
          aging: 'To update',
          fresh: 'Up to date',
          never: 'Never declared',
          stale: 'Out of date',
        },
        title: 'Your troops',
        update: 'Update troops',
        updated: 'Last updated {when}',
      },
    },
    quickLinks: {
      empty: 'No tools available yet for your role.',
      title: 'Your tools',
    },
    retry: 'Retry',
    roles: {
      admin: 'Administrator',
      def: 'Defence Leader',
      member: 'Member',
      off: 'Offender Leader',
    },
    server: {
      artefacts: 'Artefacts',
      browse: 'Browse worlds',
      closed: 'Ended',
      detail: 'Details',
      empty: 'Pick a world in the header to see how its round is going.',
      endsOn: 'Ends on {date}',
      fixed: 'Fixed end date',
      gameDay: 'day of the round',
      inDays: 'In {count} days',
      inDaysOne: 'Tomorrow',
      plans: 'Construction plans',
      released: 'Released',
      title: 'The world',
      today: 'Today',
      wonder: 'Highest wonder',
      ww: 'Wonder of the World',
    },
    welcome: 'Welcome, {name}',
    welcomeAnonymous: 'Welcome',
  },
  defCalls: {
    actions: {
      close: 'Close call',
      confirm: 'Confirm defense sent',
      declarations: 'See declarations',
      delete: 'Delete',
      edit: 'Edit',
      more: 'More actions',
      reopen: 'Reopen call',
      send: 'Send defense',
      senders: 'Who sent',
      troops: 'See my troops',
    },
    add: 'New def call',
    associatedBadge: 'From {group}',
    closed: 'Def call closed.',
    closedBadge: 'Closed',
    columns: {
      count: 'Def count',
      crop: 'Crop',
      deadline: 'Deadline',
      defense: 'Defense requested',
      note: 'Notes',
      priority: 'Priority',
      village: 'Village',
    },
    confirm: {
      declaredBy: 'declared by {user}',
      description: 'Tell the group how much defense you sent to {village}.',
      history: 'Already declared',
      me: '{alias} (you)',
      none: 'Nobody has declared anything yet.',
      noTribe: "This player's tribe is unknown: their troops can't be listed.",
      player: 'Sent by',
      playerHint: 'Pick another member if you are recording it on their behalf.',
      remove: 'Remove',
      removed: 'Declaration removed.',
      saved: 'Defense recorded.',
      submit: 'Confirm',
      title: 'Confirm defense sent',
      total: 'Def count: {count}',
      troops: 'Troops sent',
      troopsHint:
        'Only the troops that count on a def call: no scouts, rams, catapults, chiefs or settlers.',
      upkeep: 'upkeep {count}',
    },
    created: 'Def call created: the group has been notified.',
    deadline: {
      between: 'Between',
      by: 'By',
      exact: 'Exactly at',
      expired: 'Expired',
    },
    defenseTypes: {
      anti_cavalry: 'Anti-cavalry only',
      anti_infantry: 'Anti-infantry only',
      any: 'Any',
    },
    deleteConfirm: {
      body: 'The call and every defense declared on it are removed for everyone, associated groups included.',
      title: 'Delete this def call?',
    },
    deleted: 'Def call deleted.',
    detail: {
      back: 'All def calls',
      calledBy: 'Called by',
      closedAt: 'Closed on',
      createdAt: 'Created',
      info: 'Details',
      manage: 'Manage',
      noDeadline: 'Permanent wall: no deadline.',
      open: 'Open details',
      status: {
        active: 'Active',
      },
      timeLeft: 'Time left',
    },
    empty: 'No active call of this type.',
    emptyClosed: 'No closed call of this type.',
    errors: {
      callClosed: 'This call has been closed by its coordinators.',
      callExpired: 'The deadline of this call has passed: no more defense can be declared.',
      deadlinePast: 'The arrival time is already past.',
      deadlineRequired: 'This kind of call needs an arrival time.',
      invalidTroops: "Those troops can't be declared on a def call for this tribe.",
      invalidWindow: 'The start of the window comes after its end.',
      noServer: 'The group has no game world.',
      notMember: 'That player is not a member of your group.',
      noTroops: 'Declare at least one troop.',
      permanentHasNoDeadline: 'A permanent def call has no deadline to arrive by.',
      villageNotFound: 'No village of this world at those coordinates.',
    },
    form: {
      arriveBy: 'Arrive by',
      arriveFrom: 'Not before',
      arriveTo: 'Not after',
      create: 'Create and notify',
      defense: 'Defense requested',
      fromIncoming: 'From the attack landing on {village} at {time}.',
      needsCrop: 'Crop needed',
      note: 'Notes',
      notePlaceholder: "Who's attacking, what to send, where to hold back…",
      options: 'Requirements',
      priority: 'Priority',
      required: 'Requested count',
      requiredHint: 'Total in crop upkeep of the troops: 500 units eating 2 crop count 1,000.',
      timeZone: 'Times in your Travick timezone ({zone}), to the second.',
      titleEdit: 'Edit def call',
      titleNew: 'New def call',
      type: 'Type of def call',
      typeHints: {
        between: 'Defense must land between two times. Fill in only one for an exact time.',
        normal: 'Defense must land before the deadline.',
        permanent: 'No deadline: the call stays open until the count is reached.',
      },
      village: 'Village to defend',
      villageHint:
        "Coordinates of any village of this world, even outside the group. Paste x{'|'}y into either box.",
    },
    fromIncoming: 'Create a def call from this attack',
    no: 'No',
    notConfirmable: 'This call has expired or been closed: no more defense can be declared.',
    notVisible: "This def call can't be seen from the selected group.",
    priorities: {
      high: 'High',
      low: 'Low',
      medium: 'Medium',
      urgent: 'Urgent',
    },
    reached: 'Count reached',
    remaining: '{count} missing',
    reopened: 'Def call reopened.',
    senders: {
      declarations: '{count} sends',
      declarationsOf: 'Sends of {alias}',
      declarationsOne: '1 send',
      remove: 'Remove a send of {alias}',
      title: 'Who sent',
    },
    showClosed: 'Show closed calls',
    subtitle: 'Def calls for {group} and the associated groups that share theirs.',
    tabsLabel: 'Call type',
    title: 'Defense calls',
    troops: {
      add: 'Add',
      addAll: 'Add all in time',
      added: 'Added',
      addedToast: 'Added to the def call: {amount} crop upkeep.',
      addOne: 'Add {count} {troop} to the def call',
      arenaHint: 'With tournament square {level} it would make it: leave by {time}',
      departAt: 'leave at {time}',
      departBetween: 'leave between {from} and {to}',
      departBy: 'leave by {time}',
      description:
        "Your declared defensive troops, timed as if they left now, with each village's tournament square.",
      empty: 'None of your villages has declared defensive troops.',
      hero: 'Hero',
      heroKind: {
        pennant: 'Hero with pennant (between your own villages)',
        standard: 'Hero with standard (to villages of your alliance)',
      },
      heroNone: 'Without hero',
      heroNote: 'Times assume the troops travel with the hero and he is not slower than them.',
      heroTier: 'Tier {tier}',
      heroUnavailable:
        'No hero item speeds your troops up towards this village: it is neither yours nor of a member of your alliance.',
      late: 'Too late',
      noTarget: "The village to defend has no coordinates yet: travel times can't be computed.",
      onlySide: 'Only troops matching the call: {side}.',
      refresh: 'Recompute from now',
      summary: '{inTime} villages in time, {late} too late',
      title: 'Your troops for {village}',
      travel: 'Travel {time}',
    },
    types: {
      between: 'Ninja',
      normal: 'Normal',
      permanent: 'Permanent',
    },
    updated: 'Def call updated.',
    yes: 'Yes',
  },
  defCallStats: {
    columns: {
      amount: 'Defense sent',
      average: 'Per def call',
      declarations: 'Declarations',
      last: 'Last time',
      participation: 'Participation',
      player: 'Player',
      share: 'Group share',
      walls: 'Def calls',
    },
    details: {
      byType: 'By def call type',
      hide: 'Hide details',
      noTroops: 'No troops declared.',
      show: 'Details',
      troops: 'Troops sent',
    },
    empty: 'No def call of this type in the period.',
    emptyPlayers: 'No player to show.',
    former: 'Former member',
    formerHint: 'Left the group: no participation rate, only what they sent.',
    highlights: {
      mostPresent: 'Most present',
      mostSent: 'Most defense sent',
      never: 'Never answered',
      neverNone: 'Every member answered at least one def call.',
      presence: '{walls} of {eligible} def calls',
      sent: '{amount} crop upkeep',
    },
    joinedAt: 'In the group since {date}',
    kpi: {
      amount: 'Defense sent',
      amountHint: '{percent} of what was requested',
      average: 'Average participation',
      averageHint: 'per member, on the def calls since they joined',
      covered: 'Answered',
      coveredHint: '{count} of {total} def calls with our defense',
      participants: 'Players',
      participantsHint: 'out of {total} members',
      walls: 'Def calls',
      wallsHint: '{required} defense requested',
    },
    legend:
      'Participation = def calls answered out of those created since the player joined the group, not counting def calls on their own villages. Def calls include those of the associated groups that share theirs; only defense declared from this group counts, credited to whoever sent the troops, in crop upkeep.',
    never: 'Never',
    notAllowed: "Only the group's admins and Defence Leaders can see the def call stats.",
    period: {
      '7': '7 days',
      '30': '30 days',
      '90': '90 days',
      all: 'All',
      custom: 'Custom',
      from: 'From',
      invalid: 'The first day comes after the last one.',
      label: 'Period',
      to: 'To',
    },
    showFormer: 'Show former members',
    sortBy: 'Sort by',
    subtitle: 'How the players of {group} answer the defense calls.',
    title: 'Def call stats',
    types: {
      total: 'All',
    },
    typesLabel: 'Def call type',
    wallsOf: '{walls} of {eligible} def calls',
    wallsOnly: '{walls} def calls',
  },
  errors: {
    forbidden: 'You are not allowed to do that.',
    network: 'Cannot reach the server. Check your connection.',
    server: 'Server error. Please try again later.',
    sessionExpired: 'Your session has expired. Please log in again.',
    timeout: 'The server took too long to answer. Try again.',
    unexpected: 'Something went wrong.',
  },
  farmList: {
    advice: {
      allGood: 'Nothing to fix: your lists look well tuned.',
      disabled: {
        body: 'The village changed owner: the game no longer raids it. Remove it from the list, or check the new owner before re-enabling it.',
        title: '{count} targets disabled by the game',
        titleOne: '1 target disabled by the game',
      },
      duplicate: {
        body: 'The same village is in more than one list or row: the second raid finds the resources already taken. Keep it once with the right troops.',
        title: '{count} duplicated targets',
        titleOne: '1 duplicated target',
      },
      empty: {
        body: 'Troops come back empty: someone else farms it, or it produces too little. Raid it less often or remove it and use those troops elsewhere.',
        title: '{count} targets that bring nothing',
        titleOne: '1 target that brings nothing',
      },
      full: {
        body: 'Troops come back full: the target had more. Add troops to these rows or raid them more often.',
        title: '{count} targets with full troops',
        titleOne: '1 target with full troops',
      },
      losses: {
        body: 'Some troops died: there are traps or defence. Check whether the bounty is worth the losses, or send more troops.',
        title: '{count} raids won with losses',
        titleOne: '1 raid won with losses',
      },
      lost: {
        body: 'Your troops died on the last raid: the target is defended. Remove it or scout it before sending again.',
        title: '{count} raids lost',
        titleOne: '1 raid lost',
      },
      never: {
        body: 'No raid recorded yet: newly added targets, or the list is never started.',
        title: '{count} targets never raided',
        titleOne: '1 target never raided',
      },
      oversized: {
        body: 'The expected bounty fills less than a third of what the troops can carry: send the suggested amount and use the rest on new targets.',
        title: '{count} targets with too many troops',
        titleOne: '1 target with too many troops',
      },
      perHourInvolved: 'Estimated {value} resources/hour involved',
      show: 'Show',
      slowCycle: {
        body: "At the click the village doesn't have the troops at home to send them: theirs are still travelling and there are no spare ones. Enter the village's troops in the list card, train more, or move these targets to a list clicked less often.",
        title: '{count} targets slower than your clicks',
        titleOne: '1 target slower than your clicks',
        undeclared:
          '{count} of them in villages without troops entered: if you have more than the list uses, they leave at every click.',
        undeclaredOne:
          '1 of them in a village without troops entered: if you have more than the list uses, it leaves at every click.',
      },
      stale: {
        body: 'The last raid is old: troops were missing when you clicked, or the list is no longer used. Check troops or remove the target.',
        title: '{count} targets not raided for days',
        titleOne: '1 target not raided for days',
      },
      title: 'Where to improve',
      troopsSaved: 'About {count} troops to free up for other targets',
    },
    bountySource: {
      game: 'game average',
      last: 'last raid',
      observed: 'observed average',
    },
    clear: {
      body: 'Lists, targets and the observed raid history of this character on this world will be deleted. Your lists in the game are not touched.',
      confirm: 'Delete',
      done: 'Farm list data deleted.',
      open: 'Delete data',
      title: 'Delete the farm list data?',
    },
    empty: {
      body: 'Open the rally point in the game, go to the Farm list tab and paste the page here: the statistics start from the first paste.',
      noPlayer:
        'Claim your character on {server} from your profile: farm lists belong to your character.',
      title: 'No farm list yet',
    },
    history: {
      collapsed: '{count} collapsed',
      collapsedHint: 'Lists pasted collapsed: their targets were not read.',
      lists: 'Lists',
      newBounty: 'New bounty',
      newRaids: 'New raids',
      targets: 'Targets',
      toggle: 'Paste history',
      when: 'When',
    },
    issues: {
      disabled: {
        hint: 'Disabled by the game after an owner change.',
        short: 'Disabled',
      },
      duplicate: {
        hint: 'Same village in more than one row.',
        short: 'Duplicate',
      },
      empty: {
        hint: 'Raids come back empty.',
        short: 'Empty',
      },
      full: {
        hint: 'Troops come back full: there was more to take.',
        short: 'Full',
      },
      losses: {
        hint: 'Last raid won with losses.',
        short: 'Losses',
      },
      lost: {
        hint: 'Last raid lost: the troops died.',
        short: 'Lost',
      },
      never: {
        hint: 'No raid recorded for this target.',
        short: 'Never raided',
      },
      oversized: {
        hint: 'The expected bounty fills less than a third of the capacity.',
        short: 'Too many troops',
      },
      slowCycle: {
        hint: "At some clicks the village doesn't have the troops to send it: its own are still out.",
        short: 'Skips clicks',
      },
      stale: {
        hint: 'Not raided for at least two days.',
        short: 'Stale',
      },
    },
    lastUpdate: 'Last update: {when}',
    lists: {
      arena: 'Tournament square',
      arenaHint:
        'Level of the tournament square of this village: it speeds up the trip beyond 20 fields. Remembered in this browser.',
      bountyPerClick: 'Bounty / capacity per click',
      fill: 'Fill',
      interval: 'Click interval',
      intervalPlaceholder: 'e.g. 30',
      longestTrip: 'Longest round trip',
      minutes: 'minutes',
      missing: '{missing} targets more in the game than read: expand the list and paste again.',
      neverExpanded: 'This list was never pasted expanded: its {declared} targets are missing.',
      perHour: 'Resources/hour',
      seenAt: 'Targets read: {when}',
      showTargets: 'Targets',
      targets: 'Active targets',
      title: 'Lists',
      troops: 'Troops',
      unknownVillage: 'Unknown village',
    },
    needsExpand:
      '{count} lists were collapsed in the last paste: their targets are missing or out of date. Expand every list before copying the page.',
    needsExpandOne:
      '1 list was collapsed in the last paste: its targets are missing or out of date. Expand every list before copying the page.',
    paste: {
      description:
        'Travick reads lists, targets, last raids and bounties from the page, and counts the raids made since your previous paste.',
      errors: {
        notYourVillages:
          "This farm list is not your character's on this world: none of its source villages is one of your villages. Copy the page from your own account, on the world selected at the top.",
      },
      expandWarning:
        'Lists must be expanded: the game loads the targets of a list only when you open it. Collapsed lists keep the data of the last time they were pasted open.',
      firstImport: 'Farm lists imported: paste them again later to measure the raids in between.',
      hint: 'Found {lists} lists and {targets} targets in the pasted page.',
      label: 'Farm list page',
      newRaids:
        'Farm lists updated: {count} new raids, {bounty} resources since the previous paste.',
      newRaidsOne: 'Farm lists updated: 1 new raid, {bounty} resources since the previous paste.',
      notRecognized:
        'This does not look like the farm list page: paste the rally point page, Farm list tab, copied from the browser.',
      open: 'Update farm lists',
      placeholder: 'Paste here (Ctrl+V / Cmd+V)',
      result: {
        collapsed:
          '{count} lists were collapsed: their targets were not updated. Expand them in the game and paste again.',
        collapsedOne:
          '1 list was collapsed: its targets were not updated. Expand it in the game and paste again.',
        noLists: 'No farm list found in the pasted page.',
        removed: 'Deleted in the game, removed here too: {names}',
        skipped:
          '{count} lists skipped: their source village is not one of your villages on this world. If you founded, conquered or renamed it today, it will be recognized after the next nightly update.',
        skippedOne:
          '1 list skipped: its source village is not one of your villages on this world. If you founded, conquered or renamed it today, it will be recognized after the next nightly update.',
        summary: '{lists} lists read, {updated} open with {targets} targets updated.',
        villagesFound: 'Source villages in the page: {names}',
      },
      step1: 'In the game, with your account on this world, open the rally point, Farm list tab.',
      step2:
        'Expand ALL the lists (arrow on the right of each list): a collapsed list has no targets in the page.',
      step3: 'Select the whole page (Ctrl+A / Cmd+A) and copy it.',
      step4: 'Paste it in the box below and confirm.',
      submit: 'Import',
      submitting: 'Importing…',
      title: 'Paste the farm list page',
    },
    results: {
      losses: 'Won with losses',
      lost: 'Lost',
      won: 'Won without losses',
    },
    settings: {
      applied: 'Interval saved on every list.',
      applyAll: 'Apply to all lists',
      interval: 'How often do you click the farm lists?',
      intervalHint:
        'With the interval Travick knows when troops are still out at your next click, and how often each target is really raided. Without it the estimates assume you resend as soon as troops are back (theoretical max). You can also set it list by list below.',
      withoutInterval: '{count} lists have no interval: their estimates are the theoretical max.',
      withoutIntervalOne: '1 list has no interval: its estimates are the theoretical max.',
    },
    subtitle:
      'Paste your rally point farm lists: Travick works out what each target yields, where troops are wasted and how to raid better. Every new paste updates the statistics.',
    summary: {
      bountyPerRaid: 'Average bounty per raid',
      fillShares: 'Last raid: {full} full, {empty} empty',
      losses: '{count} targets with losses',
      lossesOne: '1 target with losses',
      noLosses: 'No losses on the last raids',
      observed:
        'Observed by Travick across your pastes: {raids} raids, {bounty} resources (since {since}).',
      perDay: '≈ {value} per day',
      perHour: 'Resources per hour',
      targets: 'Active targets',
      targetsHint: '{total} targets in {lists} lists',
      theoretical: 'theoretical max where no click interval is set',
      troops: 'Troops per click',
    },
    targets: {
      allIssues: 'All targets',
      allLists: 'All lists',
      columns: {
        cycle: 'Every',
        distance: 'Dist.',
        expected: 'Expected',
        fill: 'Fill',
        issues: 'Issues',
        lastBounty: 'Last bounty',
        lastRaid: 'Last raid',
        perHour: 'Res/h',
        perTroop: 'Res/h per troop',
        roundTrip: 'Round trip',
        target: 'Target',
        troops: 'Troops',
      },
      count: '{shown} of {total} targets',
      daysAgo: '{days} d ago',
      empty: 'No target matches the filters.',
      everyClicks: '{duration} (1 click in {clicks})',
      issue: 'Issue',
      list: 'List',
      openReport: 'Open the report in the game',
      searchPlaceholder: "Village, player, alliance or x{'|'}y",
      suggested: 'Suggested: {count}',
      title: 'Targets',
      today: 'today',
      withIssues: 'With an issue',
      withoutIssues: 'Without issues',
    },
    title: 'Farm lists',
    villageTroops: {
      covered: 'Enough to send every target at every click.',
      hint: 'At every click the game sends each target the village has the troops for at home, even while the previous raid is still travelling. Here: how many are needed so that every target leaves at every click, against those you own. Enter the village total, including the ones out raiding: they are the same troops as in Your villages.',
      inputLabel: '{troop} owned in {village}',
      missing: '{count} missing',
      openOverview: 'Open Your villages',
      partial: 'Enough for about {percent} of the clicks: some targets will be skipped.',
      placeholder: 'Owned',
      required: 'needed {count}',
      title: 'Troops in the village',
      undeclared:
        "Enter the village's troops: if you have more than the lists use, the far targets leave at every click anyway.",
      unresolved:
        "Village not recognised among yours (renamed, or two with the same name): its troops can't be entered.",
    },
  },
  groupCandidates: {
    actions: {
      accept: 'Accept',
      accepted: 'Candidacy accepted.',
      refuse: 'Refuse',
      refused: 'Candidacy refused.',
    },
    bulk: {
      accept: 'Accept selected',
      partialFailure: '{failed} of {total} could not be processed.',
      refuse: 'Refuse selected',
      refuseConfirmMessage: '{count} candidacies will be refused. This cannot be undone.',
      refuseConfirmTitle: 'Refuse candidacies',
      success: 'Done.',
    },
    columns: {
      appliedAt: 'Applied on',
      decidedAt: 'Decided on',
      status: 'Status',
    },
    empty: 'No candidacies found.',
    history: {
      accepted: 'Accepted',
      all: 'All',
      refused: 'Refused',
    },
    notAdmin: "Only the group's admins can review candidacies.",
    note: {
      title: "{name}'s note",
      view: 'View note',
    },
    tabs: {
      history: 'History',
      pending: 'Pending',
    },
    title: 'Candidacies',
  },
  groupDiscord: {
    disconnected: 'Discord bot disconnected.',
    errors: {
      generic: 'Something went wrong while connecting to Discord.',
      guild_already_linked: 'That Discord server is already connected to another group.',
      invalid_state: 'The connection request expired, please try again.',
    },
    events: {
      channel: 'Channel',
      discordErrorTitle: "Couldn't read channels/roles from Discord",
      empty: 'No event has been configured by the site admins yet.',
      enabled: 'Enabled',
      mentionRole: 'Mention roles',
      mentionRoleInfo:
        "Optional: pick one or more Discord roles to ping (e.g. {'@'}Defense) whenever this event is sent. Leave empty to just post the message.",
      mentionRoleInfoLabel: 'What is this for?',
      noChannel: 'No channel',
      noRole: 'No role',
      rolesSelected: '{count} roles',
      subtitle: 'Choose a channel (and, optionally, one or more roles to mention) for each event.',
      title: 'Events',
    },
    link: {
      connect: 'Add bot to a Discord server',
      connectedAt: 'Connected on {date}',
      disconnect: 'Disconnect',
      disconnectConfirmBody:
        'The bot will leave the Discord server and every channel/role you configured for this group will be forgotten.',
      disconnectConfirmTitle: 'Disconnect the Discord bot?',
      empty: 'No Discord server connected yet.',
      title: 'Connection',
    },
    linked: 'Discord server connected.',
    saved: 'Settings saved.',
    subtitle: 'Connect a Discord server and choose where each event is sent.',
    title: 'Discord bot',
  },
  groupMembers: {
    associated: {
      empty: 'No members shared yet.',
      hint: 'Members of this allied group, read-only.',
    },
    columns: {
      groupRole: 'Group role',
      joinedAt: 'Joined on',
      tacticalRole: 'Role',
      troopsNeverUpdated: 'Never',
      troopsUpdatedAt: 'Troops last updated',
    },
    empty: 'No members found.',
    filters: {
      anyTacticalRole: 'Any role',
      groupRoleHint: 'Selecting more than one narrows to members who have all of them.',
      name: 'Filter by username',
    },
    map: {
      empty: 'No claimed village to show yet.',
      hide: 'Hide map',
      legend: {
        own: 'Your group',
      },
      show: 'Show map',
    },
    missingAliases: {
      empty: 'Nothing to compare: no allowed alliances, and no member belongs to one.',
      hide: 'Hide missing aliases',
      hintGroupAlliances: "Compared against the group's allowed alliances:",
      hintMembersAlliances:
        'No allowed alliances configured — comparing against the alliance(s) of current members:',
      noneMissing: 'Every alias from these alliances is already in the group.',
      show: 'Show missing aliases',
    },
    notAdmin: "Only the group's admins can manage its members.",
    remove: {
      confirmMessage: '{name} will be removed from the group. This cannot be undone.',
      confirmTitle: 'Remove member',
    },
    tabs: {
      own: 'Your members',
    },
    tacticalRole: {
      saved: 'Role updated.',
    },
    title: 'Group members',
    troops: {
      empty: 'No villages found.',
      noPlayer: 'This member has no character claimed on this server.',
      notShared: 'This member has not shared their troops with the group.',
      title: "{name}'s troops",
    },
    viewTroops: 'View troops',
  },
  groupRanking: {
    columns: {
      position: '#',
    },
    disabled: {
      message: "The group's admin has disabled this feature for members.",
      title: 'Rankings disabled',
    },
    empty: 'No member matches this search.',
    noGroup: {
      message: 'You are not part of a group yet.',
    },
    numbersHidden: "The group's admin has hidden the numbers: you can only see the order.",
    subtitle: 'Internal leaderboards for {name}.',
    tabs: {
      attack: 'Attack power',
      conquests: 'Conquests',
      defense: 'Defense power',
      population: 'Population',
      troops: 'Total troops',
    },
    title: 'Group rankings',
  },
  groups: {
    archive: {
      empty: 'No group in the archive yet.',
      subtitle: 'Your groups on servers that have ended.',
      title: 'Group archive',
    },
    candidate: {
      body: 'Confirm the character you want to apply with, or choose another one on this server.',
      note: 'Note (optional)',
      notePlaceholder: "Tell the group why you'd like to join…",
      submit: 'Send application',
      tacticalRole: "Role you're applying for",
      title: 'Apply to "{name}"',
    },
    card: {
      apply: 'Apply',
      currentlySelected: 'Currently selected',
      leave: 'Leave group',
      pending: 'Pending',
      withdraw: 'Withdraw',
    },
    create: {
      alliances: 'Allowed alliances',
      alliancesHint:
        'Optional. If set, only players from these alliances can join. They are never shown outside the group, even if it is public.',
      changeServer: 'Change server',
      descriptionPlaceholder: 'What is this group about? (optional)',
      imageHint: 'Optional. JPG, PNG, WEBP or GIF, up to 5 MB.',
      imageSizeError: 'The image exceeds 5 MB.',
      imageTypeError: 'Unsupported image format.',
      nameHint: 'Up to {max} characters: it becomes the menu entry of the group.',
      noFavoriteServer:
        'You have no favourite server yet: add one from your profile before creating a group.',
      rankingNumbersVisible: 'Show exact numbers',
      rankingNumbersVisibleHint: 'Otherwise the ranking only shows relative positions.',
      rankingVisible: 'Show ranking to members',
      rankingVisibleHint: "Members will be able to see the group's internal ranking.",
      serverNoResults: 'No matching server found.',
      serverPlaceholder: 'Search a server that has already started…',
      subtitle: 'Your confederation on a Travian world.',
      success: 'Group created.',
      title: 'Create a new group',
      visible: 'Public group',
      visibleHint: 'Visible to other players on this server, who can apply to join.',
    },
    detail: {
      alias: 'Character',
      blockedBody: 'This group is private and you are not a member.',
      blockedTitle: 'Access not allowed',
      dualKeyRegenerated: 'Link regenerated: the old one no longer works.',
      dualLinkHint:
        'Share it with your second account: it joins the group with your same character.',
      dualLinkTitle: 'Invite link for your dual',
      finalRankingSubtitle: 'The server has ended: the position reached in each category.',
      finalRankingTitle: 'Final rankings',
      joined: 'Joined',
      left: 'You left the group.',
      linkCopied: 'Link copied.',
      linkCopyFailed: 'Could not copy automatically: select the link by hand.',
      noMembersFound: 'No member matches this search.',
      noPlayer: '—',
      pendingCandidate: 'Application under review, please wait for a decision.',
      searchMembers: 'Search members',
      searchMembersPlaceholder: 'Search by character alias…',
      selected: 'Group selected.',
      serverClosed: 'Server concluded',
    },
    invite: {
      backToGroups: 'Back to your groups',
      changePlayer: 'Change character',
      chooseRole: 'Choose a role',
      confirm: 'Join the group',
      currentPlayer: 'You will join with {alias}.',
      failedTitle: 'Could not join',
      joined: 'You joined the group.',
      pickPlayerHint: 'Choose the character to join with on {server}.',
      searchPlayer: 'Search character',
      tacticalRole: 'Your role in the group',
      tacticalRoleHint:
        'Required: choose how you will play in the group. A group leader can change it later.',
      title: 'Group invitation',
    },
    list: {
      available: {
        empty: 'No group available right now.',
        noServer: 'To see the groups on a server, add it to your favourites first.',
        subtitle: 'Public groups on {server} you are not part of yet.',
        title: 'Groups available on your current server',
      },
      confirmLeaveBody: 'You will lose access to all the data saved for this group.',
      confirmLeaveSoleAdmin: "If you were the group's only admin, it will be left without one.",
      confirmLeaveTitle: 'Leave "{name}"?',
      confirmWithdrawBody: 'You can apply again later if you change your mind.',
      confirmWithdrawTitle: 'Withdraw your application to "{name}"?',
      mine: {
        emptyBody: 'Create one, or apply to an existing group from the list below.',
        emptyTitle: 'You are not part of any group yet.',
      },
      pending: {
        empty: 'No application submitted.',
        title: 'Pending applications',
      },
      withdrawn: 'Application withdrawn.',
    },
    nameLegacyHint:
      'The current name is over {max} characters: you can keep it, but a new name must fit.',
    tacticalRoles: {
      defender: 'Defender',
      hybrid: 'Hybrid',
      offender: 'Offender',
      scouter: 'Scouter',
      wwHammer: 'WW Hammer',
    },
  },
  groupSettings: {
    associations: {
      confirmRemoveBody:
        'This removes the association for both groups: you will both lose the shared visibility. This cannot be undone.',
      confirmRemoveTitle: 'Remove the association with {name}?',
      empty: 'No associated groups yet.',
      hint: 'Link your group to another one on the same server to share visibility on members, troops, def calls, mission plan, artifact plan and push management.',
      keyPermissionsButton: 'Key permissions',
      keyPermissionsHint:
        'Choose what whoever redeems this key will see of your group. Changing this does not affect associations already created.',
      keyPermissionsSaved: 'Key permissions updated.',
      keyPermissionsTitle: 'Key permissions',
      keyRegenerated: 'Association key regenerated.',
      ownKey: 'Your association key',
      partnerShowsArtifacts: 'Their artifact plan',
      partnerShowsMembers: 'Their members',
      partnerShowsMissions: 'Their mission plan',
      partnerShowsPushManagement: 'Their push management',
      partnerShowsTroops: 'Their troops',
      partnerShowsWallCalls: 'Their def calls',
      permissionsButtonLabel: 'Permissions with {name}',
      permissionsColumn: 'Permissions',
      permissionsDialogTitle: 'Permissions — {name}',
      permissionsSaved: 'Permissions updated.',
      permissionsYouGrant: 'What you grant to {name}',
      permissionsYouReceive: 'What you can see of {name}',
      redeemed: 'Groups associated.',
      redeemLabel: "Redeem another group's key",
      redeemPermissionsHint:
        "You're about to associate with the group that owns this key. Choose what they will see of your group.",
      redeemPermissionsTitle: 'Choose the permissions to grant',
      redeemPlaceholder: 'Paste the association key you were given',
      redeemSubmit: 'Associate',
      showArtifacts: 'Show our artifact plan',
      showMembers: 'Show our members',
      showMissions: 'Show our mission plan',
      showPushManagement: 'Show our push management',
      showTroops: 'Show our troops',
      showWallCalls: 'Show our def calls',
      title: 'Group association',
    },
    copied: 'Copied.',
    copyFailed: 'Could not copy automatically: select it by hand.',
    dangerZone: {
      confirmBody:
        'This cannot be undone: every member, allowed alliance, invite key and association with other groups is deleted with it.',
      confirmTitle: 'Delete {name}?',
      deleteButton: 'Delete group',
      deleted: 'Group deleted.',
      hint: 'Deleting the group is permanent: it removes every member, allowed alliance, invite key and association with other groups.',
      title: 'Danger zone',
    },
    discordHint:
      'Connect a Discord server and choose where to send def call, push and other events.',
    discordManage: 'Manage Discord bot',
    identity: {
      imageSaved: 'Image updated.',
      saved: 'Settings saved.',
    },
    keys: {
      confirmDeleteBody: 'The link stops working immediately. This cannot be undone.',
      confirmDeleteTitle: 'Delete this invite key?',
      copyLink: 'Copy invite link',
      create: 'Create key',
      created: 'Invite key created.',
      createdAt: 'Created',
      empty: 'No invite keys yet.',
      expireDate: 'Expiry date',
      hint: 'Reusable invite links, each with an optional usage limit and expiry date.',
      maxUsage: 'Max usage',
      never: 'Never',
      title: 'Invite keys',
      unlimited: 'Unlimited',
      usage: 'Usage',
      usageDialogSubtitle: 'Everyone who joined the group through this invite key.',
      usageDialogTitle: 'Who used this key',
      usageEmpty: 'Nobody has used this key yet.',
      viewUsage: 'View who used this key',
    },
    notAdmin: "Only the group's admins can access its settings.",
    reservations: {
      adminOnly: 'Only the admin can reserve',
      adminOnlyHint:
        'Off: every member reserves for themselves. On: only you (the admins) reserve, also on behalf of the others.',
      hint: 'Slots to settle and villages to conquer that members reserve on the Reservations page.',
      hours: 'Reservation length (hours)',
      hoursHint: 'Applies to new reservations: those already made keep their expiry.',
      hoursInvalid: 'Enter a whole number of hours between {min} and {max}.',
      open: 'Open the reservations',
      title: 'Reservations',
    },
    subtitle: 'Manage {name}.',
    telegramHint:
      'Connect one or more Telegram chats and choose where to send def call, push and other events.',
    telegramManage: 'Manage Telegram bot',
  },
  groupTelegram: {
    channelDialog: {
      copied: 'Command copied.',
      copy: 'Copy',
      copyFailed: "Couldn't copy automatically — select and copy the text above by hand.",
      dismiss: 'Close these instructions',
      hint: 'Once posted, the channel appears in the list above automatically within a few seconds.',
      step1:
        '1. In your channel: Administrators → Add Administrator → search for {bot} and give it permission to post messages.',
      step2: '2. Post this exact message in the channel (as the channel itself, not as you):',
      title: 'Add a Telegram channel',
    },
    events: {
      chat: 'Destination chat',
      empty: 'No event has been configured by the site admins yet.',
      enabled: 'Enabled',
      noChat: 'No chat',
      noLinksYet: 'Connect at least one chat above before choosing where events are sent.',
      subtitle: 'Choose which connected chat receives each event.',
      title: 'Events',
    },
    instructions: {
      channel:
        'Channel: Telegram doesn\'t reliably support adding bots to channels via a link on every device, so it takes two manual steps — tap "Add a Telegram channel" below for exact instructions.',
      group:
        'Group: tap "Add a Telegram group", pick your group in the Telegram app, then tap Send on the pre-filled message it shows you. The chat appears below automatically within a few seconds.',
      title: 'How it works',
    },
    linked: 'New Telegram chat connected.',
    linkedMessage:
      "✅ This chat is now connected to <b>{group}</b> on Travick. Open the group's Telegram settings panel on the site to choose which events are sent here.",
    links: {
      addChannel: 'Add a Telegram channel',
      addGroup: 'Add a Telegram group',
      empty: 'No Telegram chat connected yet.',
      pendingHint:
        'Finish adding the bot in Telegram, then come back here: the chat will appear automatically. You can also close this and add it later — click Recheck.',
      pendingTitle: 'Waiting for Telegram…',
      recheck: 'Recheck',
      subtitle: 'Unlike Discord, you can connect more than one group or channel.',
      title: 'Connected chats',
      typeChannel: 'Channel',
      typeGroup: 'Group',
      unlink: 'Unlink',
      unlinkConfirmBody:
        'Any event currently sending here will stop being delivered until you pick another chat for it.',
      unlinkConfirmTitle: 'Unlink this chat?',
    },
    saved: 'Settings saved.',
    subtitle: 'Connect one or more Telegram chats and choose where each event is sent.',
    title: 'Telegram bot',
    unlinked: 'Chat unlinked.',
    unlinkedMessage:
      "❌ This chat has been disconnected from <b>{group}</b> on Travick. To reconnect it, start again from the group's Telegram settings panel on the site.",
  },
  groupTroops: {
    charts: {
      attackTitle: 'Attack power over time',
      defenseTitle: 'Defense power over time',
    },
    columns: {
      lastUpdated: 'Last updated',
      player: 'Player',
    },
    empty: 'No village matches these filters.',
    filters: {
      player: 'Search player…',
      role: 'Role in the group',
      tribe: 'Tribe',
      villageType: 'Village type',
    },
    notAllowed: "Only the group's admins, Defence Leaders and Offender Leaders can see this page.",
    tabs: {
      own: 'Your troops',
    },
    title: 'Group troops',
    totals: {
      title: 'Totals',
    },
  },
  guides: {
    audience: {
      admin: 'Group admin',
      adminHint: 'Who leads the group.',
      def: 'Defence Leader',
      defHint: 'Members with the Defence Leader role in the group.',
      guest: 'Everyone',
      guestHint: 'Works without an account too.',
      member: 'Group member',
      memberHint: 'Any member of the group selected in the header.',
      off: 'Offender Leader',
      offHint: 'Members with the Offender Leader role in the group.',
      user: 'Account',
      userHint: 'You need to be logged in.',
    },
    chapters: {
      defense: {
        intro: 'Incoming attacks, def calls and enemy armies of the selected group.',
        title: 'Defence',
      },
      group: {
        intro: 'A group is your confederacy on Travick: members, roles and shared tools.',
        title: 'Your group',
      },
      help: {
        intro: 'How to reach us and how your data is handled.',
        title: 'Help',
      },
      logistics: {
        intro: 'Resource pushes between members and reservations of tiles to settle or conquer.',
        title: 'Resources and territory',
      },
      offense: {
        intro: 'Attack plans for the group and counter-attack timing.',
        title: 'Offence',
      },
      start: {
        intro: 'Account, interface and the few settings that make everything else work.',
        title: 'Getting started',
      },
      tools: {
        intro: 'Calculators that work for guests too: an account is needed only to save.',
        title: 'Useful tools',
      },
      villages: {
        intro:
          'Troops, smithy and farm lists of your character on the world selected in the header.',
        title: 'Your villages',
      },
      world: {
        intro: 'Public data of the Travian worlds, updated every day. Open to everyone.',
        title: 'Worlds and statistics',
      },
    },
    collapseAll: 'Close all',
    expandAll: 'Open all',
    goodToKnow: 'Good to know',
    help: {
      text: 'Write to us: questions, problems and suggestions all help improve Travick and this manual.',
      title: "Didn't find what you were looking for?",
    },
    howItWorks: 'How it works',
    howTo: {
      audience: 'Each topic shows who can use it. Click a topic to open it, or search for a word.',
      title: 'How to read this manual',
    },
    openPage: 'Open the page',
    paste: {
      caption:
        'On a Mac use Cmd instead of Ctrl. With the browser extension one click does all three steps.',
      copy: 'Select all and copy',
      open: 'Open the page in Travian',
      paste: 'Paste it into Travick',
    },
    screenshot: {
      alt: 'Example screen: {title}',
      caption: 'Example screen: tap it to see it full size.',
      open: 'Open the image full size',
    },
    search: {
      empty: 'No topic matches your search. Try another word, or write to us.',
      label: 'Search the manual',
      placeholder: 'e.g. invite, def call, push, timezone…',
      results: 'Topics found: {count}',
    },
    subtitle: 'Everything you can do on Travick, feature by feature.',
    title: 'User manual',
    toc: 'Contents',
    topics: {
      account: {
        steps: {
          '1': 'Sign up with name, email and password, or with Continue with Google.',
          '2': 'Open the link in the verification email: until then you cannot log in with email and password.',
          '3': 'Log in with email and password, with Google, or with Discord if you linked it in your profile.',
          '4': 'Forgot your password? Use Forgot your password? on the login page and follow the link you receive by email.',
        },
        summary: 'One Travick account for all the worlds you play on.',
        tips: {
          '1': 'The password needs at least 8 characters, an uppercase and a lowercase letter and a number.',
          '2': 'The verification email did not arrive? Try to log in: the page offers to send it again.',
          '3': 'If you open an invite link before logging in, after the login you go straight back to the invite.',
        },
        title: 'Sign up and log in',
      },
      accountSettings: {
        steps: {
          '1': 'Choose language and theme (Classic, Dark, Dim): the theme previews at once, save to keep it.',
          '2': 'Choose the date format and the timezone.',
          '3': 'Change password: current password, new one twice, then Update password.',
          '4': 'Choose how to receive notifications and save.',
        },
        summary: 'Language, theme, date format, timezone, password and notifications.',
        tips: {
          '1': "The timezone drives the clock and every time you type or read (arrivals, launches, calls). Keep the same one as your leaders, ideally the game's.",
          '2': 'Settings are saved on the account: they follow you on every device.',
        },
        title: 'Account settings',
      },
      attackPlans: {
        steps: {
          '1': 'New plan, step 1: choose the enemy players (use alliances as a filter).',
          '2': 'Step 2: choose the target villages.',
          '3': 'Step 3: choose the participants and their starting villages; search them by alias. A character shared by several users appears once, and all of them see its plan.',
          '4': 'Step 4: assign the attacks (type, waves, speed).',
          '5': 'Step 5: set the arrival; the tournament squares are optimised by themselves and you can fix them by hand.',
          '6': 'Save as draft or publish: participants find their attacks in Your plan.',
        },
        summary:
          'Coordinated operations of the group: who hits what, with which wave, landing at the same time.',
        tips: {
          '1': 'Before publishing the page checks arrivals, speeds and launches already past.',
          '2': 'From Saved plans you can view, edit, duplicate, unpublish or delete a plan.',
          '3': 'A plan whose arrivals are all past is concluded: it can only be viewed or duplicated.',
          '4': 'From Saved plans, on a published or concluded plan, the Excel icon downloads the plan of all or some players: one file with a sheet per player, or one file per player.',
        },
        title: 'Attack plans',
      },
      calcDefSend: {
        steps: {
          '1': 'Choose the departure: one of your villages, or free coordinates with the tribe.',
          '2': 'Enter the destination and, if you want, the arrival time.',
          '3': "Set the hero's boots and banner: the times update by themselves.",
          '4': 'For each troop you see the minimum tournament square and the departure time; the grid shows the times for every level.',
        },
        summary: 'When each troop must leave to reach a village by a given time.',
        tips: {
          '1': 'With an arrival time the page follows the clock: a troop disappears the second it can no longer make it.',
          '2': 'It works without a world too: type coordinates and server speed by hand.',
          '3': 'Troops reinforcing another village? Tick "Troops parked in another village" and enter its coordinates: the times add the return home, and with an arrival time you see by when to withdraw them and by when to send them again.',
        },
        title: 'Defence send calculator',
      },
      contact: {
        steps: {
          '1': 'Choose the reason: information, report or suggestion.',
          '2': 'Check the email (the reply arrives there), write subject and message.',
          '3': 'Send: below the form you also find our social channels.',
        },
        summary: 'Questions, problems or ideas: write to us from the site.',
        tips: {
          '1': 'For a bug say which page, what you did and what you expected: a screenshot helps a lot.',
        },
        title: 'Contact us',
      },
      counterAttack: {
        steps: {
          '1': 'Enter the enemy village and the arrival time of their attack, or choose one of your incomings.',
          '2': "Choose the enemy troop, its tournament square and the hero's boots and map.",
          '3': 'Choose your departure village, tournament square and boots.',
          '4': 'Read the launch time for each of your troops, with the countdown.',
        },
        summary:
          "When to launch so that your attack lands on the attacker's village as their troops return home.",
        tips: {
          '1': 'Add a margin of a second or two: landing in the same second is borderline.',
          '2': 'Tribes are detected from the coordinates when the world is known.',
        },
        title: 'Counter-attack calculator',
      },
      cropFinder: {
        steps: {
          '1': 'In the game open the 9/15 crop finder, select the whole page and copy it.',
          '2': 'Press Paste from the game and paste it: free tiles only by default, tick the option to load the occupied ones too. Repeat for every page.',
          '3': 'Or add a tile by hand with coordinates, type and oasis bonus.',
          '4': 'Filter by type, oasis bonus, sector, status and the name of the player a tile is reserved for. Open the map with Show: it follows the same filters and colours free, reserved, taken and allied tiles differently.',
          '5': "Reserve a free tile: type the player's name or alliance tag and pick a member or a player of the group's alliances from the suggestions; Free or Taken by a non-ally change it later.",
          '6': 'With the oasis-collision button tick the nearby tiles that compete for the same oases: those rows turn blue and the map joins them with a blue line.',
        },
        summary:
          "Collect the group's 15c and 9c in one list and assign the free ones to members and allies.",
        tips: {
          '1': 'Tiles already in the list are never added twice; the distance is not saved.',
          '2': "A reservation made here has no expiry and appears in Reservations, with the message to the group's channels.",
          '3': 'Freeing the tile or marking it taken cancels its reservation; cancelling it from Reservations frees the tile.',
          '4': 'Only the group admin sees this page.',
          '5': 'A reservation note shows as an icon next to the status, only when there is one: open it to read or edit it.',
        },
        title: 'Crop finder',
      },
      cropOrder: {
        steps: {
          '1': "Set the village: capital or not, tribe, hero's mansion and oases.",
          '2': 'Read the list of steps in order, with cost and payback time.',
          '3': 'Logged in, save the plan: up to 10 plans on your account.',
          '4': 'With a plan open, tick the steps you have done: progress is saved by itself.',
        },
        summary:
          'In which order to raise crop fields, mill, bakery and oases, choosing at each step what pays back first.',
        tips: {
          '1': 'Ticking a step with earlier ones still open offers to tick those too.',
          '2': 'Changing settings that change the order resets the ticks, after asking.',
        },
        title: 'Crop order',
      },
      defCalls: {
        steps: {
          '1': 'Choose the tab: Normal (by a time), Ninja (within a time window) or Permanent.',
          '2': 'See troops shows which of your troops arrive in time and from which village, with tournament square and hero.',
          '3': "Send defences opens the game's rally point already filled; Add declares them with one click.",
          '4': 'Otherwise use Confirm defences sent and type the troops: the count is in crop consumption.',
          '5': 'Admins and Defence Leaders create calls with priority, type of defence and target; the icon on the row shows who sent what.',
          '6': "The eye icon at the start of each row opens the call's page: count, deadline with a live countdown, who sent what and every action as a button.",
        },
        summary:
          'Requests for defence for a village to hold: who can, sends troops and declares them.',
        tips: {
          '1': 'Urgent calls are highlighted in red; the number in the menu counts the active ones.',
          '2': 'An expired or closed call can no longer be declared: the button becomes See declarations.',
          '3': 'You also see the calls of associated groups that share their def calls with you.',
        },
        title: 'Def calls',
      },
      defCallStats: {
        steps: {
          '1': 'Choose the period (7, 30, 90 days, all, or custom days) and the type of call.',
          '2': 'Read the group summary and the highlights: most present, who sent most, who never answered.',
          '3': 'In the ranking open a player to see the troops sent and the split by type.',
        },
        summary: 'Who answers the def calls, how often and with how much.',
        tips: {
          '1': 'Participation counts only the calls born after the player joined, excluding those on their own villages.',
          '2': 'Troops are credited to who sent them, not to who declared them.',
        },
        title: 'Def call statistics',
      },
      extension: {
        steps: {
          '1': 'Install the Travick extension for Chrome, Chromium-based browsers or Firefox: in Profile, under Browser extension, the Chrome and Firefox cards open the download page.',
          '2': 'In Profile, under Browser extension, give the token a name (e.g. laptop Chrome) and press Generate token.',
          '3': 'Copy the token, paste it into the extension popup and press Connect.',
          '4': 'On a Travian page (troops or smithy overview, rally point, a report, farm lists, marketplace) click the extension icon and Send to Travick.',
          '5': 'The popup summarises what was updated and links to the page in Travick.',
        },
        summary:
          'Sends the Travian page you are looking at to Travick with one click, instead of copy and paste.',
        tips: {
          '1': 'The token is shown only once: if you lose it, revoke it and generate a new one. Never share it.',
          '2': 'The extension sends only the current tab, only when you click, and only on Travian addresses.',
          '3': 'Create one token per browser (up to 10): revoking one stops only that browser.',
          '4': 'Push: after sending the resources, from Marketplace → Send resources choose the group and send. Travick finds the push request going to that village by itself (or pick it from the list) and checks the destination and the deliveries already recorded.',
          '5': 'Incoming attacks: you can add your last login and logout, in your Travick timezone, as on the site, to narrow when the attacks left.',
          '6': "The extension's language is the browser's: Italian if the browser is in Italian, English otherwise.",
        },
        title: 'Browser extension',
      },
      farmList: {
        steps: {
          '1': 'In the game open Rally point, Farm lists, and open every list you want to analyse.',
          '2': 'Copy the page and paste it in Travick with the paste button.',
          '3': 'For each list set the click interval and the tournament square of the starting village.',
          '4': 'Read the advice at the top: empty, full, lost or duplicate targets, too many troops, skipped clicks. Show filters the table.',
          '5': 'Paste again regularly: the more often you do it, the more reliable the observed averages.',
        },
        summary: 'Statistics and advice to make your raids more profitable.',
        tips: {
          '1': 'Closed lists arrive without targets: the paste window warns you and lists them.',
          '2': 'Declare the troops in Your villages: the page then checks whether each village has enough troops for every click.',
          '3': "Only your own character's farm lists are accepted.",
        },
        title: 'Farm lists',
      },
      gettingStarted: {
        steps: {
          '1': 'Create your account with email or Google and confirm the address from the email you receive.',
          '2': 'In Profile, under Favourite servers, add the world you play on.',
          '3': 'On the same world press Link your character and search your in-game alias.',
          '4': "Join your confederacy's group with the invite link from your leaders, apply from Groups, or create a new one.",
          '5': 'Pick world and group in the header: the menu shows the pages your role can open.',
        },
        summary: 'The shortest path from a new account to a group that works together.',
        tips: {
          '1': 'Many group pages follow the world and group selected in the header: if a page looks empty, check those two first.',
          '2': 'Declare your troops in Your villages: group troops, def calls and plans use them.',
          '3': 'Not sure yet? From the home page you can open world statistics and calculators straight away, without an account.',
        },
        title: 'Start in five steps',
      },
      groupAssociations: {
        steps: {
          '1': "In Group settings, Association between groups, copy your association key and send it to the other group's admin.",
          '2': 'Key permissions decides what whoever redeems your key will see.',
          '3': 'To redeem the key of another group paste it, press Associate and choose what you grant.',
          '4': 'Permissions with each group can be changed later, in both directions.',
        },
        summary:
          'Two groups on the same world can share troops, members, def calls, plans and push requests.',
        tips: {
          '1': 'Removing an association removes it for both groups.',
          '2': 'Regenerate the key if it ended up in the wrong hands: existing associations are not touched.',
        },
        title: 'Associated groups',
      },
      groupBots: {
        steps: {
          '1': 'Discord: from Group settings press Manage Discord bot and add the bot to your Discord server.',
          '2': 'For each event choose the channel, any roles to mention, and turn it on.',
          '3': 'Telegram: Manage Telegram bot, then add a Telegram group (send the ready message) or a channel (follow the two steps shown).',
          '4': 'For each event choose the destination chat and turn it on.',
        },
        summary:
          "The group's events (attacks, def calls, pushes, plans, reservations) also arrive in your chats.",
        tips: {
          '1': 'One Discord server per group; on Telegram you can link several chats.',
          '2': 'The buttons in the messages (Update defences, Record shipment) open Travick on the right window.',
        },
        title: 'Discord and Telegram bots',
      },
      groupInvites: {
        steps: {
          '1': 'Open the invite link your leaders sent you and log in if asked.',
          '2': 'Check the character you will enter with (Change player if needed), choose your role in the group (Offender, Defender, Hybrid, Scouter or WW Hammer: it is required) and press Join the group.',
          '3': 'Do you share the account with a dual? On the group page copy the link for your dual: they will join with the same character and your same role, without choosing anything.',
        },
        summary: 'Enter a group with a link, without waiting for an application to be accepted.',
        tips: {
          '1': 'An invite can expire or reach its usage limit: ask your leaders for a new one.',
          '2': 'Regenerate makes the old dual link stop working.',
          '3': 'The role is checked only after the invite itself: if you cannot join (wrong key, alliance not allowed…) you are told why first. A group leader can change your role later from Members.',
        },
        title: 'Invites and duals',
      },
      groupMembers: {
        steps: {
          '1': 'In Members turn on Admin, Defence Leader and Offender Leader for each member: with none the member is a simple member.',
          '2': 'Set the tactical role and filter by name, alias or role.',
          '3': "See troops shows a member's declared troops; Show map shows their villages.",
          '4': 'Show missing aliases lists the players of the allowed alliances not yet in the group.',
          '5': 'In Applications accept or reject one by one or in bulk; History keeps the decisions.',
        },
        summary: 'The group admin manages who is in, with which role, and who wants to join.',
        tips: {
          '1': 'Removing a member cannot be undone.',
          '2': 'Associated groups appear as extra tabs, read only.',
        },
        title: 'Members and applications',
      },
      groupRanking: {
        steps: {
          '1': 'Choose the ranking: total troops, attack power, defence power or conquests.',
          '2': 'The group archive keeps your groups on finished worlds with their final ranking.',
        },
        summary: 'Who is strongest in the group, and the groups of the worlds that are over.',
        tips: {
          '1': 'The admin decides whether members see the rankings and whether exact numbers or only positions are shown.',
          '2': 'The archive is opened from the profile, too.',
        },
        title: 'Group rankings and archive',
      },
      groupRoles: {
        steps: {
          '1': 'Member: sees incomings, def calls, push requests, reservations, enemies and their own plan.',
          '2': "Defence Leader: creates def calls, sees all the group's attacks, the def call statistics and the troops.",
          '3': "Offender Leader: builds and publishes attack plans and sees the group's troops.",
          '4': 'Admin: everything above, plus members, applications, settings, bots and push requests.',
        },
        summary:
          'What you can do depends on your role in the active group. A member can have more than one.',
        tips: {
          '1': 'The menu shows only the pages of your role: if one is missing, ask an admin of the group.',
          '2': 'The tactical role (Offender, Defender, Hybrid, Scouter, WW Hammer) is only informative.',
        },
        title: 'Roles in the group',
      },
      groups: {
        steps: {
          '1': 'Your groups: the ones you belong to; the active one is marked.',
          '2': 'Available groups: the public groups of the world in the header. Press Apply, choose the character and, if you like, role and a note.',
          '3': 'Pending applications can be withdrawn with Withdraw application.',
          '4': 'Create group: name, description, picture, world, character and, if you want, the allowed alliances.',
          '5': 'Choose whether the group is public (others can apply) and whether members see the group rankings.',
        },
        summary:
          'The Groups page gathers your groups, your applications and the public groups of the current world.',
        tips: {
          '1': 'To see the groups of a world, add it to your favourite servers first.',
          '2': 'The group name appears in the menu: keep it short (7 characters).',
          '3': 'Leaving a group deletes the data you saved for it.',
        },
        title: 'Find, join or create a group',
      },
      groupSettings: {
        steps: {
          '1': 'Identity: name, description, picture, public group, rankings visible to members, exact numbers.',
          '2': 'Allowed alliances: only their players can join. Empty list means no restriction.',
          '3': 'Invite keys: create a link with maximum uses and expiry date, copy it and see who used it.',
          '4': 'Reservations: open them, decide whether only the admin books and how many hours a reservation lasts.',
          '5': 'Danger zone: Delete group removes it forever with members, keys and associations.',
        },
        summary: 'Identity, allowed alliances, invite keys and reservations of the group.',
        tips: {
          '1': 'Deleting an invite key stops its link immediately.',
          '2': 'The settings are opened from the cog next to the group selector, too.',
        },
        title: 'Group settings',
      },
      groupTroops: {
        steps: {
          '1': 'Filter by player, tribe, village type or role in the group.',
          '2': 'The Totals row sums what you are looking at; Last update says how fresh each figure is.',
          '3': 'Show charts follows attack and defence power over time.',
        },
        summary:
          'All the troops declared by the members, village by village, with totals and charts.',
        tips: {
          '1': "The figures are only as good as the members' pastes: remind them to update Your villages.",
          '2': 'Associated groups that share their troops appear as extra tabs.',
        },
        title: 'Group troops',
      },
      home: {
        steps: {
          '1': 'Get started: while something is missing (world, character, group, troops) the home lists the steps left, each with the button to do it.',
          '2': 'Your character: rank, population and villages with the change since yesterday, and how long ago you updated troops and smithy. Update troops opens Your villages.',
          '3': 'The world: day of the round, level of the highest wonder (or the end date) and how long until artefacts and construction plans.',
          '4': 'Your group: members, total population and villages, how many members updated their troops in the last 24 hours and the open activities (attacks on you, wall calls, pushes, plans...). Each box opens its page.',
        },
        summary: 'Your character, your world and your group at a glance, as soon as you log in.',
        tips: {
          '1': 'Character and world are the same as in the card at the top of the menu: they follow the world and group selected in the header.',
          '2': 'The troops badge is green under 24 hours, yellow up to 3 days and red after that: update them before your group plans with them.',
          '3': 'Attacks on you and pushes where you are below quota are in red. The total of the attacks on the group is shown only to admins and defence leaders; the group troops count only how many updated, never who.',
        },
        title: 'Your home',
      },
      inactiveSearch: {
        steps: {
          '1': 'Choose the world and the centre of the search (coordinates, or one of your villages).',
          '2': 'Set the days of inactivity (1 to 7), the tolerated growth and the other filters.',
          '3': 'Press Search: the results are sorted by distance.',
          '4': 'With your farm lists imported, filter the villages already in a list or not yet.',
        },
        summary: 'Villages of players who have stopped growing, sorted by distance: ideal farms.',
        tips: {
          '1': 'The last search is remembered in this browser.',
          '2': 'Logged in with a character on the world: centre on one of your villages. Your alliance is hidden by default; remove it from "Hide alliances" to see its inactives too.',
          '3': 'In the alliance and player fields, start typing: the matching tags and nicknames of the world are suggested. Changing world clears them, since the same names there are other people.',
          '4': 'The tribe filter offers only the tribes playable on the chosen world.',
        },
        title: 'Inactive search',
      },
      incomings: {
        steps: {
          '1': 'In the game open the rally point with the incoming attacks and copy the page.',
          '2': 'Press Add, paste and confirm; or use the manual mode for a single attack.',
          '3': 'The summary tells which attacks were saved and which were discarded, and why.',
          '4': 'For each attack Possible troops lists the troops compatible with the arrival time; add login and logout of the attacker to narrow them.',
          '5': "Use the hero icon to upload the attacker's hero screenshot, and the map icon to see who can reinforce in time.",
        },
        summary:
          'Report the attacks arriving on your villages: the group sees them and can organise the defence.',
        tips: {
          '1': 'You see only the attacks on your own character; admins and Defence Leaders see them all in Attacks recap.',
          '2': "Times are in your account's timezone: the game's times must match it.",
          '3': 'The list refreshes by itself every 30 seconds.',
          '4': 'The number on the Incomings menu entry counts the attacks on your character that have not landed yet.',
        },
        title: 'Incoming attacks',
      },
      interface: {
        steps: {
          '1': 'Server selector: the world you are looking at, chosen among your favourites. The + adds a new one.',
          '2': 'Group selector: the active group. Changing it can change your role and therefore the menu.',
          '3': "Clock: the time in your account's timezone, the same used by every calculation and plan.",
          '4': 'Side menu: sections with coloured icons; the numbers tell you how many things are waiting (active calls, attacks, plans).',
          '5': 'Home: the news, your character with the state of your troops, the world and the selected group with its open activities (see Your home).',
        },
        summary: 'Where things are and what the selectors at the top change.',
        tips: {
          '1': 'On a computer the button with three lines shrinks the menu to icons; on a phone it opens the menu.',
          '2': 'A closed section shows the total of the numbers inside it.',
          '3': 'The card at the top of the menu shows your character and world: tap them to open their pages.',
          '4': 'On a phone, with a group selected, a bar at the bottom of the screen takes you to Incomings, Walls, Your plan and Push requests in one tap, with the same numbers as the menu.',
        },
        title: 'Header, menu and home',
      },
      map: {
        steps: {
          '1': 'Add players and alliances from the two side panels: each one gets its own colour.',
          '2': "Show, hide or highlight each entry; the player's colour wins over the alliance's.",
          '3': 'Set a reference village (yours or X and Y) to centre the map and measure distances.',
          '4': 'Drag to move, use the wheel or the buttons to zoom; full screen is available.',
          '5': 'Click a village for its details and the distance from the reference village.',
        },
        summary: 'Choose players and alliances and see where their villages are.',
        tips: {
          '1': 'Share this map copies a link that reopens the map exactly as it is, also for those without an account.',
          '2': 'From the keyboard: arrows to move, + and - to zoom, Home to frame the whole world.',
          '3': 'The coordinates are always shown along the top and left edges: zooming in, they get denser down to every single cell.',
          '4': "Disbanded alliances don't show up in the search: their former members appear under the alliance they belong to now.",
        },
        title: 'World map',
      },
      news: {
        steps: {
          '1': 'The three most recent news are at the top of the home page.',
          '2': 'See all opens the archive with every published news.',
        },
        summary: 'Announcements about new features, fixes and maintenance.',
        tips: {
          '1': 'The New and Bug labels tell at a glance what a news is about.',
        },
        title: 'News',
      },
      npcOptimization: {
        steps: {
          '1': 'Choose the tribe and type the resources you have.',
          '2': 'Add to the list what you want to complete: fields and buildings (from level to level), troops, research, smithy, celebrations or any expense.',
          '3': 'Choose how to distribute what is left: equal parts, all crop, no crop, or in troops.',
          '4': 'Tap a number of the result to copy it and paste it into the merchant.',
        },
        summary:
          'The four numbers to type into the NPC merchant to complete what you want to build.',
        tips: {
          '1': 'From level means the current level: to build level 7 write from 6 to 7.',
          '2': 'Logged in, save up to 10 configurations and reload them with Saved.',
        },
        title: 'NPC optimisation',
      },
      overviewVillages: {
        steps: {
          '1': 'Choose the world in the header: you need a character linked on it.',
          '2': 'In the game open Villages overview, Troops tab, and copy the page (see Pasting pages from the game).',
          '3': 'Press Update troops, paste and confirm. Do the same with the smithy overview in the Smithy tab.',
          '4': 'Assign a type to each village (Push, Defence, Attack, WWK, WWR, Scout): select them and press Assign.',
          '5': 'History and Show charts show how troops and attack and defence power changed.',
          '6': 'Or let Travick guess the types: Automatic type sets Push (no or few troops), Defence, Attack, Scout (many scouts), WWK (attack army with more than 5000 catapults) or WWR (more than 8000 rams). Only villages without a type, unless you choose Recalculate all villages.',
        },
        summary:
          "Declare the troops and smithy levels of your villages: the group's tools use them.",
        tips: {
          '1': 'A paste overwrites every village it contains, zeros included: paste the whole page.',
          '2': 'You can also correct a number directly in the table cell.',
          '3': 'Inside a group the data is shared with it (Shared with the group): who plays the same character as a dual sees and edits the same data.',
          '4': 'When updating the troops by paste or with the browser extension you can tick Also set the village type from the troops: the same rule, only on villages without a type or on all of them.',
        },
        title: 'Your villages: troops and smithy',
      },
      pasting: {
        steps: {
          '1': 'In the game open the page the feature asks for (villages overview, rally point, report, marketplace, farm lists).',
          '2': 'Press Ctrl+A to select the whole page and Ctrl+C to copy it.',
          '3': 'In Travick open the paste window of that page and press Ctrl+V: the page reads villages, troops and times by itself.',
        },
        summary:
          'Many features read data by pasting a whole Travian page: no typing numbers one by one.',
        tips: {
          '1': 'Copy from the browser page, not from a text editor: Travick needs the links of the page, which plain text loses.',
          '2': 'Only data of your own character is accepted: a page of another account is refused and the window tells you why.',
          '3': 'Villages founded or renamed today may be unknown until the next nightly update of the world data.',
        },
        title: 'Pasting pages from the game',
      },
      playerAlliance: {
        steps: {
          '1': 'Player: rank, tribe, alliance, population, villages founded, conquered and lost, victory points.',
          '2': 'Current villages with origin (capital, founded, conquered from) and lost villages.',
          '3': 'Alliance: members, former members with where they went, previous names, population and tribe charts.',
          '4': 'History opens the timeline of events: foundations, conquests, losses, members joining and leaving.',
        },
        summary: 'History, villages and members of any player or alliance of the world.',
        tips: {
          '1': 'The comparison days slider (1 to 7) changes the variations shown in the tables and in the summary.',
          '2': 'The small map shows where the villages are: open the full map to compare them with others.',
          '3': "For a deleted player or alliance the charts stop on the deletion day; a deleted player's page shows villages and map as they were before, and those villages no longer appear on the world or alliance map.",
        },
        title: 'Player and alliance pages',
      },
      privacy: {
        summary: 'Which data Travick handles and what it saves in your browser.',
        tips: {
          '1': 'Travick saves in the browser only technical data and preferences: no tracking cookies.',
          '2': 'The full policy is linked at the bottom of the menu.',
        },
        title: 'Privacy and cookies',
      },
      profile: {
        steps: {
          '1': 'Identity: name, Travian lobby name and profile picture.',
          '2': 'Link Discord to log in with Continue with Discord.',
          '3': 'Favourite servers: search a world by name and add it. Favourites fill the server selector in the header.',
          '4': 'On each world press Link your character and pick your alias: one character per world.',
          '5': 'Your groups: make one active, leave it, or open the archive of the groups on finished worlds.',
        },
        summary:
          'Your public data, the worlds you follow and the Travian character you play on each of them.',
        tips: {
          '1': "While you are in a group on a world you cannot change that world's character: leave the group first.",
          '2': 'Removing the link deletes the troops and smithy you declared on that world, history included.',
          '3': 'Finished worlds leave the header and go to the Server archive.',
        },
        title: 'Profile and character',
      },
      pushMonitoring: {
        steps: {
          '1': 'Choose period and mode: summary, highlights and ranking update.',
          '2': 'Sort the ranking by participation, amount sent, quotas, missing or shipments typed by hand.',
        },
        summary: 'Participation of the members in the push requests, for the group admin.',
        tips: {
          '1': 'Quota columns appear only if the period contains requests with quotas.',
        },
        title: 'Push monitoring',
      },
      pushRequests: {
        steps: {
          '1': 'Three modes: goal (a total), per village (amount × villages of the sender) or per player.',
          '2': 'Your quota column tells how much you are asked; a red band means you are below.',
          '3': "Record shipment: paste the game's marketplace page, or type the amount by hand.",
          '4': 'Who pushed opens, under each request, the shipments grouped by player.',
          '5': 'The admin creates, edits and closes the requests; goal requests close by themselves when reached.',
          '6': "The eye icon at the start of each row opens the request's page: progress, your quota, who pushed and every action as a button.",
        },
        summary:
          'Resource requests for a village: who sends records it and everyone sees the progress.',
        tips: {
          '1': 'Pasting the marketplace is more reliable than typing: the admin sees which shipments were typed by hand.',
          '2': 'You can record a shipment on behalf of another member.',
          '3': 'The owner of the village being pushed has no quota.',
          '4': 'With the browser extension you record a shipment from the marketplace page with one click, without copying it.',
        },
        title: 'Push requests',
      },
      rankings: {
        steps: {
          '1': 'The world is the one in the header; as a guest choose it in the page.',
          '2': 'Search an alias or an alliance tag.',
          '3': 'Click the column headings to sort by rank, population or villages.',
          '4': 'Click a player or an alliance to open its page.',
        },
        summary: 'The daily ranking of the world, with the change from yesterday.',
        tips: {
          '1': 'The green and red arrows show how many positions were gained or lost since yesterday.',
          '2': 'The search ignores accents and Cyrillic look-alike letters: КС is found by typing KC.',
        },
        title: 'Player and alliance rankings',
      },
      recapIncomings: {
        steps: {
          '1': 'Filter by defender, attacker, arrival or launch date.',
          '2': 'Classify each attack from Real to Fake: the change is saved at once.',
          '3': 'Add an internal marker visible only to admins and Defence Leaders.',
          '4': 'From an attack not yet landed, the def call icon opens one already filled in.',
        },
        summary: 'All the attacks on the group, for those who coordinate the defence.',
        tips: {
          '1': "The number in the menu counts the group's attacks not yet landed.",
          '2': 'The launch date filter keeps attacks whose possible departure overlaps the chosen interval.',
        },
        title: 'Attacks recap',
      },
      reservations: {
        steps: {
          '1': 'Press Reserve and type the coordinates: the page tells you what is on the tile.',
          '2': 'A free tile can be settled, a village conquered: the type is chosen accordingly.',
          '3': 'The countdown shows how long the reservation lasts; in the last hour it turns red.',
          '4': 'When you have settled or conquered press Confirm; otherwise Cancel frees the tile.',
        },
        summary:
          "Book a tile to settle or a village to conquer, so that two members don't go for the same one.",
        tips: {
          '1': 'Only one active reservation per tile.',
          '2': 'Duration and who can reserve are decided by the admin in Group settings.',
          '3': 'The History tab keeps confirmed, cancelled and expired reservations.',
          '4': 'The tiles reserved by the admin from the crop finder have no expiry: they stay until the admin frees them.',
        },
        title: 'Reservations',
      },
      serverDetail: {
        steps: {
          '1': 'Open a world from the server list or from the card at the top of the menu.',
          '2': 'Read active and deleted players, conquests, villages and alliances, and the world configuration.',
          '3': 'Follow the charts over time and the progress timeline (artifacts, construction plans, Wonder of the World).',
          '4': 'Top 5 players and alliances lead to the full rankings; on WW worlds WW ranking shows the wonders.',
        },
        summary: 'Statistics, configuration and milestones of a single world.',
        tips: {
          '1': 'If data collection started late the page warns you that numbers may be incomplete.',
          '2': 'From the header of the page you can open the world in the game or on the map.',
        },
        title: 'World page',
      },
      servers: {
        steps: {
          '1': 'Search by name or open Filters: start date, domain, server type, registrations.',
          '2': 'Sort by start date, speed, end date, artifacts, construction plans or total players.',
          '3': 'The star adds the world to your favourites (logged in).',
          '4': 'Timeline shows the worlds on a calendar: click a bar to open that world.',
        },
        summary: 'All the Travian worlds: running, upcoming and finished.',
        tips: {
          '1': 'Future worlds are hidden by the start date filter: clear it to see them.',
          '2': 'Filters are in the link: you can share the list exactly as you see it.',
          '3': 'Your favourite worlds that are over stay in Server archive, with the troops you had saved.',
          '4': "On fixed-length worlds (e.g. Rise of Governors) the end date, when Travian doesn't announce it, is estimated from the speed: x1 180 days, x2 120, x3 80, x5 50, x10 30.",
        },
        title: 'Servers',
      },
      startGuide: {
        steps: {
          '1': 'Choose the server speed: for now the guide exists for 1x servers.',
          '2': 'Pick one of the four strategies (4 or 3 celebrations, simulator or farm troops): each card lists focus, pros, cons and where you get to.',
          '3': 'Set tribe and hero level, and for the farm strategies the troop and how many to make: costs, rewards and totals follow.',
          '4': 'Logged in, tick the steps you have done: progress is saved on your account, one per speed and strategy.',
        },
        summary:
          "The build order to found your second village fast in T4.6, step by step, with the author's tips.",
        tips: {
          '1': 'Read the tips above the steps: they mark the decisive moments and the time goals.',
          '2': 'Start over clears the ticks of the open guide only; the other strategies keep theirs.',
          '3': 'Went faster than planned? The Extra culture points list shows the cheapest CP per resource.',
        },
        title: 'Second village guide',
      },
      trackEnemies: {
        steps: {
          '1': 'Press Add and choose the type: Attack or raid (say whether the enemy attacked or defended) or Scouting.',
          '2': 'Paste the report from the game: the window stays open so you can paste the next one.',
          '3': 'Each row shows the latest report and the changes from the previous one (green and red).',
          '4': 'The eye opens composition, wounded and report history.',
          '5': 'The calculator estimates how much the army has grown since the report, building by building, hospital included.',
        },
        summary: 'The enemy armies your group keeps an eye on, one row per village.',
        tips: {
          '1': 'The report date counts: an older report goes into the history.',
          '2': 'Admins, Defence Leaders and Offender Leaders can insert by hand, mark an army dead and fix the latest report.',
          '3': 'The growth estimate is a maximum: it assumes the enemy trains and heals non-stop.',
        },
        title: 'Track enemies',
      },
      yourPlan: {
        steps: {
          '1': 'Each table is a starting village of a plan; the countdown runs to the second.',
          '2': "Send opens the game's rally point already filled.",
          '3': 'Once its launch time has passed, mark each attack as sent, or not launched with the reason.',
          '4': 'Excel downloads your plan as a spreadsheet with the mission rules.',
        },
        summary: 'Your attacks in the published plans, in launch order with a countdown.',
        tips: {
          '1': 'Change artifact or tournament square and the levels are recalculated for you.',
          '2': 'The number in the menu counts the published plans with attacks of yours.',
        },
        title: 'Your plan',
      },
    },
  },
  header: {
    clock: {
      label: 'Server time',
      timezone: 'Timezone: {zone}',
    },
    group: {
      manage: 'Manage groups',
      none: 'No group',
      readonly: 'Your only group',
      switched: 'Active group: {name}',
      switching: 'Switching group…',
    },
    language: {
      en: 'English',
      it: 'Italian',
    },
    openMenu: 'Open menu',
    server: {
      add: 'Add a server to your favourites',
      manage: 'Manage favourites',
      none: 'No server',
    },
    userMenu: 'User menu',
  },
  inactiveSearch: {
    activeFilters: '{count} active',
    advanced: 'Advanced filters',
    basis: {
      player: 'Player',
      village: 'Village',
    },
    basisHint:
      'Player: the whole account has stopped growing. Village: each village on its own, even if the player grows elsewhere.',
    capital: {
      any: 'All villages',
      exclude: 'No capitals',
      only: 'Capitals only',
    },
    capitalBadge: 'Capital',
    columns: {
      coordinates: 'Coords',
      distance: 'Distance',
      farmList: 'Farm list',
      status: 'Status',
    },
    dataNote: 'Population is updated once a day: the first column is the latest update.',
    delta: '{value} since the previous day',
    empty: 'No inactive village matches the filters.',
    excludeMyAlliance: 'Hide my alliance',
    farmList: {
      all: 'All',
      in: 'In list',
      out: 'Not in list',
    },
    farmListBadge: {
      in: 'In list',
      out: 'Not in list',
    },
    farmListHint:
      'Compares the results with the farm lists you imported in the Farm lists page, by coordinates.',
    farmListImport: 'Import it',
    farmListMissing: 'No farm list imported on this world.',
    fields: {
      alliances: 'Only these alliances',
      basis: 'Inactivity measured on',
      capital: 'Capital',
      coordinates: 'Coordinates',
      days: 'Inactive for',
      daysOption: '{n} days',
      daysOptionOne: '1 day',
      distance: 'Distance',
      excludeAlliances: 'Hide alliances',
      excludePlayers: 'Hide players',
      farmList: 'Farm list',
      includeNatars: 'Include Natars',
      max: 'Max',
      maxGrowth: 'Tolerated growth',
      min: 'Min',
      myVillage: 'Centre on my village',
      myVillagePlaceholder: 'Choose a village',
      playerPopulation: 'Player population',
      statuses: 'Status',
      tribes: 'Tribes',
      villagePopulation: 'Village population',
      x: 'X coordinate',
      y: 'Y coordinate',
    },
    maxGrowthHint: 'Inhabitants a player may gain over the period and still count as inactive.',
    noHistory:
      'This world does not keep a population history, so inactivity cannot be measured here.',
    openMap: "Open ({x}{'|'}{y}) on the game map",
    removeTag: 'Remove {value}',
    results: '{total} inactive villages',
    resultsOne: '1 inactive village',
    status: {
      growing: 'Slow growth',
      idle: 'Idle',
      natars: 'Natars',
      shrinking: 'Shrinking',
    },
    subtitle:
      'Villages of players whose population has not grown in the last days, sorted by distance from your coordinates.',
    tagsPlaceholder: 'Type and press Enter',
    title: 'Inactive search',
    today: 'Today',
  },
  incomings: {
    add: {
      auto: {
        ignoreMarkers: 'Ignore attacks with these markers',
        label: 'Rally point',
        links: '{count} village links found in the pasted page.',
        notRecognized: 'No village link found: copy the page from the game, not plain text.',
        placeholder: 'Paste the rally point here',
        raids: 'Also load raids?',
        step1: 'In the game open the rally point, "Incoming troops" tab.',
        step2: 'Select the page (Ctrl+A / Cmd+A) and copy it (Ctrl+C / Cmd+C).',
        step3:
          'Paste it below. With more pages of attacks, repeat for each page: duplicates are recognised.',
      },
      button: 'Add incoming',
      description:
        'Paste your rally point or enter an attack by hand. Arrival times are read in your Travick timezone: keep it the same as the one set in the game.',
      manual: {
        arrival: 'Arrival (date and time with seconds)',
        attacker: 'Attacker coordinates',
        coordsInvalid: 'Coordinates are whole numbers between -400 and 400.',
        defender: 'Attacked village',
        noVillages: 'No village found',
        type: 'Type',
      },
      mode: 'Insert mode',
      modes: {
        auto: 'Automatic',
        manual: 'Manual',
      },
      submit: 'Save attacks',
      submitting: 'Saving…',
      title: 'Add incoming attacks',
    },
    columns: {
      arrival: 'Arrival',
      attacker: 'Attacker',
      defender: 'Your village',
      hero: 'Hero',
      internalMarker: 'Internal marker',
      marker: 'Marker',
      troops: 'Possible troops',
      waves: 'Waves',
    },
    delete: 'Delete attack',
    deleteConfirm: {
      body: 'It disappears from the list and from the hero tracker. Notifications already sent stay where they are.',
      title: 'Delete this attack?',
    },
    deleted: 'Attack deleted.',
    empty: 'No incoming attacks match these filters.',
    errors: {
      alreadyLanded: 'The attack has already landed: its hero data can no longer change.',
      attackerNotFound: 'No village of this world at the attacker coordinates.',
      defenderNotFound: 'The attacked village does not belong to this world.',
      invalidArrival: 'Invalid arrival date/time.',
      invalidHeroChange: 'Invalid date/time for the change.',
      noServer: 'The group has no game world.',
    },
    filters: {
      anyType: 'All',
      attacker: 'Attacker',
      attackerPlaceholder: 'Alias or village',
      heroAbsentOnly: 'Only attacks without hero',
      status: 'Arrival',
      statuses: {
        all: 'All',
        past: 'Landed',
        upcoming: 'Upcoming',
      },
      title: 'Filters',
      type: 'Type',
    },
    hero: {
      absentSince: 'Outfit change seen on {time}: this attack carries no hero.',
      changedAt: 'When did you see the change?',
      description: 'Hero tracker status, hero screenshot and outfit change report.',
      imageAlt: "Screenshot of {attacker}'s hero",
      imageTakenAt: 'Hero as it was on {time}',
      imageTitle: "Attacker's hero",
      invalidType: 'Use a JPG, PNG, WebP or GIF image.',
      landed:
        'This attack has already landed: hero data are kept for reference only and can no longer be changed.',
      noImage: 'No screenshot uploaded.',
      now: 'Now',
      referenceHint:
        "Upload a screenshot of the attacker's hero as it is now. It is only a reference to notice an outfit change later: uploading it marks no attack.",
      referenceTitle: 'Reference: how the hero looks now',
      removeImage: 'Remove',
      replace: 'Replace hero screenshot',
      report: 'Confirm change',
      reported: 'Change saved: {count} attacks marked without hero.',
      reportHint:
        'If in game the hero no longer matches the reference, enter when you saw the change: every attack of this attacker in the group landing after that moment is marked as hero-less, and the group is notified.',
      reporting: 'Saving…',
      reportTitle: 'Did you see the hero change outfit?',
      title: 'Hero of {attacker}',
      tooLarge: 'The image is larger than 5 MB.',
      upload: 'Upload hero screenshot',
    },
    heroStates: {
      absent: 'No hero',
      tracked: 'Tracked',
      untracked: 'Not tracked',
    },
    heroTracker: {
      activeBody:
        "Hero tracker active: Travick checks the attacker's hero every 10 seconds and marks the attacks as hero-less as soon as the outfit changes.",
      inactiveBody:
        "Travick cannot connect to this world, so it can't watch the attacker's hero. Contact the site support to activate it. Meanwhile you can upload a screenshot of the attacker's hero and report an outfit change by hand.",
      inactiveTitle: 'Hero tracker not active',
    },
    in: 'in {time}',
    internalMarker: {
      edit: 'Edit internal marker',
      hint: "A note for the group's coordinators (e.g. fake, real, sniped). Leave empty to remove it.",
      title: 'Internal marker',
    },
    markers: {
      green: 'Green marker',
      grey: 'Grey marker',
      none: 'None',
      red: 'Red marker',
      yellow: 'Yellow marker',
    },
    noPlayer: 'You have no character in this group, so there are no attacks to show.',
    recap: {
      addMore: 'Add more',
      alreadyArrived: 'Already landed, not saved: {count}.',
      ignoredMarker: 'Ignored because of their marker: {count}.',
      notMember: 'Ignored: the attacked village does not belong to a member of the group',
      parsed: 'Movements read from the page: {count}.',
      saved: '{count} attacks saved.',
      savedOne: '1 attack saved.',
      unknownVillages:
        "Ignored: villages Travick doesn't know yet (they appear after the next world update)",
      updated: '{count} already present (waves updated if higher).',
    },
    reinforcements: {
      before: 'Lands {time} before the attack',
      description:
        'Villages of the group (and of associated groups sharing their troops) whose declared defensive troops, sent now, land before {time}.',
      empty: 'No village of the group has declared defensive troops.',
      fields: '{distance} fields',
      hideLate: 'Hide late villages',
      late: '{time} too late',
      legend: {
        comfortable: 'In time',
        late: 'Too late',
        target: 'Village under attack',
        tight: 'In time, under {minutes} min to spare',
      },
      listLabel: 'Reinforcing villages',
      noCounts:
        "Troop quantities are visible only to the group's admins, Defence Leaders and Offender Leaders.",
      noTarget: "The attacked village has no coordinates yet: the map can't be drawn.",
      open: 'Who can reinforce in time',
      refresh: 'Recompute from now',
      showLate: 'Show the {count} late villages',
      summary: '{inTime} villages in time, {late} too late',
      target: 'Under attack',
      title: 'Reinforcements for {village}',
      troopLate: 'Does not land in time',
      zoom: 'Show {village} on the map',
    },
    subtitle: 'Attacks on {player} in the selected group.',
    title: 'Incoming attacks',
    troops: {
      arena: 'TS {levels}',
      none: 'No troop fits the departure window',
      notComputed: 'No departure window given',
    },
    types: {
      attack: 'Attack',
      raid: 'Raid',
    },
    wavesCount: '{count} waves',
    window: {
      hint: 'Used to work out which troops the attack may carry. Fill in both only if you saw the attacks leave between your last login and your logout. Otherwise fill in just one: the range goes from that moment to now. Left empty, it means you saw the attacks leave and uploaded them straight away: they are taken as sent in the last few minutes.',
      lastLogin: 'Last login',
      logout: 'Logout',
      timezone: 'Times in your Travick timezone ({zone}).',
      title: 'When did you see the attacks leave? (optional)',
    },
  },
  incomingsRecap: {
    classifications: {
      fake: 'Fake',
      none: 'No info',
      probableFake: 'Possible fake',
      probableReal: 'Possible real',
      real: 'Real',
    },
    columns: {
      classification: 'Assessment',
      defender: 'Defender',
      departure: 'Departure',
    },
    departureBefore: 'before {time}',
    departureUnknown: 'Unknown',
    filters: {
      classification: 'Assessment',
      clearDeparture: 'Clear dates',
      defender: 'Defender',
      departure: 'Departure between',
      departureFrom: 'Departure from',
      departureHint:
        'Attacks that may have left in this range: the departure seen between login and logout, narrowed down by the troops that can make it in time. Attacks with no departure information are always included.',
      departureTo: 'Departure to',
    },
    subtitle: 'Every attack on the members of {group}.',
    title: 'Incomings recap',
  },
  landing: {
    areas: {
      defense: {
        body: 'Report attacks by pasting your rally point: Travick works out the compatible troops, leaders sort them from real to fake and send def calls with the departure time of every village.',
      },
      group: {
        body: 'Members, roles, applications and invite links. Several in-game alliances in one group, and associated groups sharing walls, troops and plans.',
      },
      logistics: {
        body: 'Resource pushes with quotas and live progress, and reservations of tiles to settle or conquer: no more two members chasing the same one.',
      },
      offense: {
        body: 'Attack plans in waves that land together: Travick optimises the tournament squares and everyone sees their own launches with a countdown.',
      },
      tools: {
        body: 'Inactive search, NPC optimisation and crop order: they work without an account too.',
      },
      villages: {
        body: 'Declare troops and smithy once, then analyse your farm lists: expected loot, lost targets, missing troops.',
      },
      world: {
        body: 'Every Travian world with daily rankings, the history of any player or alliance and a map to see where everyone is.',
      },
    },
    cta: {
      body: 'It takes a minute to sign up.',
      button: 'Get started',
      title: 'Ready to organise your alliance?',
    },
    features: {
      eyebrow: 'Features',
      groups: {
        body: 'Gather several in-game alliances under one confederation, with roles for admins, Defence Leaders and Offender Leaders.',
        title: 'Groups & roles',
      },
      heading: 'Everything you need, from defence to logistics',
      incomings: {
        body: 'Collect and share incoming attacks so defenders always know where to send troops.',
        title: 'Incoming attacks',
      },
      lead: 'Seven areas built around how alliances really play. Each item opens its page in the manual.',
      more: 'Explore every feature in the manual',
      personal: {
        body: 'Utilities for your own account, wherever you play — no alliance required.',
        title: 'Personal tools',
      },
      stats: {
        body: 'Player and alliance rankings, village lists and history for every world you follow.',
        title: 'Server intelligence',
      },
      subtitle: 'Built around how alliances really play.',
      title: 'What you get',
    },
    final: {
      guide: 'Read the manual',
      heading: 'Your confederation deserves a war room',
      lead: 'Create your account in a minute and invite your alliance mates.',
    },
    flow: {
      bots: {
        body: 'Attacks, def calls, pushes, plans and reservations land in your chats, with buttons that open Travick on the right page.',
        title: 'Discord and Telegram bots',
      },
      extension: {
        body: 'One click from the game page and Travick is up to date. For Chrome, Chromium-based browsers and Firefox.',
        title: 'Browser extension',
      },
      eyebrow: 'From the game to your chats',
      heading: 'One gesture, everyone up to date',
      lead: 'No numbers to copy by hand, no news lost in the chat.',
      paste: {
        body: 'Copy a Travian page and paste it: rally point, marketplace, reports, farm lists. Travick reads it for you.',
        title: "Paste, don't retype",
      },
    },
    hero: {
      ctaGuest: 'Continue as guest',
      ctaSecondary: 'I already have an account',
      ctaTry: 'Try it without an account',
      eyebrow: 'For alliances and confederations',
      headline: "Your confederation's war room",
      lead: 'Incoming attacks, def calls, attack plans that land together, resource pushes and statistics for every world: everything a Travian alliance needs, in one place, with your Discord and Telegram chats always in the loop.',
      or: 'Or',
      points: {
        bots: 'Discord and Telegram bots',
        daily: 'World data updated daily',
        roles: 'A menu for every role',
      },
      subtitle:
        'Travick gathers the tools a Travian alliance actually needs: incoming attacks, defence coordination, member management and personal utilities — all in one place.',
      title: 'Run your confederation like a war room',
    },
    how: {
      step1: {
        body: 'Sign up with an email or your Google account, then confirm your address.',
        title: 'Create your account',
      },
      step2: {
        body: 'Use the invite key from your leaders, or create your own group.',
        title: 'Join a confederation',
      },
      step3: {
        body: 'Your menu adapts to your role: you only see the tools you are allowed to use.',
        title: 'Start coordinating',
      },
      title: 'How it works',
    },
    meta: {
      title: 'Tools for Travian alliances',
    },
    mock: {
      bot: {
        channel: '#defence',
        message: 'New def call: reinforcements needed at the Northern Fortress.',
      },
      incoming: {
        class: 'Possible real',
        title: 'Incoming attack',
        village: 'Northern Fortress',
      },
      label: "Preview of a group's war room on Travick",
      live: 'Live',
      plan: {
        body: '{count} attacks land at {time}',
        title: 'Attack plan',
      },
      title: 'War room',
      wall: {
        progress: '{sent} of {goal} crop upkeep',
        title: 'Def call',
      },
    },
    roles: {
      admin: {
        body: 'Leads the group: members, invites, associations with other groups, bots and push requests.',
      },
      def: {
        body: 'Coordinates the defence: every attack on the group, real or fake, def calls and who answers them.',
      },
      eyebrow: 'Roles',
      heading: 'Everyone sees what they need',
      lead: 'The menu follows your role in the selected group. A member can hold more than one.',
      member: {
        body: 'Reports their attacks, answers def calls and pushes, and finds their launches already scheduled.',
      },
      off: {
        body: 'Plans the operations: targets, participants, waves and arrival times, published to the whole group.',
      },
    },
    steps: {
      account: {
        body: 'With an email or with Google, then confirm your address. Later you can sign in with Discord too.',
        title: 'Create your account',
      },
      group: {
        body: "Use your leaders' invite link, apply to a group or create a new one.",
        title: 'Join your confederation',
      },
      heading: 'Up and running in four steps',
      play: {
        body: 'Declare your troops: walls, plans and group troops use them from that moment on.',
        title: 'Start coordinating',
      },
      world: {
        body: 'Follow the world you play on and link your in-game character.',
        title: 'Pick your world',
      },
    },
    try: {
      eyebrow: 'No account needed',
      heading: 'Try it now, no sign-up',
      lead: 'World statistics and calculators are open to everyone: an account is only needed to save.',
      open: 'Open the tool',
      tabs: 'Tools to try',
    },
  },
  maintenance: {
    body: 'Travick is temporarily unavailable while we run some maintenance. It will be back as soon as possible.',
    endsAt: 'Expected back around {datetime}',
    noEndDate: 'No end time announced yet — check back a bit later.',
    title: 'We are working on it',
  },
  map: {
    canvas: {
      aria: 'World map, {count} villages drawn. Arrow keys to pan, plus and minus to zoom, Home to fit the whole world.',
      hint: 'Drag to pan, wheel to zoom',
    },
    controls: {
      exitFullscreen: 'Exit full screen',
      fullscreen: 'Full screen',
      reset: 'Fit the whole world',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
    },
    dialog: {
      conquered: 'Conquered from',
      distance: 'Distance',
      distanceUnit: 'slots',
      error: 'Village details are unavailable.',
      unknownOwner: 'unknown player',
    },
    empty:
      'Nothing selected yet: add a player or an alliance from the panels above and the map fills in.',
    entity: {
      countAlliance: '{villages} villages · {members} members',
      countPlayer: '{villages} villages on the map',
    },
    noFavorite: {
      cta: 'Add one from your profile.',
      message: 'You have no server yet.',
    },
    panels: {
      alliances: {
        empty: 'No alliance selected.',
      },
      disable: 'Hide {name} from the map',
      enable: 'Show {name} on the map',
      enableShort: 'Show',
      highlight: 'Highlight on the map',
      noResults: 'No match.',
      players: {
        empty: 'No player selected.',
        search: 'Search a player…',
      },
      remove: 'Remove {name}',
    },
    reference: {
      clear: 'Clear',
      hint: 'A village or a pair of coordinates, not both — from -{size} to +{size}. The map zooms onto the surrounding area.',
      villageLabel: 'Reference village',
      villagePlaceholder: 'Choose one of your villages',
      x: 'X',
      y: 'Y',
    },
    server: {
      readonlyHint:
        'This world comes from the shared link and is not among your servers, so it cannot be changed here.',
    },
    share: {
      button: 'Share this map',
      copied: 'Link copied to the clipboard.',
      hint: 'Creates a link that reopens the map exactly as it is now, panels included.',
      linkLabel: 'Link to share',
    },
    subtitle: 'Pick players and alliances, then explore where their villages are.',
    title: 'World map',
    tooltip: {
      populationSuffix: 'pop.',
    },
  },
  menu: {
    aggiorna_dati_cata_points_cdthammer: 'Update cata points / CD / hammer data',
    aggiorna_possessori_artefatti: 'Update artefact holders',
    alleanze: 'Alliances',
    archive_servers: 'Archive Servers',
    artefatti: 'Artefacts',
    attack_planning: 'Attack planning',
    attuali: 'Current',
    bot_discord: 'Discord bot',
    bot_telegram: 'Telegram bot',
    calc_def_send: 'Defense send calculator',
    calcola_falangiata: 'Phalanx calculator',
    calcola_invio_difese: 'Defence sending calculator',
    candidates: 'Candidates',
    classifica_alleanze: 'Alliance rankings',
    classifica_giocatori: 'Player rankings',
    counter_attack: 'Counter-attack calculator',
    crea_richiesta_push: 'Create push request',
    crop_capital_order: 'Crop capital order',
    crop_finder: 'Crop finder',
    def_call_stat: 'Def call stats',
    def_call_stats: 'Def call stats',
    defense_planning: 'Defence planning',
    farm_list: 'Farm lists',
    group_archive: 'Group archive',
    group_ranking: 'Group ranking',
    gruppi: 'Groups',
    guide_start: 'Second village guide',
    il_tuo_piano: 'Your plan',
    incomings: 'Incoming attacks',
    leadership: 'Leadership',
    lista_gruppi: 'Group list',
    mappa: 'Map',
    membri: 'Members',
    monitoraggio_push: 'Push monitoring',
    muri: 'Def calls',
    nemici: 'Enemies',
    news: 'News',
    npc_optimization: 'NPC optimisation',
    nuovo_piano: 'New plan',
    overview: 'Overview',
    panoramica: 'Overview',
    permanente: 'Permanent',
    piani_salvati: 'Saved plans',
    pianifica_artefatti: 'Plan artefacts',
    push: 'Push',
    recap_incoming: 'Incoming recap',
    report_main_nemico: 'Enemy main report',
    reservation: 'Reservations',
    ricerca_inattivi: 'Inactive search',
    richieste_ninjate: 'Sniping requests',
    richieste_push: 'Push requests',
    rotazione: 'Rotation',
    scout_planning: 'Scouting planning',
    servers: 'Servers',
    settings: 'Settings',
    tool_utili: 'Useful tools',
    traccia_main_nemici: 'Track enemy mains',
    track_enemies: 'Track enemies',
    troops: 'Troops',
    truppe: 'Troops',
    tuoi_gruppi: 'Your groups',
    tuoi_villaggi: 'Your villages',
  },
  mobileNav: {
    defCalls: 'Walls',
    incomings: 'Incomings',
    label: 'Group shortcuts',
    pushRequests: 'Push',
    yourPlan: 'Your plan',
  },
  nav: {
    logout: 'Log out',
  },
  news: {
    backToList: 'Back to the news',
    carousel: {
      goTo: 'Go to announcement {position}',
      next: 'Next announcement',
      previous: 'Previous announcement',
    },
    chips: {
      bug: 'Bug',
      feature: 'Feature',
    },
    empty: 'No news yet.',
    readMore: 'Read more',
    subtitle: 'Everything we shipped, newest first.',
    viewMore: 'View all',
  },
  notFound: {
    body: 'This page does not exist, or it is not part of the menu available to you.',
    code: '404',
    title: 'Page not found',
  },
  notify: {
    defCall: {
      changes: 'What changed',
      closed: {
        body: 'The coordinators closed this def call: no more defense is needed.',
        title: 'Def call closed · {village}',
      },
      contribution: {
        onBehalf: 'declared by {user}',
        progress: 'Def call progress',
        sent: '{player} sent {amount}',
        title: 'Defense on its way · {village}',
      },
      crop: 'Crop needed',
      deadline: 'Arrive by',
      deadlineLabel: 'Deadline',
      defense: 'Defense requested',
      defenseTypes: {
        anti_cavalry: 'Anti-cavalry only',
        anti_infantry: 'Anti-infantry only',
        any: 'Any',
      },
      exact: 'Exact arrival',
      fields: {
        arrive_by: 'Arrive by',
        arrive_from: 'Not before',
        defense_type: 'Defense requested',
        needs_crop: 'Crop needed',
        note: 'Notes',
        priority: 'Priority',
        required: 'Requested count',
        type: 'Type',
        village: 'Village',
      },
      no: 'No',
      noDeadline: 'No deadline, until the count is reached',
      note: 'Notes',
      player: 'Player',
      priorities: {
        high: 'High',
        low: 'Low',
        medium: 'Medium',
        urgent: 'Urgent',
      },
      priority: 'Priority',
      reached: 'Count reached',
      remaining: '{count} still missing',
      required: 'Requested count',
      sendDefense: 'Send defense',
      title: {
        between: 'Ninja defense call · {village}',
        normal: 'Defense call · {village}',
        permanent: 'Permanent def call · {village}',
      },
      types: {
        between: 'Ninja',
        normal: 'Normal',
        permanent: 'Permanent',
      },
      updateDefense: 'Update defense',
      updatedNotice: 'This is not a new def call: an existing one has been changed.',
      updatedTitle: 'Def call updated',
      window: 'Arrival window',
      windowText: 'between {from} and {to}',
      yes: 'Yes',
    },
    heroChanged: {
      body: 'Change seen at {time}. The following attacks carry no hero:',
      detectedByTracker: 'Detected by the hero tracker',
      reportedBy: 'Reported by {user}',
      title: '{attacker} changed hero equipment',
    },
    incomings: {
      arena: 'TS {levels}',
      arrival: 'Arrival',
      attacker: 'Attacker',
      defender: 'Defender',
      heroTracker: 'Hero tracker',
      heroTrackerOff: 'not active',
      heroTrackerOn: 'active',
      marker: 'Marker',
      openOnTravick: 'Open the def call on Travick',
      possibleTroops: 'Possible troops',
      possibleTroopsNone: 'no troop matches the departure window',
      possibleTroopsUnknown: 'no departure window given',
      raid: 'Raid',
      title: 'Incoming attacks on {village}',
      uploadedBy: 'Uploaded by {user}',
      waves: 'Waves',
    },
    plan: {
      attacks: 'Attacks',
      edit: {
        body: 'The plan has been changed: check your attacks again on Travick.',
        title: 'Attack plan changed: {name}',
      },
      landing: 'Landing',
      landingRange: 'from {from} to {to}',
      more: '+{count} more',
      new: {
        body: 'Every participant finds their attacks, with launch times, in “Your plan” on Travick.',
        title: 'New attack plan: {name}',
      },
      openPage: 'Your plan',
      participants: 'Participants',
    },
    push: {
      changes: 'What changed',
      closed: {
        body: 'The admin closed this push request: no more resources are needed.',
        title: 'Push closed · {village}',
      },
      contribution: {
        onBehalf: 'recorded by {user}',
        quota: '{player}: {sent} of {required}',
        quotaMet: 'quota met',
        sent: '{player} sent {amount}',
        title: 'Resources on their way · {village}',
      },
      fields: {
        amount: 'Amount',
        mode: 'Kind',
        note: 'Reason',
        resources: 'Resources',
        shared_groups: 'Associated groups',
        village: 'Village',
      },
      modeNames: {
        per_player: 'Per player',
        per_village: 'Per village',
        target: 'Target',
      },
      modes: {
        per_player: '{amount} per player',
        per_village: '{amount} per village owned',
        target: 'Target: {amount} in total',
      },
      note: 'Reason',
      player: 'Player',
      progress: 'Progress',
      reached: 'Target reached',
      record: 'Record shipment',
      remaining: '{count} still missing',
      request: 'Request',
      reset: {
        body: 'The admin cleared every recorded shipment ({count} shipments, {amount} resources): the count starts again from zero.',
        title: 'Shipments reset · {village}',
      },
      resources: 'Resources',
      resourceTypes: {
        both: 'Mixed or crop only',
        crop: 'Crop only',
        mixed: 'Mixed',
      },
      sendResources: 'Send resources',
      title: 'Push request · {village}',
      totalSent: '{amount} sent so far',
      updatedNotice: 'This is not a new request: an existing one has been changed.',
      updatedTitle: 'Push updated',
    },
    reportedBy: 'Reported by {group}',
    reservation: {
      cancelled: {
        body: '{user} cancelled the reservation: the slot is free again.',
        title: 'Reservation cancelled · {target}',
      },
      cancelledBy: 'Cancelled by',
      created: {
        title: 'New reservation · {target}',
      },
      expired: {
        body: 'The reservation of {player} has expired: the slot is free again.',
        title: 'Reservation expired · {target}',
      },
      expiredAt: 'Expired on',
      expires: 'Expires',
      freeTile: "({x}{'|'}{y}) · free slot",
      fromCropFinder: 'Reserved from the crop finder: it does not expire, the admin frees it.',
      hours: '{count} hours',
      hoursOne: '{count} hour',
      kinds: {
        conquer: 'Conquer',
        found: 'Settle',
      },
      noExpiry: 'No expiry',
      note: 'Note',
      onBehalf: 'on behalf of the player',
      openMap: 'View on the map',
      openPage: 'Reservations',
      owner: '{owner} · {population} inhabitants',
      reservedAt: 'Reserved on',
      reservedBy: 'Entered by',
      reservedFor: 'Reserved for',
      target: 'Village to conquer',
      tile: 'Slot',
      validFor: 'Valid for',
      wasValidUntil: 'Was valid until',
    },
  },
  npcOptimization: {
    items: {
      add: 'Add to the list',
      celebrationOption: '{name} (Town Hall {level})',
      clear: 'Clear list',
      empty:
        'The list is empty: add fields, buildings, troops or anything else you need to pay for.',
      emptyRange: 'The target level must be above the current one.',
      from: 'Current',
      loading: 'Loading costs…',
      notAvailable: 'Not available for this tribe: choose again.',
      pick: 'Choose…',
      quantity: 'Qty',
      remove: 'Remove from the list',
      rowCost: 'Cost by resource',
      rowTotal: 'Total cost of this row',
      title: 'What you want to complete',
      to: 'Target',
      what: 'What',
    },
    kinds: {
      building: 'Building',
      celebration: 'Celebration',
      field: 'Field',
      manual: 'Other cost',
      research: 'Research',
      smithy: 'Smithy',
      troop: 'Troops',
    },
    presets: {
      badge: '{count}/{max}',
      close: 'Close',
      confirmDelete: 'Delete "{name}"? This can\'t be undone.',
      count: 'Saves used: {count} of {max}.',
      current: 'Configuration: {name}',
      delete: 'Delete',
      empty: 'You haven\'t saved any configuration yet. Use "Save" to find it here later.',
      errors: {
        limitReached: 'You already have {max} saved configurations: overwrite or delete one.',
        nameRequired: 'Give the configuration a name.',
        tooLarge: 'This configuration is too large to be saved: shorten the list.',
      },
      limitHint:
        'You already have {max} saved configurations: use the name of an existing one to overwrite it, or delete one first.',
      load: 'Load',
      loaded: 'Configuration "{name}" loaded.',
      loading: 'Loading…',
      login: 'Log in to save configurations',
      nameLabel: 'Name',
      namePlaceholder: 'e.g. Capital fields to 10',
      open: 'Saved',
      overwrite: 'Overwrite',
      overwriteHint: 'A configuration with this name already exists: it will be overwritten.',
      save: 'Save',
      saved: 'Configuration "{name}" saved.',
      saveDescription:
        'Resources, list and leftover rule are saved to your account, so you can load them again later. Up to {max} saves.',
      saveTitle: 'Save configuration',
      summary: 'Items in the list: {count}',
      title: 'Saved configurations',
      unreadable: "This configuration can't be read anymore.",
      updated: 'Configuration "{name}" updated.',
    },
    remainder: {
      crop: 'All to crop',
      hint: {
        crop: 'The leftover all goes to crop.',
        mixed: 'The leftover is split evenly across the four resources.',
        noCrop: 'The leftover is split across lumber, clay and iron.',
        troops:
          "The leftover becomes as many units of the troop as it pays for; what's left after that is split evenly.",
      },
      label: 'What to do with the leftover',
      mixed: 'Split evenly',
      noCrop: 'No crop',
      pickTroop: 'Choose a troop…',
      troop: 'Troop for the leftover',
      troops: 'Into troops',
      troopsResult: 'The leftover also pays for {count} × {troop}.',
    },
    resources: {
      clay: 'Clay',
      crop: 'Crop',
      detailed: 'By resource',
      iron: 'Iron',
      mode: 'Enter them',
      sum: 'Total: {total}',
      title: 'Your resources',
      total: 'Total only',
      totalHint:
        'Useful when you only know the sum, e.g. what you will have after some raids. Without the split there is no way to tell whether the NPC is needed.',
      totalLabel: 'Total resources',
      tribe: 'Tribe',
      wood: 'Lumber',
    },
    result: {
      available: 'Available',
      columns: {
        after: 'After NPC',
        needed: 'Needed',
        now: 'Now',
        resource: 'Resource',
      },
      copy: 'Copy {resource}: {amount}',
      missing: 'Missing',
      remainder: 'Left over',
      spent: 'Cost',
      status: {
        empty: 'Nothing in the list yet: below, your resources split by the rule you picked.',
        insufficient: 'Not enough resources: you are {amount} short.',
        notNeeded:
          'No NPC needed: you already have enough of every resource. If you still want to trade, here is how.',
        npc: 'Type these amounts into the NPC merchant (tap one to copy it).',
      },
      title: 'NPC distribution',
    },
    subtitle:
      "Enter the resources you have and what you want to complete: you'll see whether they are enough and the four amounts to type into the NPC merchant.",
    title: 'NPC optimisation',
  },
  overviewVillages: {
    autoRoles: {
      confirm: {
        action: 'Recalculate all',
        body: 'The type of every village is computed again from its troops, overwriting the ones you chose by hand.',
        title: 'Recalculate every village type?',
      },
      done: 'Type set on {count} villages.',
      doneOne: 'Type set on 1 village.',
      hint: 'Push, Defence, Attack, Scout, WWK or WWR, guessed from the troops in each village.',
      mode: {
        all: 'Recalculate all villages',
        unassigned: 'Only villages without a type',
      },
      nothing: 'No village type changed.',
      open: 'Automatic type',
      pasteOption: 'Also set the village type from the troops',
    },
    charts: {
      allVillages: 'All villages',
      empty: 'Nothing to draw yet: the chart starts from your first update.',
      hide: 'Hide charts',
      power: {
        attack: 'Attack',
        defenseCavalry: 'Against cavalry',
        defenseInfantry: 'Against infantry',
        title: 'Attack and defence power over time',
      },
      show: 'Show charts',
      total: {
        title: 'Total troops over time',
      },
      villagePicker: 'Village shown in the charts',
    },
    columns: {
      arena: 'Arena',
      attack: 'Attack',
      average: 'Average',
      openMap: 'Open {coords} on the game map',
      sum: 'Sum',
      total: 'Total',
    },
    compactNumbers: 'Compact numbers (120K)',
    empty: {
      noMatch: 'No village of the selected types.',
      noPlayer: {
        action: 'Claim your character',
        body: 'You have not claimed a character on {server}, so we cannot tell which villages are yours. Claim it from your profile: until then there is nothing to show here.',
        title: 'No character on this world',
      },
      noServer: {
        action: 'Choose a world',
        body: 'This page shows the villages you own on a world. Add a world to your list first: until then there is nothing to show here.',
        title: 'No world selected',
      },
      noVillages: 'This character has no village yet.',
    },
    history: {
      andMore: '{names} and {count} more',
      andMoreOne: '{names} and 1 more',
      empty: 'No update recorded yet.',
      smithy: {
        title: 'Smithy update history',
      },
      source: {
        import: 'Pasted from the game',
        inline: 'Edited in the table',
      },
      subtitle: '{count} updates recorded. Click an entry for the per-village detail.',
      subtitleOne: '1 update recorded. Click it for the per-village detail.',
      troops: {
        title: 'Troops update history',
      },
      villagesOne: '1 village',
    },
    lastUpdate: 'Last update: {when}',
    neverUpdated: 'Never updated yet.',
    overallTotal: 'Total across every tribe:',
    paste: {
      diagnosis: {
        detail: 'Tables examined: {tables} · village links: {links} · villages read: {recognized}',
        noTables: {
          smithy:
            'No table arrived: the paste came through as plain text. Select the table in the game page and copy it again with Ctrl+C.',
          troops:
            'No table arrived: the paste came through as plain text. Select the table in the game page and copy it again with Ctrl+C.',
        },
        notYours: {
          smithy:
            'The villages in this paste are not the ones of your character on this world. Check you copied the page of the right account.',
          troops:
            'The villages in this paste are not the ones of your character on this world. Check you copied the page of the right account.',
        },
        wrongPage: {
          smithy:
            'This looks like another page: no research level columns in it. Open the village overview and switch to the Troops tab, then the smithy view, and copy that page.',
          troops:
            'This looks like another page: no per-troop columns in it. Open the village overview and switch to the Troops tab (village/statistics/troops), then copy that page.',
        },
      },
      done: '{count} villages updated.',
      doneOne: '1 village updated.',
      label: 'Pasted overview',
      links: '{count} village links found in the paste.',
      linksOne: '1 village link found in the paste.',
      nothingChanged: 'Nothing to update: the values were already these.',
      notRecognized:
        'No village recognised: the paste lost the village links. Select the table in the game page and copy it again.',
      placeholder: 'Click here and paste with Ctrl+V (Cmd+V on Mac)',
      recognized: '{count} villages recognised.',
      recognizedOne: '1 village recognised.',
      skipped: '{count} villages in the paste are not among yours and were skipped.',
      skippedOne: '1 village in the paste is not among yours and was skipped.',
      smithy: {
        description:
          'Paste the whole smithy overview: every village it contains is overwritten with the research levels it reports.',
        open: 'Update smithy',
        step1:
          'In game open the smithy overview: the one with the research levels, one column per upgradable troop.',
        title: 'Update the smithy from the game',
      },
      step2: 'Select the whole page (Ctrl+A), copy it (Ctrl+C) and paste it below (Ctrl+V).',
      step3:
        "The extra page content is discarded on its own: what matters is that the table's village links come through, which is what tells one village from another.",
      submit: 'Update',
      submitting: 'Updating…',
      troops: {
        description:
          'Paste the whole troops overview: every village it contains is overwritten with the quantities it reports, zeros included.',
        open: 'Update troops',
        step1:
          'In game open the village overview and go to the Troops tab (village/statistics/troops): it is the one with a column per troop type.',
        title: 'Update troops from the game',
      },
    },
    roles: {
      apply: 'Assign',
      assigned: 'Type assigned to {count} villages.',
      assignedOne: 'Type assigned to 1 village.',
      bulkLabel: 'Type to assign',
      clearFilter: 'Clear filter',
      clearSelection: 'Deselect',
      defense: 'Defense',
      offense: 'Offence',
      push: 'Push',
      scout: 'Scout',
      selectAll: 'Select every village of this tribe',
      selected: '{count} villages selected',
      selectedOne: '1 village selected',
      unassignedCount: '{count} still unassigned',
      unassignedCountOne: '1 still unassigned',
      wwk: 'WWK (catapults)',
      wwr: 'WWR (rams)',
    },
    shared: {
      badge: 'Shared with your group',
      hint: 'These troops belong to the group: whoever is in it with the same character sees and edits the same data. Leaving the group leaves them to whoever stays.',
    },
    subtitle: '{player} on {server} — {count} villages',
    subtitleOne: '{player} on {server} — 1 village',
    tabs: {
      smithy: 'Smithy',
      troops: 'Troops',
    },
    title: 'Your villages',
    troops: {
      slot: 'Troop {slot}',
    },
    unknownTribe: 'Unknown tribe',
    villagesCount: '({count} villages)',
    villagesCountOne: '(1 village)',
  },
  player: {
    detail: {
      backTo: 'Back to {label}',
      charts: {
        breakdown: {
          empty: 'No villages to show yet.',
          title: 'Villages: founded / conquered / lost',
        },
        victoryPoints: {
          empty: 'No victory points history yet.',
          title: 'Victory points over time',
        },
      },
      deletedNotice:
        'This player was deleted on {date}: villages and map show the situation before the deletion, and the charts stop on that day.',
      fields: {
        conquered: 'Conquered',
        daysPlayed: 'Days played',
        daysPlayedValue: '{count} days',
        deletedOn: 'Deleted on {date}',
        founded: 'Founded',
        lost: 'Lost',
        noAlliance: 'No alliance',
        openProfile: 'Open Travian profile',
        registeredSince: 'Registered since',
        victoryPoints: 'Victory points',
      },
      history: {
        events: {
          conquered: 'Conquered {village} from:',
          founded: 'Founded {village}',
          lostTo: 'Lost {village}, conquered by:',
          zeroed: '{village} was destroyed',
        },
        title: "{alias}'s history",
      },
      lostVillages: {
        conqueredByLabel: 'Conquered by:',
        empty: 'No lost villages.',
        reasonConqueredUnknown: 'Conquered',
        reasonZeroed: 'Destroyed',
        title: 'Lost villages',
      },
      map: {
        empty: 'No villages to place on the map.',
        title: 'Village positions',
        titleBeforeDeletion: 'Village positions before deletion',
      },
      villages: {
        columns: {
          coordinates: 'Coordinates',
          date: 'Date',
          origin: 'Origin',
          victoryPoints: 'Victory points',
        },
        conquered: 'Conquered',
        conqueredFromLabel: 'Conquered from:',
        empty: 'No villages yet.',
        founded: 'Founded',
        title: 'Current villages',
        titleBeforeDeletion: 'Villages before deletion',
      },
    },
  },
  privacy: {
    lastUpdated: 'Last updated: {date}',
    link: 'Privacy & Cookie Policy',
    sections: {
      changes: {
        p1: 'We may update this policy when the service changes. The date at the top shows the latest revision, and significant changes will be announced on the site.',
        title: 'Changes to this policy',
      },
      controller: {
        p1: 'This site is run by Travick, which is the data controller.',
        p2: 'For any question about this policy or your data, write to {email} or use the contact form.',
        title: 'Data controller',
      },
      cookies: {
        p1: 'Travick uses no profiling, advertising or analytics cookies and loads no third-party tracking scripts. In your browser (localStorage and sessionStorage) it only stores what it needs to work and the preferences you choose:',
        p2: "These are technical tools exempt from consent (art. 122 of Legislative Decree 196/2003 and the Italian Data Protection Authority's guidelines of 10 June 2021), which is why the site shows no cookie banner. They stay in your browser and are not used to track you. You can delete them at any time from your browser settings: you will be signed out and your preferences will go back to their defaults.",
        p3: 'The Google sign-in script is loaded only when you press the Google button: from then on Google may set its own cookies, governed by its own policy.',
        title: 'Cookies and browser storage',
      },
      data: {
        items: {
          account:
            'Account data: nickname, email address, password (stored only as a hash) and your preferences (language, timezone, date format, theme).',
          contact: 'Contact form: the email address, subject and message you send us.',
          extension:
            'Browser extension: if you install it, the game data it sends with the token you generate in your profile.',
          game: 'Game data you enter: claimed characters, villages, troops, reports, farm lists and anything else you paste or type into the tools. Public world data (rankings, map) comes from the official Travian map files.',
          groups:
            'Group data: membership and roles in groups and, when the group admins enable them, the Discord and Telegram identifiers used to send notifications.',
          social:
            'Social sign-in: if you sign in with Google or Discord, the identifier, email address and name that the provider sends us.',
          technical:
            'Technical data: IP address and request logs, used to protect the service from abuse.',
        },
        p1: 'We only collect what is needed to provide the service:',
        p2: 'We do not use your data for advertising, we do not sell it and we do not build marketing profiles.',
        title: 'What data we collect',
      },
      intro: {
        p1: 'This policy explains which personal data Travick collects when you use the site, why it does so and which rights you have, under Regulation (EU) 2016/679 (GDPR) and Italian Legislative Decree 196/2003.',
        p2: 'Travick is an independent tool for Travian players: it is not affiliated with or endorsed by Travian Games GmbH.',
        title: 'Introduction',
      },
      minors: {
        p1: 'The service is not intended for people under 14.',
        title: 'Minors',
      },
      purposes: {
        items: {
          contact: 'Answering your requests (art. 6(1)(b) and (f) GDPR).',
          emails:
            'Service emails, such as address verification, password reset and the updates you subscribe to (art. 6(1)(b) GDPR).',
          legal:
            'Complying with legal obligations and defending our rights (art. 6(1)(c) and (f) GDPR).',
          security:
            'Security, abuse prevention and request limits based on the IP address (art. 6(1)(f) GDPR, legitimate interest in keeping the service available and secure).',
          service:
            'Providing the service and managing your account (art. 6(1)(b) GDPR, performance of a contract).',
        },
        title: 'Purposes and legal bases',
      },
      recipients: {
        items: {
          backendHosting: 'Application and database hosting: {backendHosting}.',
          frontendHosting: 'Website hosting: {frontendHosting}.',
          mail: 'Email delivery: {mailProvider}.',
        },
        p1: 'Data is processed by the controller and by providers acting on its behalf as processors (art. 28 GDPR):',
        p2: 'When you use Google or Discord sign-in, or a group is connected to Discord or Telegram, those services process data as independent controllers under their own privacy policies. We disclose data to no one else, except to the authorities when the law requires it.',
        title: 'Who processes the data',
      },
      retention: {
        items: {
          account:
            'Account and game data: as long as the account exists. Once it is deleted, the data is erased within [N] days, except what we must keep by law.',
          backups: 'Backups: overwritten on a rolling basis within [N] days.',
          contact: 'Contact requests: for the time needed to answer, then up to [N] months.',
          logs: 'Technical logs: up to [N] days.',
        },
        title: 'How long we keep data',
      },
      rights: {
        p1: 'At any time you can ask for access to your data, its rectification or erasure, the restriction of processing and data portability, and you can object to processing based on legitimate interest (arts. 15–21 GDPR). Many of your data can be viewed and changed directly from your profile and account settings; for everything else write to {email}. We reply within one month.',
        p2: 'You also have the right to lodge a complaint with the Italian Data Protection Authority (Garante per la protezione dei dati personali, {url}) or with the authority of the country where you live.',
        title: 'Your rights',
      },
      security: {
        p1: 'Passwords are stored only as a hash, connections are encrypted (HTTPS) and access to data is limited to what each role needs.',
        title: 'Security',
      },
      transfers: {
        p1: 'Some providers, such as Netlify, Google and Discord, are based in the United States. Transfers rely on the EU-U.S. Data Privacy Framework or, failing that, on the Standard Contractual Clauses approved by the European Commission.',
        title: 'Transfers outside the EU',
      },
    },
    storage: {
      columns: {
        duration: 'Duration',
        keys: 'Keys',
        purpose: 'Purpose',
      },
      preferences: {
        duration: 'Until you delete it',
        purpose: 'Remembers theme, language, date format, sidebar and selected world',
      },
      session: {
        duration: 'Until you sign out',
        purpose: 'Keeps you signed in',
      },
      technical: {
        duration: 'Until the tab is closed',
        purpose: 'Prevents reload loops after a site update',
      },
      tools: {
        duration: 'Until you delete it',
        purpose: "Remembers the calculators' inputs and the display options of some pages",
      },
      translations: {
        duration: 'Until the texts are updated',
        purpose: 'Keeps a copy of the interface texts so the site opens in your language',
      },
    },
    subtitle: 'How Travick handles your data and what it stores in your browser.',
    title: 'Privacy & Cookie Policy',
    toc: 'Contents',
  },
  profile: {
    discord: {
      errors: {
        already_linked: 'This Discord account is already linked to another Travick user.',
        generic: "Couldn't link the Discord account, please try again.",
      },
      hintEmpty:
        "You'll be asked to authorise Travick on Discord: that's how we know the account is yours.",
      hintLinked:
        "Filled in by Discord, it can't be edited by hand. Linking a new account replaces this one, including for signing in with Discord.",
      label: 'Discord',
      link: 'Link Discord',
      linked: 'Discord account linked.',
      notLinked: 'No Discord account linked',
      relink: 'Link a new account',
    },
    extension: {
      confirmRevokeBody:
        "The extension using it will stop working at once. To use it again you'll need a new token.",
      confirmRevokeTitle: 'Revoke "{name}"?',
      copied: 'Token copied.',
      copy: 'Copy',
      copyFailed: "Couldn't copy automatically: select the token and copy it by hand.",
      create: 'Generate token',
      createdAt: 'Created {date}',
      createdHint:
        "It's shown only this once: we don't keep it in readable form. If you lose it, revoke it and generate a new one. Don't share it: whoever has it can send data in your name.",
      createdTitle: 'Token "{name}" created: copy it now and paste it into the extension.',
      done: 'Done',
      download: {
        chrome: 'Extension for Chrome',
        firefox: 'Extension for Firefox',
        hint: 'Download and install it, then connect it with a token.',
      },
      empty: 'No tokens yet.',
      errors: {
        tooManyTokens: "You've reached the limit of {max} tokens: revoke one to create another.",
      },
      lastUsedAt: 'Last used {date}',
      listTitle: 'Your tokens',
      nameHint: 'Only for you: it tells you which browser uses it.',
      nameLabel: 'Token name',
      namePlaceholder: 'e.g. Chrome laptop',
      neverUsed: 'Never used',
      revoke: 'Revoke',
      revoked: 'Token "{name}" revoked.',
      revokeLabel: 'Revoke token {name}',
      secretLabel: 'Extension token',
      subtitle:
        'Tokens that let the Travick extension send troops, smithy, incoming attacks, reports and farm lists from Travian with one click. Create one per browser.',
      title: 'Browser extension',
    },
    favorites: {
      added: '{name} added to your favourites.',
      addTitle: 'Add a server',
      allAdded: 'Every server found is already in your favourites.',
      archiveLink: 'See the archive of concluded servers',
      confirmRemoveBody:
        'The server will disappear from the header selector. You can add it back any time.',
      confirmRemoveTitle: 'Remove {name} from your favourites?',
      confirmRemoveWithPlayer:
        'You will also lose the link with the character {alias}: you would have to set it again if you add the server back.',
      empty: 'You have no favourite server yet.',
      loadMore: 'Load more',
      noResults: 'No server matches your search.',
      removed: '{name} removed from your favourites.',
      searchPlaceholder: 'Search a server by name…',
      subtitle: 'These feed the server selector in the header.',
      title: 'Favourite servers',
    },
    groups: {
      archiveLink: 'See the archive of concluded groups',
      confirmLeaveBody:
        'You will lose your role and access to this group’s content. You can only rejoin with a new invite.',
      confirmLeaveTitle: 'Leave {name}?',
      empty: 'You do not belong to any group yet.',
      leave: 'Leave group',
      left: 'Left {name}.',
      player: 'Your character in this group',
      select: 'Make active',
    },
    identity: {
      avatar: 'Profile picture',
      avatarHint: 'JPG, PNG, WebP or GIF, up to 5 MB. It is resized and converted for you.',
      avatarRemove: 'Remove picture',
      avatarRemoved: 'Profile picture removed.',
      avatarTooLarge: 'That image is too large: the limit is 5 MB.',
      avatarUpload: 'Upload an image',
      avatarUploaded: 'Profile picture updated.',
      avatarUploading: 'Uploading…',
      avatarWrongType: 'Unsupported format. Use JPG, PNG, WebP or GIF.',
      lobbyName: 'Travian lobby name',
      lobbyNameInfo:
        'This can help your alliance leadership recognize you in the game, if it differs from your account name.',
      lobbyNameInfoLabel: 'More info about the Travian lobby name',
      propic: 'Avatar URL',
      propicDisabledHint: 'You are using an uploaded image. Remove it to use a link instead.',
      propicHint: 'Direct link to an image. Leave empty to use your initials.',
    },
    player: {
      change: 'Change character',
      claimed: '{alias} linked to {server}.',
      confirmReleaseAction: 'Release and delete',
      confirmReleaseBody:
        'You declared troops or smithy for {count} villages of this character: releasing it deletes them, history included. This cannot be undone.',
      confirmReleaseBodyOne:
        'You declared troops or smithy for 1 village of this character: releasing it deletes them, history included. This cannot be undone.',
      confirmReleaseTitle: 'Release {alias}?',
      current: 'Linked now',
      label: 'Your character',
      lockedByGroup: "You're in a group on this server — leave it to change or remove this.",
      none: 'Link your character',
      noRank: 'Unranked',
      noResults: 'No character matches your search.',
      pickSubtitle: 'Search your in-game alias. Only one character per server can be linked.',
      pickTitle: 'Your character on {server}',
      population: '{count} pop.',
      rank: 'Rank {rank}',
      release: 'Remove the link',
      released: 'Link with {alias} removed.',
      replaces: 'Will replace {alias}.',
      searchHint: 'Type at least {min} characters to search.',
    },
    saved: 'Profile updated.',
    subtitle: 'Your public details and the worlds you follow.',
  },
  push: {
    actions: {
      close: 'Close early',
      delete: 'Delete',
      edit: 'Edit',
      more: 'More actions',
      participants: 'Who pushed',
      record: 'Record shipment',
      reopen: 'Reopen',
      reset: 'Reset shipments',
      send: 'Send resources',
      shipments: 'Shipments',
    },
    add: 'New push request',
    admin: {
      manual: 'By hand: {count}',
      manualTitle: 'Typed by hand, not read from the market page: it may be wrong',
      shortfall: 'Under quota: {count}',
      shortfallTitle: "Members of the group who haven't sent their quota yet",
    },
    associatedBadge: 'From {group}',
    closed: 'Push request closed.',
    closedBadge: 'Closed',
    columns: {
      mine: 'Your share',
      note: 'Reason',
      progress: 'Progress',
      request: 'Request',
      village: 'Village',
    },
    created: 'Push request created.',
    deleteConfirm: {
      body: 'The request and every shipment recorded on it are removed for everyone, associated groups and statistics included. To keep them, close it instead.',
      title: 'Delete this push request?',
    },
    deleted: 'Push request deleted.',
    detail: {
      back: 'All push requests',
      closedAt: 'Closed on',
      createdAt: 'Created',
      info: 'Details',
      manage: 'Manage',
      noQuota: 'No quota for you on this request.',
      open: 'Open details',
      requestedBy: 'Requested by',
      sharedWith: 'Also shown to',
      status: {
        active: 'Open',
      },
    },
    empty: 'No open push request.',
    emptyClosed: 'No closed push request.',
    errors: {
      alreadyRegistered: 'These deliveries have already been recorded on this push.',
      invalidPartner: 'One of the groups can no longer see your pushes: reopen the form.',
      noAmount: 'Enter the resources you sent.',
      noDeliveries:
        'No outgoing delivery found in the pasted page: copy the whole marketplace page after sending.',
      noResourceType: 'Choose at least one kind of resources.',
      noServer: 'The group has no game world.',
      notMember: 'You have no character in this group.',
      notSender:
        'That player is neither a member of the group nor of one of its declared alliances.',
      recipientSender: "The owner of the pushed village doesn't send resources to themselves.",
      requestClosed: 'The admin closed this request: no more shipments can be recorded.',
      targetUnknown:
        'The village of this push has no coordinates to compare with: record it by hand.',
      villageNotFound: 'No village of this world at those coordinates.',
      wrongTarget: 'These deliveries go to {found}, not to the village of this push.',
    },
    estimate: {
      group: '{players} members of the group, {villages} villages',
      label: 'Estimated total',
    },
    form: {
      amountLabels: {
        per_player: 'Resources per player',
        per_village: 'Resources per village owned',
        target: 'Total resources requested',
      },
      create: 'Create request',
      description: 'Which village needs resources, how much and why.',
      examplePerPlayer: 'Every player must send {amount}. Only you can close it.',
      examplePerVillage:
        'Example: a player with 10 villages must send {total} ({amount} × 10). Only you can close it.',
      exampleTarget: '{amount} in total, from everyone together. Closes by itself when reached.',
      member: 'Player',
      memberPlaceholder: 'Choose a player',
      memberVillage: 'Village',
      memberVillagePlaceholder: 'Choose a village',
      mode: 'Kind of request',
      modeHints: {
        per_player: 'Each player sends this amount. Only you can close it.',
        per_village:
          'Each player sends this amount for every village they own. Only you can close it.',
        target: 'Closes by itself when the total is reached.',
      },
      note: 'Reason (optional)',
      notePlaceholder: 'e.g. WW level 50 by Sunday',
      resources: 'Resources accepted',
      resourcesHint: 'Shown to the players: every resource sent is counted anyway.',
      shared: 'Show it to the associated groups too',
      sharedHint:
        'Only the groups you share your pushes with. They also get the Discord/Telegram messages, if they enabled them.',
      targets: {
        coords: 'Coordinates',
        member: 'Member',
      },
      titleEdit: 'Edit push request',
      titleNew: 'New push request',
      village: 'Village to push',
      villageHint: 'Any village of the world, an ally outside the group too.',
    },
    mine: {
      banner:
        "Push requests where you haven't sent your share yet: {count}. They are highlighted in red.",
      done: 'You sent your share ({required}).',
      met: 'Done',
      missing: '{count} missing',
      sent: 'sent by you',
      short: "You haven't sent what was requested yet: {missing} still missing out of {required}.",
    },
    modes: {
      per_player: 'Per player',
      per_village: 'Per village',
      target: 'Target',
    },
    notVisible: "This push request can't be seen from the selected group.",
    reached: 'Target reached',
    record: {
      allianceMember: 'alliance {tag}',
      amount: 'Resources sent',
      associated: 'associated group',
      closed: 'The admin closed this request: no more shipments can be recorded.',
      description: 'Resources you sent to {village}.',
      found: 'Deliveries found: {count}',
      history: 'Shipments recorded',
      manualBadge: 'by hand',
      manualHint:
        "A typed amount can't be checked: the admin will see it marked as entered by hand.",
      manualTitle: 'Entered by hand: it may be wrong',
      me: '{alias} (you)',
      metTitle: 'Quota sent',
      modes: {
        auto: 'From market',
        manual: 'By hand',
      },
      modesLabel: 'How to record',
      none: 'No shipment recorded yet.',
      notRecognized: 'No delivery recognised: copy the whole marketplace page from the game.',
      onBehalfBy: 'recorded by {user}',
      participants: 'Progress per player',
      pasteLabel: 'Marketplace page',
      pastePlaceholder: 'Paste the marketplace page here',
      perVillageNote: 'The per-village quota follows the villages each player owns now.',
      player: 'Sent by',
      playerHint:
        "You can record for another member or for a player of the group's declared alliances.",
      recipient: 'recipient',
      remove: 'Remove shipment',
      removed: 'Shipment removed.',
      saved: 'Recorded: {amount} resources.',
      shipmentsOf: 'Shipments of {alias}',
      shortTitle: "Hasn't sent the requested quota",
      step1: 'In Travian, open the Marketplace, tab "Send resources", after sending.',
      step2: 'Select the whole page (Ctrl+A / Cmd+A) and copy it.',
      step3:
        'Paste it below: the outgoing deliveries to this village are counted, repeats included.',
      submit: 'Record',
      title: 'Record shipment',
    },
    remaining: '{count} missing',
    reopened: 'Push request reopened.',
    requestText: {
      per_player: '{amount} per player',
      per_village: '{amount} per village',
      target: '{amount} in total',
    },
    resetConfirm: {
      body: 'Every shipment recorded so far is removed, by everyone and from every group: the count starts again from zero and the group is told on Discord/Telegram (push update). The request itself stays.',
      title: 'Reset every shipment of this request?',
    },
    resetDone: 'Shipments reset.',
    resourceKinds: {
      both: 'Mixed or crop only',
      crop: 'Crop only',
      mixed: 'Mixed',
    },
    resources: {
      clay: 'Clay',
      crop: 'Crop',
      iron: 'Iron',
      lumber: 'Lumber',
    },
    showClosed: 'Show closed requests',
    subtitle:
      'Resources requested by {group} and by the associated groups that share their pushes with it.',
    title: 'Push requests',
    totalSent: 'sent in total',
    updated: 'Push request updated.',
  },
  pushStats: {
    columns: {
      amount: 'Sent',
      compliance: 'Quotas',
      last: 'Last shipment',
      manual: 'By hand',
      missing: 'Missing',
      participation: 'Participation',
      player: 'Player',
      requests: 'Requests',
    },
    empty: 'No push request in this period.',
    emptyPlayers: 'No player to show.',
    highlights: {
      mostPresent: 'Most present',
      mostSent: 'Sent the most',
      never: 'Never took part',
      neverNone: 'Everyone took part at least once.',
      presence: '{requests} of {eligible} requests',
      short: 'Under quota',
      shortNone: 'Every quota has been met.',
    },
    kpi: {
      amount: 'Resources sent',
      amountHint: '{covered} of {total} requests answered ({percent})',
      average: 'Avg. participation',
      averageHint: 'requests answered out of those each could answer',
      noQuotas:
        'No request with a quota (per village / per player) here: target requests have none.',
      participants: 'Participants',
      participantsHint: 'out of {total} members',
      quotas: 'Quotas met',
      quotasHint: '{met} of {total} quotas (per village / per player)',
      requests: 'Requests',
      requestsHint: '{active} still open',
    },
    legend:
      'Requests seen by the group (its own and those shown by associates), created in the period. Shipments recorded from this group, credited to who sent them. The per-village quota uses the villages each player owns now. "By hand" counts the shipments typed rather than read from the market page.',
    missingShort: '{amount} missing',
    never: 'Never',
    notAllowed: 'Push monitoring is for the group admin.',
    quotasOf: '{met} of {total}',
    requestsOf: '{requests} of {eligible} requests',
    requestsOnly: '{requests} requests',
    subtitle:
      'How the players of {group} answer the push requests: who takes part, who sends the most, who meets the quota.',
    title: 'Push monitoring',
    types: {
      total: 'All',
    },
    typesLabel: 'Kind of request',
    villages: 'Villages: {count}',
  },
  rank: {
    alliances: {
      filterPlaceholder: 'Search by tag…',
      title: 'Alliance ranking',
    },
    players: {
      diffDown: 'Down {value} since yesterday',
      diffUp: 'Up {value} since yesterday',
      empty: 'No ranked players yet.',
      guestServer: {
        empty: 'No active servers available right now.',
        placeholder: 'Choose a server',
      },
      noFavorite: {
        cta: 'Add one from your profile, then come back.',
        message: "You haven't picked a favourite server yet.",
      },
      title: 'Player ranking',
    },
  },
  reservation: {
    actions: {
      cancel: 'Cancel reservation',
      cancelShort: 'Cancel',
      confirm: 'Confirm',
      confirmHint: 'Settled or conquered: closes the reservation without notifying the channels',
      mapShort: 'Map',
      openMap: 'View on the game map',
    },
    add: 'Reserve',
    adminOnlyNotice: 'In this group only the admin can reserve slots: ask them if you need one.',
    cancelConfirm: {
      body: 'The slot {tile} reserved for {player} becomes free for anyone in the group. The channels will be notified.',
      bodyMine:
        'Your slot {tile} becomes free for anyone in the group. The channels will be notified.',
      confirm: 'Yes, cancel it',
      title: 'Cancel the reservation?',
    },
    cancelled: 'Reservation cancelled: the slot is free again.',
    cancelledBy: 'cancelled by {user}',
    columns: {
      expires: 'Expires in',
      player: 'Reserved for',
      status: 'Status',
      target: 'Target',
      tile: 'Slot',
    },
    confirmConfirm: {
      body: {
        conquer:
          '{player} conquered the village at {tile}. The reservation is closed and moves to the history; no message is sent to the channels.',
        found:
          '{player} settled the slot {tile}. The reservation is closed and moves to the history; no message is sent to the channels.',
      },
      confirm: 'Yes, done',
      title: 'Confirm the reservation?',
    },
    confirmed: 'Reservation confirmed: well done!',
    confirmedBy: 'confirmed by {user}',
    created: 'Slot reserved.',
    empty: 'No active reservation. Reserve a slot with “Reserve”.',
    emptyFiltered: 'No reservation matches the filters.',
    emptyHistory: 'No expired, cancelled or confirmed reservation yet.',
    errors: {
      alreadyReserved:
        '{player} reserved this slot first: it can be taken again once their reservation expires.',
      noServer: 'The group has no game world.',
      notActive: 'This reservation has already expired, been cancelled or been confirmed.',
      notMember: 'You have no character in this group.',
      onBehalfAdminOnly: 'Only the group admin can reserve on behalf of another player.',
      outOfMap: 'Outside the map: coordinates go from -{radius} to {radius}.',
      playerNotMember: 'That player is not a member of the group.',
      tileOccupied:
        '{village} is already there: you cannot settle on it. Reserve it to conquer instead.',
      villageNotFound:
        'There is no village at those coordinates: there is nothing to conquer. Reserve it to settle instead.',
    },
    filters: {
      allKinds: 'All',
      clear: 'Clear filters',
      kind: 'Kind',
      label: 'Filters',
      mine: 'Mine only',
      search: 'Search',
      searchPlaceholder: 'Player, village or owner',
    },
    form: {
      coordinates: 'Coordinates',
      description: 'Nobody else in the group can take it for the next {hours} hours.',
      expiresPreview: 'If you reserve now, it lasts until {date}.',
      forMyself: 'Myself',
      freeTile: 'Free slot: you can settle here.',
      kind: 'What for',
      kindHint:
        'A village can only be conquered, a free slot only settled: it is chosen for you from the coordinates.',
      noOtherMembers:
        'As group admin you can reserve on behalf of another member, but there is no other player in the group yet.',
      note: 'Note (optional)',
      notePlaceholder: 'e.g. next to my 15-cropper',
      reservedFor: 'Reserve for',
      reservedForHint: 'As group admin you can reserve on behalf of another member.',
      submit: 'Reserve',
      taken: 'Already reserved by {player} until {date}.',
      takenNoExpiry: 'Already reserved by {player}, with no expiry (crop finder).',
      title: 'Reserve a slot',
      villageOf: 'of {player}, {population} inhabitants',
    },
    freeTile: 'Free slot',
    kinds: {
      conquer: 'Conquer',
      found: 'Settle',
    },
    noExpiry: 'No expiry',
    onBehalf: 'entered by {user}',
    population: '{count} inhabitants',
    status: {
      active: 'Active',
      cancelled: 'Cancelled',
      confirmed: 'Confirmed',
      expired: 'Expired',
    },
    subtitle:
      'Slots to settle and villages to conquer reserved by {group}. A reservation lasts {hours} h, then the slot is free again.',
    tabs: {
      active: 'Active',
      history: 'History',
    },
    title: 'Reservations',
  },
  servers: {
    detail: {
      archive: {
        playerBoxTitle: 'Associated character',
        troopsDialog: {
          empty: 'No troops were saved for this world.',
          smithyLevelShort: 'lvl {level}',
          subtitle: 'Last update before the world ended.',
          title: 'Saved troops — {server}',
          totals: 'Totals',
        },
        viewTroops: 'View saved troops',
      },
      charts: {
        playersOverTime: {
          empty: 'No history yet.',
          title: 'Active players over time',
        },
        tribes: {
          empty: 'No tribe data yet.',
          title: 'Active players by tribe',
        },
        villagesOverTime: {
          empty: 'No history yet.',
          title: 'Total villages over time',
        },
      },
      config: {
        allianceShowIncomingAttacks: 'Alliance attack notifications',
        boostedStart: 'Boosted start',
        crop18: '18 Cropper Field',
        eliteBalancing: 'Confederations enabled',
        keepVidOnConquer: 'Keep tribe on conquest',
        mergingTroopsAndForwardingTroops: 'Troop merging & forwarding',
        settlersCanChangeTribe: 'Settlers can change tribe',
        title: 'World settings',
      },
      favorite: {
        add: 'Add to favourites',
        remove: 'In your favourites',
      },
      lateDataBanner: {
        body: 'Data collection for this world only started on {date}, several days after it began — figures before that date may be missing.',
        title: 'Data may be incomplete',
      },
      noDataBanner: {
        body: "We're sorry, but we don't have any player, village or alliance data for this world — it most likely ended before this site started tracking it.",
        title: 'Data not available for this world',
      },
      notStartedBanner: {
        body: 'It is scheduled to open on {date}. Players, villages and alliances will show up here once the round begins.',
        title: "This world hasn't started yet",
      },
      progressionTimeline: {
        points: {
          artifacts: 'Artifacts',
          constructionPlans: 'Construction plans',
          end: 'Server end',
          firstWWLevelOne: 'First WW at level 1',
          secondVillage: 'Second village',
          start: 'Server start',
        },
        title: 'Server progression',
      },
      recentDeleted: {
        dialogTitle: 'Deleted players',
        empty: 'No deleted players yet.',
        seeAll: 'See all deleted players',
        title: 'Recently deleted players',
      },
      stats: {
        activePlayers: 'Active players',
        deletedAlliances: 'Deleted alliances',
        deletedPlayers: 'Deleted players',
        playersWithoutAlliance: 'Players without alliance',
        totalAlliances: 'Total alliances',
        totalConquests: 'Total conquests',
        totalVillages: 'Total villages',
      },
      topAlliances: {
        seeAll: 'See full ranking',
        title: 'Top 5 alliances',
      },
      topPlayers: {
        empty: 'No ranked players yet.',
        seeAll: 'See full ranking',
        title: 'Top 5 players',
      },
      wonderRanking: {
        columns: {
          alliance: 'Alliance',
          level: 'Level',
          player: 'Player',
          position: '#',
          wonder: 'Wonder',
        },
        empty: 'No Wonder of the World ranking available yet.',
        open: 'WW ranking',
        title: 'Wonder of the World ranking – {server}',
        winner: 'Winner',
      },
    },
    list: {
      card: {
        addFavorite: 'Add {name} to favourites',
        openMap: 'Open the map of {name}',
        removeFavorite: 'Remove {name} from favourites',
        tribes: 'Tribes',
      },
      columns: {
        artefactsDate: 'Artefacts date',
        canRegister: 'Registration open',
        constructionPlansDate: 'Construction plans date',
        endDate: 'End date',
        name: 'Server name',
        players: 'Total players',
        startDate: 'Start date',
      },
      empty: 'No servers match this filter.',
      filterPlaceholder: 'Search by name…',
      filters: {
        allDomains: 'All domains',
        allServerNames: 'All servers',
        allTypes: 'All types',
        canRegister: {
          all: 'All',
          label: 'Registration',
          no: 'Closed',
          yes: 'Open',
        },
        domain: 'Domain',
        domainValues: {
          america: 'America',
          arabics: 'Arabics',
          asia: 'Asia',
          europe: 'Europe',
          international: 'International',
        },
        includeConcluded: 'Also show concluded servers',
        other: 'Other',
        serverType: 'Server type',
        startFrom: 'Start from',
        startTo: 'Start to',
        toggle: 'Filters',
      },
      openGameServer: 'Open {name} on the game server',
      showing: 'Showing {shown} of {total}',
      sortBy: 'Sort by',
      status: {
        concluded: 'Concluded',
        running: 'Running',
        scheduled: 'Scheduled',
      },
      timeline: {
        empty: 'No servers match this filter.',
        hint: 'Drag or scroll to move along the timeline. Click a bar to open the server.',
        title: 'Servers timeline',
      },
      timelineButton: 'Timeline',
    },
  },
  settings: {
    notifications: {
      app: 'In-app',
      desktop: 'Desktop',
      email: 'Email',
      saved: 'Notification settings saved.',
      title: 'Notifications',
    },
    password: {
      firstPasswordNotice:
        'Your account was created through a social provider, so there is no current password to confirm.',
      invalid: 'The new password does not meet the requirements below.',
      submit: 'Update password',
      subtitle: 'Choose a strong password you do not reuse anywhere else.',
      success: 'Password updated.',
    },
    preferences: {
      dateFormat: {
        eu: 'EU (dd.mm.yy, 24h)',
        hint: 'Saved to your account and applied on every device, everywhere dates and times are shown.',
        iso: 'ISO (yyyy-mm-dd, 24h)',
        title: 'Date format',
        uk: 'UK (dd/mm/yy, 12h)',
        us: 'US (mm/dd/yy, 12h)',
      },
      language: 'Interface language',
      languageHint: 'Saved to your account and applied on every device.',
      saved: 'Preferences saved.',
      theme: {
        classic: 'Classic',
        classicHint: 'Parchment and Travick blue',
        dark: 'Dark',
        darkHint: 'Deep night, high contrast',
        dim: 'Dim',
        dimHint: 'Soft slate, easy on the eyes',
        hint: 'Saved to your account and applied on every device. It takes effect as soon as you choose it; save to keep it.',
        title: 'Theme',
      },
      timezoneDefault: 'Default (Europe/London, UTC+00/+01)',
      timezoneHint:
        'Used for the clock in the header. Defaults to London time (UTC+00 in winter, UTC+01 in summer) when nothing is selected.',
      timezoneInfo:
        'The timezone you pick is the reference for every time shown in the app: clock, calculations and planning. The default is server time (Europe/London: UTC+00 in winter, UTC+01 in summer). Check with your confederacy leader before changing it, so you do not end up working on a different timezone than the rest of the confederacy.',
      timezoneInfoLabel: 'About the timezone',
      title: 'Preferences',
    },
    subtitle: 'Preferences, security and notifications.',
  },
  sidebar: {
    collapse: 'Collapse sidebar',
    contactUs: 'Contact us',
    expand: 'Expand sidebar',
    followUs: 'Follow us',
    manual: 'Manual',
    navigation: 'Main navigation',
    pendingInside: '{count} to check in the entries inside',
    player: {
      label: 'Your character',
      openPlayer: 'Open the profile of {name}',
      openServer: 'Open the world {name}',
      population: 'Population',
      rank: 'Rank',
      villages: 'Villages',
    },
    privacy: 'Privacy & Cookies',
  },
  startGuide: {
    about: {
      expectations: 'Expected settle time, by resources farmed on day 1',
      farm0: '0–20k',
      farm0Hours: '~120+ h',
      farm20: '20–40k',
      farm20Hours: '105–120 h',
      farm40: '40–80k',
      farm40Hours: '95–105 h',
      farm80: '80k+',
      farm80Hours: 'under 95 h',
      farmNote:
        'Same for all four strategies. With farm troops count the net profit of day 1: troops are an investment and do not pay back at once.',
      title: 'About “{name}”',
    },
    autosave: {
      failed: 'Not saved',
      retry: 'Retry',
      saved: 'Saved',
      saving: 'Saving…',
    },
    catchUp: {
      body: '{count} steps before #{number} are not ticked yet. Mark them as done too?',
      confirm: 'Mark them',
      dismiss: 'No',
    },
    credits:
      'From the “T4.6 Start Guide” spreadsheet by Caím, made with the help of Pokedex and Dirtyclown.',
    extra: {
      intro:
        'If you went really fast (a good spawn, or bossing it yourself) you may run short of culture points: speeding up before celebration 1 leaves less time for your CP production. These are the buildings with the cheapest CP per resource, in order.',
      title: 'Extra culture points',
    },
    goals: {
      fields4In12h: 'Goal: all fields to level 4 within 12 hours',
      fields4In16h: 'Goal: all fields to level 4 within 12–16 hours',
      fieldsIn2h: 'Goal: get here within 2 hours',
      party1In48h: 'Goal: celebration 1 within 48 hours',
      party1In72h: 'Goal: celebration 1 within 72 hours',
    },
    list: {
      allDone: 'Every step is done.',
      cost: 'Cost {value}',
      cp: '{value} CP/day',
      farm: 'Break-even at {value} resources: {raids} full raids, or {perHour24}/h over 24 h ({perHour48}/h over 48 h).',
      hideDone: 'Hide done',
      markDone: 'Mark step {number} as done',
      nextBadge: 'Next',
      perCp: '{value} res. per CP',
      pop: '{value} pop',
      reset: 'Start over',
      reward: 'Reward {value}',
      showDone: 'Show done',
      tier: 'Task {tier}',
      title: 'Steps',
      totals: 'Then: {cp} CP/day · {pop} pop · balance {balance} (without production)',
    },
    next: {
      completeBody: 'You have completed every step of the guide.',
      completeTitle: 'Time to found your village!',
      done: 'Done',
      title: 'Next step · #{number}',
    },
    notes: {
      bonus25: 'Activate the 25% resource production bonus.',
      critical3pFarm:
        'A more critical phase, where you need to think for yourself. Every start is different, and so are the CP generated so far: if you went fast with a lot of farming, your CP production has given you less, and the celebrations must make up for it. Work out your situation and add some CP production here if needed: see the “Extra culture points” list below for cheap CP.',
      crop6:
        'Recommended: crop fields to level 6, for the 1 CP per day each one gives. CP get more expensive later, so count each crop field as a 1,250-resource investment in CP: the field then costs only about 2,000, with a return of 66 hours — reasonable, on top of the cheap CP.',
      decisive3p:
        'Here comes the tricky part. Pay attention!\nIf you farmed well and expect celebration 1 in less than 48 hours, your hourly production has generated too few culture points. Compensate by raising your CP production: work out how many CP you need and how many you lack, and use the “Extra culture points” list below. You have 3 celebrations and at least 48 hours of production to make it up.',
      decisive4p:
        'Here comes the tricky part: the build-up has one decisive moment and it is here. Pay attention!\nIf you farmed well and did celebration 1 in less than 48 hours, your hourly production has generated too few culture points. Compensate by upgrading crannies to level 7: work out how many CP you need and how many you lack, and use the crannies to fill the gap. You have at least 3 celebrations and about 60 hours of production to make it up. Note: one cranny is needed anyway to reach 250 population.',
      egyptianIron:
        "Egyptians: skip iron mines to level 5, thanks to the hero's resource production.",
      farmUnits3p:
        'It is hard to say how many farm troops to make: the break-even shown on the troop step helps you judge whether they pay off. Recommended: 10 to 20 cavalry, or 30 to 60 infantry. Timing matters too: oases only produce once all the animals are dead, so starting farm troops right away is not recommended. The best number depends on the oases near you. Equites Imperatoris are not recommended: they are expensive and hard to make more profitable than Legionnaires.',
      farmUnits4p:
        'It is hard to say how many farm troops to make: the break-even shown on the troop step helps you judge whether they pay off. Recommended: 7 to 12 cavalry, or 30 to 60 infantry. Timing matters too: oases only produce once all the animals are dead, so starting farm troops right away is not recommended. The best number depends on the oases near you: judge from your results.',
      fields5Roi:
        'Choose here which fields to upgrade based on their return, or invest more in farm troops: you already farm and have more income. Focusing on CP production may be better, since it has to go up anyway to make it with 4 celebrations. Return of fields to level 5 (with the reward of a level 6 hero): wood 67.4 h, clay 67.7 h, iron 82.5 h, crop 76.7 h. Iron mines are not recommended, and a no-go for Egyptians.',
      grainMill:
        'Optional: grain mill level 1. With crop fields at level 6 it pays back in 63 hours, task reward included, but you will have to demolish a cranny to make room.',
      greatSpawn:
        'With a great spawn, if you expect to farm 100k+ on day 1, move wood, clay and iron fields to level 5 after celebration 1. You can settle within about 92 hours, with celebration 1 within 20 hours. Remember to build them after the celebration, or your income will not be enough.',
      heroFirstAdventure: 'Send the hero only on the first adventure.',
      heroHorse:
        'Send the hero on the shortest adventure to get a horse, then smash animals in the oases!',
      heroPoints:
        'Put points in strength according to how many oases you can raid:\n• no oases: at most 2 points\n• 1–5 oases: 8 to 12 points\n• 6+ oases: 12 points or more\nUse the rewards to bring the hero back to full health after the animals, and put the rest in resource production. You will rarely use the hero for 24 hours or more: some extra points in production keep the income going when there are no more oases to clear.',
      ironRoi:
        "Iron mines don't pay back well: with a level 6–8 hero it takes about 81 hours (reward included) for roughly +75 iron per hour (with the 25% bonus). Compare it with your farming numbers and decide whether more farm troops later are the better investment.",
      partyQueue:
        'Remember: a celebration already in the queue does not get shorter when you upgrade the town hall, and CP production raised while a celebration is queued counts from the next one.',
      raidOasis1h:
        'Raid oases until you need to walk more than 1 hour to one you are sure to clear. Then consider adventure 2 (resource bounty): it gives about 2,300 resources.',
      raidOasis2h:
        'Keep raiding oases until they are more than 2 hours away; then consider putting almost all points in resource production, together with the Book of Wisdom. The book comes from adventure 6, usually within 24 hours of the start.',
      soloOasis:
        'Theutates Thunders, Equites Imperatoris and Steppe Riders can be sent alone to an empty oasis.',
      stableRewards:
        "The CP and population of the stable depend on taking it to level 3 or 5: don't count on them too early.",
      townHall:
        'Pro tip: if you have more resources than you need and room to settle sooner, consider upgrading the town hall: celebrations get shorter and you get their CP sooner.',
    },
    reset: {
      body: 'The {count} steps ticked in this guide will be cleared. Settings stay as they are.',
      confirm: 'Start over',
      done: 'Progress cleared.',
      title: 'Start the guide over?',
    },
    settings: {
      farmFirst: 'First batch',
      farmHint: 'How many troops depends on the oases near you: 0 removes the step from the list.',
      farmSecond: 'After celebration 1',
      farmUnit: 'Farm troop',
      heroLevel: 'Hero level',
      heroLevelHint: 'Task rewards grow by 2% per hero level.',
      title: 'Your start',
      tribe: 'Tribe',
      tribeHint: 'Sets the cost of the settlers and the farm troops.',
    },
    speed: {
      backTo1x: 'Open the 1x guide',
      label: 'Server speed',
      soon: 'Soon',
      unavailableBody:
        'For now only the guide for 1x servers exists: the other speeds will follow.',
      unavailableTitle: 'The {speed} guide is not available yet',
    },
    steps: {
      all: '{building}: all to level {level}',
      count: '{count}× {building} to level {level}',
      demolish: 'Demolish {count}× {building}',
      farmUnits: {
        first: 'Train {count}× {unit} for farming',
        second: 'Train {count}× more {unit} for farming',
      },
      launch: 'Keep {value} resources (750 of each) to found the village',
      one: '{building} to level {level}',
      party: 'Small celebration #{number}',
      research: 'Research {unit}',
      settlers: 'Train settlers: {count}',
      task: {
        completeEconomy: 'Task “Complete economy”: all resource fields to level {value}',
        cultureProduction: 'Task “Culture points”: produce {value} CP per day',
        evenGrowth: 'Task “Even growth”: one field of each type to level {value}',
        population: 'Task “Population”: reach {value} inhabitants',
      },
    },
    strategies: {
      '3p-farm': {
        cons: 'More expensive, less room to accelerate',
        cp: '~230+ CP/day',
        description:
          'The way to go for real farmers who also want a good base. With 3 celebrations the first one comes later, so there is more time to make your investment pay off: it goes for a lot of resource income early and invests in culture points afterwards. Fixing the culture points costs more, but you will also have more resources to spend, and the resulting base helps after settling too. It needs a lot of activity and experience: one mistake and it is unlikely to pay off.',
        fields: 'All fields level 5, one crop 7',
        focus: 'Early settle, better base',
        name: '3 celebrations · Farm',
        pros: 'Solid base, fast, the best for farming',
        style: 'Hero + troop raiding',
        troops: '~50+ crop upkeep',
      },
      '3p-sim': {
        cons: 'More expensive, less room to accelerate',
        cp: '~210+ CP/day',
        description:
          'If you want a good base and still want to settle fast, this is your pick. Starting with 3 celebrations costs a little more than the 4-celebration strategies, but it pays off after settling: you end up with about 10% more culture point production and a bit more resource income to keep celebrating, without losing crop. With no farming at all the expected settle time is about 130 hours, against 125 for the 4-celebration start; the gap shrinks with every resource you farm.',
        fields: 'All fields level 5, crop 6',
        focus: 'Early settle, better base',
        name: '3 celebrations · Sim',
        pros: 'Solid base, straightforward and fast',
        style: 'Hero raiding & simulator',
        troops: 'No crop upkeep',
      },
      '4p-farm': {
        cons: 'Smaller base, needs a good start, spawn and active micro farming',
        cp: '~180+ CP/day',
        description:
          'A style built for efficiency. Farming should not be the main priority, because it is hard to make much profit before the decisive moment (the timing of celebration 1): here farming is a fast source of resources with a better return than, for example, fields to level 5. After that moment it is easier to speed up by investing more in farming, since the returns can be very good. Pick this one if you want to settle fast and cheaply without depending only on your activity on day 1.',
        fields: 'Crop level 5, the rest level 4',
        focus: 'Early settle, flexibility',
        name: '4 celebrations · Farm',
        pros: 'Cheap to accelerate, flexible and fast',
        style: 'Hero + troop raiding',
        troops: '~25+ crop upkeep',
      },
      '4p-sim': {
        cons: 'Smaller base, needs a good start and spawn',
        cp: '~180+ CP/day',
        description:
          'A simple and very efficient style. How fast you settle depends only on what you earn by killing animals in the oases: the goal is settling as fast and as cheaply as possible. It suits a player who goes all out on day 1 and then plays efficiently. It is also more flexible on culture points: there are more ways to get cheap CP and therefore to speed up.',
        fields: 'All fields level 5',
        focus: 'Early settle, flexibility',
        name: '4 celebrations · Sim',
        pros: 'Cheap to accelerate, flexible and fast',
        style: 'Hero raiding & simulator',
        troops: 'No crop upkeep',
      },
    },
    strategy: {
      focus: 'Focus:',
      label: 'Strategy',
      parties: '{count} celebrations',
      progress: '{done}/{total} done',
    },
    subtitle:
      'The build order to found your second village as fast as possible in T4.6: choose the server speed and a strategy, then follow the steps.',
    summary: {
      cost: 'Resources spent',
      cp: 'CP/day when settling',
      label: 'Summary',
      loginToTrack: 'Log in to tick the steps.',
      progress: 'Progress',
      steps: 'Steps',
    },
    title: 'Second village guide',
    track: {
      login: 'Log in to tick the steps you have done: your progress is saved on your account.',
      loginButton: 'Log in',
    },
    tribes: {
      egyptian: 'Egyptians',
      gaul: 'Gauls',
      hun: 'Huns',
      roman: 'Romans',
      teuton: 'Teutons',
    },
  },
  trackEnemies: {
    actions: {
      delete: 'Delete army',
      growth: 'Estimate the growth',
      growthShort: 'Growth',
      markAlive: 'Mark alive again',
      markDestroyed: 'Mark dead/destroyed',
      more: 'More actions',
      view: 'See the army',
    },
    add: {
      another: 'Add another',
      created: 'Enemy army added.',
      createdFor: 'New army: {player}, village {village}.',
      dateHint:
        'Leave it empty to use the one written in the report. Game time, i.e. your Travick time zone.',
      dateLabel: 'Date of the report (optional)',
      description:
        'Paste a report: the date of the report is the reference, and a village already tracked is updated on its own row.',
      kindLabel: 'Kind of report',
      kinds: {
        battle: 'Attack / raid',
        scout: 'Scout',
      },
      notRecognized:
        "This doesn't look like a report: paste it from the game page, not as plain text.",
      olderReport:
        'There is a more recent report for this village: it stays the one shown, this one goes into the history.',
      open: 'Add',
      pasteLabel: 'Report',
      pastePlaceholder:
        'Open the report in the game, select it all (Ctrl+A) and paste it here (Ctrl+V)',
      recognized: 'Report recognised.',
      reportDate: 'Report of {date}',
      scoutHint: "The scouted player's troops are recorded (reinforcements are left out).",
      sideLabel: 'Which side is the enemy?',
      sides: {
        attacker: 'The attacker',
        attackerHint: 'It attacked: what came back alive, from its village.',
        defender: 'The defender',
        defenderHint: 'It was attacked: what is left alive in the attacked village.',
      },
      submit: 'Record',
      survivors: 'Survivors recorded',
      title: 'Add an enemy army',
      updated: 'Enemy army updated.',
      updatedFor: 'Army of {player}, village {village}, updated.',
    },
    armyRemoved: 'Army deleted.',
    changeSince: '{value} since the previous report',
    columns: {
      army: 'Army',
      report: 'Report',
      uploaded: 'Last upload',
      village: 'Village',
    },
    deleteConfirm: {
      body: 'The army of {village} and all its reports will be removed for the whole group.',
      title: 'Delete this army?',
    },
    destroyedBadge: 'Dead / destroyed',
    empty: 'No enemy army reported yet. Paste a battle or scout report with “Add”.',
    emptyFiltered: 'No army matches the filters.',
    errors: {
      alreadyRegistered: 'This report has already been recorded.',
      futureDate: 'The date is in the future.',
      invalidDate: "The date of the report couldn't be read: enter it below.",
      memberVillage: 'That village belongs to a member of your group: did you pick the wrong side?',
      noServer: 'The group has no game world.',
      notLatest: 'Only the most recent report can be edited: reload the army.',
      noTroopInfo: "The report doesn't show the troops of that side (failed scout?).",
      noTroops: 'Enter at least one troop or one wounded.',
      reportNotFound: 'No report with that side was found in the pasted text.',
      sideRequired: 'Choose whether the enemy is the attacker or the defender.',
      villageNotFound:
        "That village is not in this world's data (an oasis, or founded after the last update).",
    },
    filters: {
      alliance: 'Alliance',
      clear: 'Clear filters',
      from: 'Report from',
      label: 'Filters',
      player: 'Player',
      status: 'Status',
      statuses: {
        alive: 'Alive',
        all: 'All',
        destroyed: 'Destroyed',
      },
      to: 'Report to',
    },
    growth: {
      barracksLevel: 'Barracks level',
      cavalry: 'Cavalry',
      description:
        'Army of {village}, report of {date}: estimate of the troops trained since then.',
      destroyed:
        'Marked dead/destroyed on {date}: the estimate starts from zero, from that moment. Only the wounded are left, for the hospital.',
      disclaimer:
        'Upper bound: non-stop training, resources and crop not considered. Chiefs and settlers are left out. The wounded are assumed queued at once (left waiting they lose 10% a day).',
      estimated: 'Estimated army: {count} units (was {before})',
      great: {
        barracks: 'Great barracks too',
        stable: 'Great stable too',
      },
      greatLevel: {
        barracks: 'Great barracks level',
        stable: 'Great stable level',
      },
      helmet: {
        cavalry: 'Cavalry helmet',
        infantry: 'Mercenary helmet (infantry)',
      },
      hospital: 'Hospital',
      hospitalHeal: 'Heal the wounded',
      hospitalHint:
        "Heals in half the training time, one queue for infantry and cavalry, in parallel with the training; hero items don't count. Spartans: Asclepeion, same speed.",
      hospitalLevel: 'Hospital level',
      hours: 'Hours of training',
      hoursHint:
        "Since the report: {elapsed}. Lower it if you think they don't train around the clock.",
      hoursHintDestroyed:
        "Since it was marked destroyed: {elapsed}. Lower it if you think they don't train around the clock.",
      infantry: 'Infantry',
      noCatalog: 'The tribe of this army is unknown: there is nothing to compute.',
      noHelmet: 'None',
      nothing: 'Choose at least one troop in training.',
      noTroop: 'None',
      noWounded: "No wounded in the latest report: the hospital doesn't count.",
      queues: {
        barracks: 'barracks',
        greatBarracks: 'great barracks',
        greatStable: 'great stable',
        hospital: 'hospital',
        stable: 'stable',
        workshop: 'workshop',
      },
      resetHours: 'Since the report',
      resetHoursDestroyed: 'Since the destruction',
      result: 'Estimate',
      siege: 'Siege (workshop)',
      stableLevel: 'Stable level',
      title: 'How much may it have grown?',
      troop: 'Troop in training',
      unitTime: '{building}: one every {time}',
      workshop: 'Siege (workshop)',
      workshopLevel: 'Workshop level',
      wounded: 'Wounded in the latest report',
    },
    hero: 'Hero',
    manual: {
      changePlayer: 'Change',
      date: 'Seen on (optional)',
      dateHint: 'Leave it empty for now. Game time, i.e. your Travick time zone.',
      description: 'Enemy player, village of origin and troops.',
      hero: 'The hero is with the army',
      noPlayers: 'No player found.',
      open: 'Insert by hand',
      player: 'Enemy player',
      searchHint: 'Type at least {min} characters of the name.',
      submit: 'Save',
      title: 'Insert an enemy army by hand',
      troops: 'Troops',
      village: 'Village of origin',
      villagePlaceholder: 'Choose the village',
      wounded: 'Wounded (optional)',
      woundedHint:
        'Only infantry and cavalry can be wounded: they count in the hospital of the growth estimate.',
      woundedOf: 'Wounded {troop}',
    },
    markedAlive: 'Army marked as alive again.',
    markedDestroyed: 'Army marked as dead/destroyed.',
    noTroops: 'No troops',
    reportRemoved: 'Report deleted: the row is back to the previous one.',
    reportsCount: '{count} reports',
    reportsCountOne: '{count} report',
    slot: 'Troop {slot}',
    sources: {
      attack: 'Attacking',
      defense: 'Defending',
      manual: 'By hand',
      scout: 'Scouted',
    },
    subtitle: 'Enemy armies reported by {group}: one row per village, from the most recent report.',
    title: 'Track enemies',
    totalUnits: '{count} units',
    view: {
      comparedWith: 'Changes compared with the report of {date}.',
      confirmRemove: 'Delete',
      current: 'Current army',
      destroyed: 'Marked dead/destroyed on {date} by {name}.',
      editDate: 'Date of the report',
      edited: 'Edited by {name} on {date}',
      editHint: 'Survivors per troop. The report will show who edited it.',
      editReport: 'Edit this report',
      editSave: 'Save changes',
      editTitle: 'Edit the latest report',
      history: 'Reports ({count})',
      removeReport: 'Delete this report',
      reportEdited: 'Report updated.',
      title: 'Army of {village}',
      total: 'Total: {count} units',
      uploadedBy: 'Added by {name} on {date}',
      woundedNote: 'The wounded are already left out: the hospital may bring them back.',
    },
    woundedShort: '{count} wounded',
  },
  troop: {
    egyptians: {
      anhurGuard: 'Anhur Guard',
      ashWarden: 'Ash Warden',
      khopeshWarrior: 'Khopesh Warrior',
      nomarch: 'Nomarch',
      ram: 'Ram',
      reshephChariot: 'Resheph Chariot',
      settler: 'Settler',
      slaveMilitia: 'Slave Militia',
      sopduExplorer: 'Sopdu Explorer',
      stoneCatapult: 'Stone Catapult',
    },
    gauls: {
      chieftain: 'Chieftain',
      druidrider: 'Druidrider',
      haeduan: 'Haeduan',
      pathfinder: 'Pathfinder',
      phalanx: 'Phalanx',
      ram: 'Ram',
      settler: 'Settler',
      swordsman: 'Swordsman',
      theutatesThunder: 'Theutates Thunder',
      trebuchet: 'Trebuchet',
    },
    huns: {
      bowman: 'Bowman',
      catapult: 'Catapult',
      logades: 'Logades',
      marauder: 'Marauder',
      marksman: 'Marksman',
      mercenary: 'Mercenary',
      ram: 'Ram',
      settler: 'Settler',
      spotter: 'Spotter',
      steppeRider: 'Steppe Rider',
    },
    romans: {
      equitesCaesaris: 'Equites Caesaris',
      equitesImperatoris: 'Equites Imperatoris',
      equitesLegati: 'Equites Legati',
      fireCatapult: 'Fire Catapult',
      imperian: 'Imperian',
      legionnaire: 'Legionnaire',
      praetorian: 'Praetorian',
      ram: 'Ram',
      senator: 'Senator',
      settler: 'Settler',
    },
    spartans: {
      catapult: 'Catapult',
      corinthianCrusher: 'Corinthian Crusher',
      elpidaRider: 'Elpida Rider',
      ephor: 'Ephor',
      hoplite: 'Hoplite',
      ram: 'Ram',
      sentinel: 'Sentinel',
      settler: 'Settler',
      shieldsman: 'Shieldsman',
      twinsteelTherion: 'Twinsteel Therion',
    },
    teutons: {
      axeman: 'Axeman',
      catapult: 'Catapult',
      chief: 'Chief',
      clubswinger: 'Clubswinger',
      paladin: 'Paladin',
      ram: 'Ram',
      scout: 'Scout',
      settler: 'Settler',
      spearman: 'Spearman',
      teutonicKnight: 'Teutonic Knight',
    },
    vikings: {
      berserker: 'Berserker',
      catapult: 'Catapult',
      heimdallsEye: "Heimdall's Eye",
      huskarlRider: 'Huskarl Rider',
      jarl: 'Jarl',
      ram: 'Ram',
      settler: 'Settler',
      shieldMaiden: 'Shield Maiden',
      thrall: 'Thrall',
      valkyriesBlessing: "Valkyrie's Blessing",
    },
  },
  validation: {
    email: 'Enter a valid email address.',
    minLength: 'Use at least {n} characters.',
    password: {
      lowercase: 'One lowercase letter',
      match: 'Passwords match',
      minLength: 'At least 8 characters',
      number: 'One number',
      uppercase: 'One uppercase letter',
    },
    required: 'This field is required.',
  },
}
